// Generated from the client-provided Comprehensive Movement Disorders Panel gene table.
const comprehensiveMovementDisordersGeneTable = [
  {
    "gene": "AAAS",
    "phenotype": "Achalasia-addisonianism-alacrimia syndrome [MIM: 231550]",
    "omimEntry": "605378",
    "inheritance": "AR"
  },
  {
    "gene": "AARS1",
    "phenotype": "Leukoencephalopathy, hereditary diffuse, with spheroids 2 [MIM:619661]; Charcot-Marie-Tooth disease, axonal, type 2N [MIM: 613287]; Developmental and epileptic encephalopathy 29 [MIM: 616339]; Trichothiodystrophy 8, nonphotosensitive [MIM: 619691]",
    "omimEntry": "601065",
    "inheritance": "AD, AR"
  },
  {
    "gene": "AARS2",
    "phenotype": "Combined oxidative phosphorylation deficiency 8 [MIM: 614096]; Leukoencephalopathy, progressive, with ovarian failure [MIM: 615889]",
    "omimEntry": "612035",
    "inheritance": "AR"
  },
  {
    "gene": "AASS",
    "phenotype": "Hyperlysinemia",
    "omimEntry": "605113",
    "inheritance": "AR"
  },
  {
    "gene": "ABCA1",
    "phenotype": "HDL deficiency, familial, 1 [MIM: 604091]; Tangier disease [MIM: 205400]",
    "omimEntry": "600046",
    "inheritance": "AR"
  },
  {
    "gene": "ABCA2",
    "phenotype": "Intellectual developmental disorder with poor growth and with or without seizures or ataxia [MIM: 618808]",
    "omimEntry": "600047",
    "inheritance": "AR"
  },
  {
    "gene": "ABCA7",
    "phenotype": "{Alzheimer disease 9, susceptibility to} [MIM: 608907]",
    "omimEntry": "605414",
    "inheritance": "AD"
  },
  {
    "gene": "ABCB7",
    "phenotype": "Anemia, sideroblastic, with ataxia [MIM: 301310]",
    "omimEntry": "300135",
    "inheritance": "XL"
  },
  {
    "gene": "ABCC8",
    "phenotype": "Diabetes mellitus, noninsulin-dependent\t[MIM:125853]; Diabetes mellitus, permanent neonatal 3 [MIM: 618857]; Diabetes mellitus, transient neonatal 2 [MIM: 610374]; Hyperinsulinemic hypoglycemia, familial, 1 [MIM: 256450]; Hypoglycemia of infancy, leucine-sensitive [MIM: 240800]; Maturity-onset diabetes of the young, type 12 [MIM: 621196]",
    "omimEntry": "600509",
    "inheritance": "AD, AR"
  },
  {
    "gene": "ABCD1",
    "phenotype": "Adrenoleukodystrophy [MIM: 300100]; Adrenoleukodystrophy, adult [MIM: 300100]",
    "omimEntry": "300371",
    "inheritance": "XLR"
  },
  {
    "gene": "ABCD3",
    "phenotype": "Bile acid synthesis defect, congenital, 5 [MIM: 616278]",
    "omimEntry": "170995",
    "inheritance": "AR"
  },
  {
    "gene": "ABHD12",
    "phenotype": "Polyneuropathy, hearing loss, ataxia, retinitis pigmentosa, and cataract [MIM: 612674]",
    "omimEntry": "613599",
    "inheritance": "AR"
  },
  {
    "gene": "ABHD5",
    "phenotype": "Chanarin-Dorfman syndrome [MIM: 275630]",
    "omimEntry": "604780",
    "inheritance": "AR"
  },
  {
    "gene": "ACAD9",
    "phenotype": "Mitochondrial complex I deficiency, nuclear type 20 [MIM: 61126]",
    "omimEntry": "611103",
    "inheritance": "AR"
  },
  {
    "gene": "ACADM",
    "phenotype": "Acyl-CoA dehydrogenase, medium chain, deficiency of [MIM: 201450]",
    "omimEntry": "607008",
    "inheritance": "AR"
  },
  {
    "gene": "ACADS",
    "phenotype": "Acyl-CoA dehydrogenase, short-chain, deficiency of [MIM: 201470]",
    "omimEntry": "606885",
    "inheritance": "AR"
  },
  {
    "gene": "ACADVL",
    "phenotype": "VLCAD deficiency [MIM: 201475]",
    "omimEntry": "609575",
    "inheritance": "AR"
  },
  {
    "gene": "ACAT2",
    "phenotype": "ACAT2 deficiency [MIM: 614055]",
    "omimEntry": "100678",
    "inheritance": "IC"
  },
  {
    "gene": "ACBD5",
    "phenotype": "Retinal dystrophy with leukodystrophy [MIM: 618863]",
    "omimEntry": "616618",
    "inheritance": "AR"
  },
  {
    "gene": "ACO2",
    "phenotype": "Infantile cerebellar-retinal degeneration [MIM: 614559]; Optic atrophy 9 [MIM: 616289]",
    "omimEntry": "100850",
    "inheritance": "AD, AR"
  },
  {
    "gene": "ACOX1",
    "phenotype": "Mitchell syndrome [MIM: 618960]; Peroxisomal acyl-CoA oxidase deficiency [MIM: 264470]",
    "omimEntry": "609751",
    "inheritance": "AD, AR"
  },
  {
    "gene": "ACOX2",
    "phenotype": "Bile acid synthesis defect, congenital, 6 [MIM:617308]",
    "omimEntry": "601641",
    "inheritance": "AR"
  },
  {
    "gene": "ACP5",
    "phenotype": "Spondyloenchondrodysplasia with immune dysregulation [MIM: 607944]",
    "omimEntry": "171640",
    "inheritance": "AR"
  },
  {
    "gene": "ACTA1",
    "phenotype": "Myopathy, scapulohumeroperoneal [MIM: 616582]; Congenital myopathy 2A, typical, autosomal dominant [MIM: 161800]; Congenital myopathy 2B, severe infantile, autosomal recessive [MIM: 620265]; Congenital myopathy 2C, severe infantile, autosomal dominant [MIM: 620278]",
    "omimEntry": "102610",
    "inheritance": "AD, AR"
  },
  {
    "gene": "ACTB",
    "phenotype": "Baraitser-Winter syndrome 1 [MIM: 243310]; Becker nevus, syndromic or isolated, somatic mosaic [MIM: 604919]; Congenital smooth muscle hamartoma with or without hemihypertrophy, somatic mosaic [MIM: 620470];\nDystonia-deafness syndrome 1 [MIM: 607371]; Thrombocytopenia 8, with dysmorphic features and developmental delay [MIM: 620475]",
    "omimEntry": "102630",
    "inheritance": "AD"
  },
  {
    "gene": "ACTL6B",
    "phenotype": "Developmental and epileptic encephalopathy 76 [MIM: 618468]; Intellectual developmental disorder with severe speech and ambulation defects [MIM: 618470]",
    "omimEntry": "612458",
    "inheritance": "AD, AR"
  },
  {
    "gene": "ACTN2",
    "phenotype": "Cardiomyopathy, dilated, 1AA, with or without LVNC [MIM: 612158]; Cardiomyopathy, hypertrophic, 23, with or without LVNC [MIM: 612158]; Congenital myopathy 8 [MIM: 618654]; Myopathy, distal, 6, adult onset [MIM: 618655]",
    "omimEntry": "102573",
    "inheritance": "AD"
  },
  {
    "gene": "ADA2",
    "phenotype": "Sneddon syndrome [MIM: 182410]; Vasculitis, autoinflammation, immunodeficiency, and hematologic defects syndrome [MIM: 615688]",
    "omimEntry": "607575",
    "inheritance": "AR"
  },
  {
    "gene": "ADAMTS13",
    "phenotype": "Thrombotic thrombocytopenic purpura, hereditary [MIM: 274150]",
    "omimEntry": "604134",
    "inheritance": "AR"
  },
  {
    "gene": "ADAR",
    "phenotype": "Aicardi-Goutieres syndrome 6 [MIM: 615010]; Dyschromatosis symmetrica hereditaria [MIM: 127400]",
    "omimEntry": "146920",
    "inheritance": "AD, AR"
  },
  {
    "gene": "ADCY5",
    "phenotype": "Dyskinesia with orofacial involvement, autosomal dominant [MIM: 606703]; Dyskinesia with orofacial involvement, autosomal recessive [MIM: 619647]; Neurodevelopmental disorder with hyperkinetic movements and dyskinesia [MIM: 619651]",
    "omimEntry": "600293",
    "inheritance": "AD, AR"
  },
  {
    "gene": "ADCY6",
    "phenotype": "Lethal congenital contracture syndrome 8 [MIM: 616287]",
    "omimEntry": "600294",
    "inheritance": "AR"
  },
  {
    "gene": "ADD3",
    "phenotype": "Cerebral palsy, spastic quadriplegic, 3 [MIM: 617008]",
    "omimEntry": "601568",
    "inheritance": "AR"
  },
  {
    "gene": "ADGRG1",
    "phenotype": "Cortical dysplasia, complex, with other brain malformations 14A, (bilateral frontoparietal) [MIM: 606854]; Cortical dysplasia, complex, with other brain malformations 14B, (bilateral perisylvian) [MIM: 615752]",
    "omimEntry": "604110",
    "inheritance": "AR"
  },
  {
    "gene": "ADH1C",
    "phenotype": "{Alcohol dependence, protection against} [MIM: 103780]; {Parkinson disease, susceptibility to} [MIM: 168600]",
    "omimEntry": "103730",
    "inheritance": "AD, Mu"
  },
  {
    "gene": "ADPRS",
    "phenotype": "Neurodegeneration, childhood-onset, stress-induced, with variable ataxia and seizures [MIM: 618170]",
    "omimEntry": "610624",
    "inheritance": "AR"
  },
  {
    "gene": "ADSL",
    "phenotype": "Adenylosuccinase deficiency [MIM: 103050]",
    "omimEntry": "608222",
    "inheritance": "AR"
  },
  {
    "gene": "ADSS1",
    "phenotype": "Myopathy, distal, 5 [MIM: 617030]",
    "omimEntry": "612498",
    "inheritance": "AR"
  },
  {
    "gene": "AFG3L2",
    "phenotype": "Optic atrophy 12 [MIM: 618977]; Spastic ataxia 5, autosomal recessive [MIM: 614487]; Spinocerebellar ataxia 28 [MIM: 610246]",
    "omimEntry": "604581",
    "inheritance": "AD, AR"
  },
  {
    "gene": "AGA",
    "phenotype": "Aspartylglucosaminuria [MIM: 208400]",
    "omimEntry": "613228",
    "inheritance": "AR"
  },
  {
    "gene": "AGK",
    "phenotype": "Cataract 38, autosomal recessive [MIM: 614691]; Sengers syndrome [MIM: 212350]",
    "omimEntry": "610345",
    "inheritance": "AR"
  },
  {
    "gene": "AGL",
    "phenotype": "Glycogen storage disease IIIa [MIM: 232400]; Glycogen storage disease IIIb [MIM: 232400]",
    "omimEntry": "610860",
    "inheritance": "AR"
  },
  {
    "gene": "AGRN",
    "phenotype": "Myasthenic syndrome, congenital, 8, with pre- and postsynaptic defects [MIM: 615120]",
    "omimEntry": "103320",
    "inheritance": "AR"
  },
  {
    "gene": "AGTPBP1",
    "phenotype": "Neurodegeneration, childhood-onset, with cerebellar atrophy [MIM: 618276]",
    "omimEntry": "606830",
    "inheritance": "AR"
  },
  {
    "gene": "AHCY",
    "phenotype": "Hypermethioninemia with deficiency of S-adenosylhomocysteine hydrolase [MIM: 613752]",
    "omimEntry": "180960",
    "inheritance": "AR"
  },
  {
    "gene": "AHI1",
    "phenotype": "Joubert syndrome 3 [MIM: 608629]",
    "omimEntry": "608894",
    "inheritance": "AR"
  },
  {
    "gene": "AIFM1",
    "phenotype": "Combined oxidative phosphorylation deficiency 6 [MIM: 300816]; Cowchock syndrome [MIM: 310490]; Deafness, X-linked 5 [MIM: 300614]; Spondyloepimetaphyseal dysplasia, X-linked, with hypomyelinating leukodystrophy [MIM: 300232]",
    "omimEntry": "300169",
    "inheritance": "XLR"
  },
  {
    "gene": "AIMP1",
    "phenotype": "Leukodystrophy, hypomyelinating, 3 [MIM: 260600]",
    "omimEntry": "603605",
    "inheritance": "AR"
  },
  {
    "gene": "ALAD",
    "phenotype": "{Lead poisoning, susceptibility to} [MIM: 612740]; Porphyria, acute hepatic [MIM: 612470]",
    "omimEntry": "125270",
    "inheritance": "AR"
  },
  {
    "gene": "ALDH18A1",
    "phenotype": "Cutis laxa, autosomal dominant 3 [MIM: 616603]; Cutis laxa, autosomal recessive, type IIIA [MIM: 219150]; \nSpastic paraplegia 9A, autosomal dominant [MIM: 601162]; Spastic paraplegia 9B, autosomal recessive [MIM: 616586]",
    "omimEntry": "138250",
    "inheritance": "AD, AR"
  },
  {
    "gene": "ALDH3A2",
    "phenotype": "Sjogren-Larsson syndrome [MIM: 270200]",
    "omimEntry": "609523",
    "inheritance": "AR"
  },
  {
    "gene": "ALDH5A1",
    "phenotype": "Succinic semialdehyde dehydrogenase deficiency [MIM: 271980]",
    "omimEntry": "610045",
    "inheritance": "AR"
  },
  {
    "gene": "ALDH6A1",
    "phenotype": "Methylmalonate semialdehyde dehydrogenase deficiency [MIM: 614105]",
    "omimEntry": "603178",
    "inheritance": "AR"
  },
  {
    "gene": "ALG14",
    "phenotype": "Myasthenic syndrome, congenital, 15, without tubular aggregates [MIM: 616227]; Intellectual developmental disorder with epilepsy, behavioral abnormalities, and coarse facies [MIM: 619031]; Myopathy, epilepsy, and progressive cerebral atrophy [MIM: 619036]",
    "omimEntry": "612866",
    "inheritance": "AR"
  },
  {
    "gene": "ALG2",
    "phenotype": "Congenital disorder of glycosylation, type Ii [MIM: 607906]; Myasthenic syndrome, congenital, 14, with tubular aggregates [MIM: 616228]",
    "omimEntry": "607905",
    "inheritance": "AR"
  },
  {
    "gene": "ALG6",
    "phenotype": "Congenital disorder of glycosylation, type Ic [MIM: 603147]",
    "omimEntry": "604566",
    "inheritance": "AR"
  },
  {
    "gene": "ALS2",
    "phenotype": "Amyotrophic lateral sclerosis 2, juvenile [MIM: 205100]",
    "omimEntry": "205100",
    "inheritance": "AR"
  },
  {
    "gene": "AMACR",
    "phenotype": "Alpha-methylacyl-CoA racemase deficiency [MIM: 614307]; Bile acid synthesis defect, congenital, 4 [MIM: 214950]",
    "omimEntry": "604489",
    "inheritance": "AR"
  },
  {
    "gene": "AMPD2",
    "phenotype": "pastic paraplegia 63, autosomal recessive [MIM: 615686]; Pontocerebellar hypoplasia, type 9 [MIM: 615809]",
    "omimEntry": "102771",
    "inheritance": "AR"
  },
  {
    "gene": "ANG",
    "phenotype": "Amyotrophic lateral sclerosis 9 [MIM: 611895]",
    "omimEntry": "105850",
    "inheritance": ""
  },
  {
    "gene": "ANK3",
    "phenotype": "Intellectual developmental disorder, autosomal recessive 37 [MIM: 615493]",
    "omimEntry": "600465",
    "inheritance": "AR"
  },
  {
    "gene": "ANKLE2",
    "phenotype": "Microcephaly 16, primary, autosomal recessive [MIM: 616681]",
    "omimEntry": "616062",
    "inheritance": "AR"
  },
  {
    "gene": "ANO10",
    "phenotype": "Spinocerebellar ataxia, autosomal recessive 10 [MIM: 613728]",
    "omimEntry": "613726",
    "inheritance": "AR"
  },
  {
    "gene": "ANO3",
    "phenotype": "Dystonia 24 [MIM: 615034]",
    "omimEntry": "610110",
    "inheritance": "AD"
  },
  {
    "gene": "ANO5",
    "phenotype": "Gnathodiaphyseal dysplasia [MIM: 166260]; Miyoshi muscular dystrophy 3 [MIM: 613319]; Muscular dystrophy, limb-girdle, autosomal recessive 12 [MIM: 611307]",
    "omimEntry": "608662",
    "inheritance": "AD, AR"
  },
  {
    "gene": "ANOS1",
    "phenotype": "Hypogonadotropic hypogonadism 1 with or without anosmia (Kallmann syndrome 1) [MIM: 308700]",
    "omimEntry": "300836",
    "inheritance": "XLR"
  },
  {
    "gene": "AP1S2",
    "phenotype": "Pettigrew syndrome [MIM: 304340]",
    "omimEntry": "300629",
    "inheritance": "XLR"
  },
  {
    "gene": "AP3B2",
    "phenotype": "Developmental and epileptic encephalopathy 48 [MIM: 617276]",
    "omimEntry": "602166",
    "inheritance": "AR"
  },
  {
    "gene": "AP3D1",
    "phenotype": "Hermansky-Pudlak syndrome 10 [MIM: 617050]",
    "omimEntry": "607246",
    "inheritance": "AR"
  },
  {
    "gene": "AP4B1",
    "phenotype": "Spastic paraplegia 47, autosomal recessive [MIM: 614066]",
    "omimEntry": "607245",
    "inheritance": "AR"
  },
  {
    "gene": "AP4E1",
    "phenotype": "Spastic paraplegia 51, autosomal recessive [MIM: 613744]; Stuttering, familial persistent, 1 [MIM: 184450]",
    "omimEntry": "607244",
    "inheritance": "AD, AR"
  },
  {
    "gene": "AP4M1",
    "phenotype": "Spastic paraplegia 50, autosomal recessive [MIM: 612936]",
    "omimEntry": "602296",
    "inheritance": "AR"
  },
  {
    "gene": "AP4S1",
    "phenotype": "Spastic paraplegia 52, autosomal recessive [MIM: 614067]",
    "omimEntry": "607243",
    "inheritance": "AR"
  },
  {
    "gene": "AP5Z1",
    "phenotype": "Spastic paraplegia 48, autosomal recessive [MIM: 613647]",
    "omimEntry": "613653",
    "inheritance": "AR"
  },
  {
    "gene": "APOB",
    "phenotype": "Hypercholesterolemia, familial, 2 [MIM: 144010]; Hypobetalipoproteinemia [MIM: 615558]",
    "omimEntry": "107730",
    "inheritance": "AD, AR"
  },
  {
    "gene": "APP",
    "phenotype": "Alzheimer disease 1, familial [MIM: 104300]; Cerebral amyloid angiopathy, Dutch, Italian, Iowa, Flemish, Arctic variants [MIM: 605714]",
    "omimEntry": "104760",
    "inheritance": "AD"
  },
  {
    "gene": "APTX",
    "phenotype": "Ataxia, early-onset, with oculomotor apraxia and hypoalbuminemia [MIM: 208920]",
    "omimEntry": "606350",
    "inheritance": "AR"
  },
  {
    "gene": "AR",
    "phenotype": "{Prostate cancer, susceptibility to} [MIM: 301120]; Androgen insensitivity [MIM: 300068]; Androgen insensitivity, partial, with or without breast cancer [MIM: 312300]; Hypospadias 1, X-linked [MIM: 300633]; Spinal and bulbar muscular atrophy, X-linked 1 [MIM: 313200]",
    "omimEntry": "313700",
    "inheritance": "XL, XLR"
  },
  {
    "gene": "ARCN1",
    "phenotype": "Short stature-micrognathia syndrome [MIM: 617164]",
    "omimEntry": "600820",
    "inheritance": "AD"
  },
  {
    "gene": "ARFGEF2",
    "phenotype": "Periventricular heterotopia with microcephaly [MIM: 608097]",
    "omimEntry": "605371",
    "inheritance": "AR"
  },
  {
    "gene": "ARG1",
    "phenotype": "Argininemia [MIM: 207800]",
    "omimEntry": "608313",
    "inheritance": "AR"
  },
  {
    "gene": "ARL13B",
    "phenotype": "Joubert syndrome 8 [MIM: 612291]",
    "omimEntry": "608922",
    "inheritance": "AR"
  },
  {
    "gene": "ARL6",
    "phenotype": "{Bardet-Biedl syndrome 1, modifier of} [MIM: 209900]; Bardet-Biedl syndrome 3 [MIM: 600151]; Retinitis pigmentosa 55 [MIM: 613575]",
    "omimEntry": "608845",
    "inheritance": "AD, AR, DR"
  },
  {
    "gene": "ARL6IP1",
    "phenotype": "Spastic paraplegia 61, autosomal recessive [MIM: 615685]",
    "omimEntry": "607669",
    "inheritance": "AR"
  },
  {
    "gene": "ARMC9",
    "phenotype": "Joubert syndrome 30 [MIM: 617622]",
    "omimEntry": "617612",
    "inheritance": "AR"
  },
  {
    "gene": "ARNT2",
    "phenotype": "Webb-Dattani syndrome [MIM: 615926]",
    "omimEntry": "606036",
    "inheritance": "AR"
  },
  {
    "gene": "ARSA",
    "phenotype": "Metachromatic leukodystrophy [MIM: 250100]",
    "omimEntry": "607574",
    "inheritance": "AR"
  },
  {
    "gene": "ARV1",
    "phenotype": "Developmental and epileptic encephalopathy 38 [MIM: 617020]",
    "omimEntry": "611647",
    "inheritance": "AR"
  },
  {
    "gene": "ARX",
    "phenotype": "Developmental and epileptic encephalopathy 1 [MIM: 308350]; Hydranencephaly with abnormal genitalia [MIM:  300215]; Intellectual developmental disorder, X-linked 29 [MIM: 300419]; Lissencephaly, X-linked 2 [MIM:  300215]; Partington syndrome [MIM: 309510]; Proud syndrome [MIM: 300004]",
    "omimEntry": "300382",
    "inheritance": "XL, XLR"
  },
  {
    "gene": "ASAH1",
    "phenotype": "Farber lipogranulomatosis [MIM: 228000]; Spinal muscular atrophy with progressive myoclonic epilepsy [MIM: 159950]",
    "omimEntry": "613468",
    "inheritance": "AR"
  },
  {
    "gene": "ASCC1",
    "phenotype": "Barrett esophagus/esophageal adenocarcinoma [MIM: 614266]; Spinal muscular atrophy with congenital bone fractures 2 [MIM: 616867]",
    "omimEntry": "614215",
    "inheritance": "AR"
  },
  {
    "gene": "ASCC3",
    "phenotype": "Intellectual developmental disorder, autosomal recessive 81 [MIM: 620700]",
    "omimEntry": "614217",
    "inheritance": "AR"
  },
  {
    "gene": "ASL",
    "phenotype": "Argininosuccinic aciduria [MIM: 207900]",
    "omimEntry": "608310",
    "inheritance": "AR"
  },
  {
    "gene": "ASNS",
    "phenotype": "Asparagine synthetase deficiency [MIM: 615574]",
    "omimEntry": "108370",
    "inheritance": "AR"
  },
  {
    "gene": "ASS1",
    "phenotype": "Citrullinemia [MIM: 215700]",
    "omimEntry": "603470",
    "inheritance": "AR"
  },
  {
    "gene": "ATCAY",
    "phenotype": "Ataxia, cerebellar, Cayman type [MIM: 601238]",
    "omimEntry": "608179",
    "inheritance": "AR"
  },
  {
    "gene": "ATG5",
    "phenotype": "Spinocerebellar ataxia, autosomal recessive 25 [MIM: 617584]",
    "omimEntry": "604261",
    "inheritance": "AR"
  },
  {
    "gene": "ATL1",
    "phenotype": "Neuropathy, hereditary sensory, type ID [MIM: 613708]; Spastic paraplegia 3A, autosomal dominant [MIM: 182600]",
    "omimEntry": "606439",
    "inheritance": "AD"
  },
  {
    "gene": "ATM",
    "phenotype": "{Breast cancer, susceptibility to} [MIM: 114480]; Ataxia-telangiectasia\t[MIM: 208900]; Lymphoma, B-cell non-Hodgkin, somatic; Lymphoma, mantle cell, somatic; T-cell prolymphocytic leukemia, somatic",
    "omimEntry": "607585",
    "inheritance": "AD, AR, Smu"
  },
  {
    "gene": "ATN1",
    "phenotype": "Congenital hypotonia, epilepsy, developmental delay, and digital anomalies [618494]; Dentatorubral-pallidoluysian atrophy [MIM: 125370]",
    "omimEntry": "607462",
    "inheritance": "AD"
  },
  {
    "gene": "ATP13A2",
    "phenotype": "Kufor-Rakeb syndrome [MIM: 606693]; Spastic paraplegia 78, autosomal recessive [MIM: 617225]",
    "omimEntry": "610513",
    "inheritance": "AR"
  },
  {
    "gene": "ATP1A2",
    "phenotype": "Alternating hemiplegia of childhood 1 [MIM: 104290]; Developmental and epileptic encephalopathy 98 [MIM: 619605]; Fetal akinesia, respiratory insufficiency, microcephaly, polymicrogyria, and dysmorphic facies [MIM: 619602]; Migraine, familial basilar [MIM: 602481]; Migraine, familial hemiplegic, 2 [MIM: 602481]",
    "omimEntry": "182340",
    "inheritance": "AD, AR"
  },
  {
    "gene": "ATP1A3",
    "phenotype": "Alternating hemiplegia of childhood 2 [MIM: 614820]; CAPOS syndrome [MIM: 601338]; Developmental and epileptic encephalopathy 99 [MIM: 619606]; Dystonia-12 [MIM: 128235]",
    "omimEntry": "182350",
    "inheritance": "AD"
  },
  {
    "gene": "ATP2A1",
    "phenotype": "Brody myopathy [MIM: 601003]",
    "omimEntry": "108730",
    "inheritance": "AR"
  },
  {
    "gene": "ATP2B3",
    "phenotype": "Spinocerebellar ataxia, X-linked 1 [MIM: 302500]",
    "omimEntry": "300014",
    "inheritance": "XLR"
  },
  {
    "gene": "ATP5F1E",
    "phenotype": "Mitochondrial complex V (ATP synthase) deficiency, nuclear type 3 [MIM: 614053]",
    "omimEntry": "606153",
    "inheritance": "AR"
  },
  {
    "gene": "ATP6AP2",
    "phenotype": "Parkinsonism with spasticity, X-linked [MIM: 300911]; Congenital disorder of glycosylation, type IIr [MIM: 301045]; Intellectual developmental disorder, X-linked syndromic, Hedera type [MIM: 300423]",
    "omimEntry": "300556",
    "inheritance": "XLR"
  },
  {
    "gene": "ATP7A",
    "phenotype": "Menkes disease [MIM: 309400]; Neuronopathy, distal hereditary motor, X-linked [MIM: 300489]; Occipital horn syndrome [MIM: 304150]",
    "omimEntry": "300011",
    "inheritance": "XLR"
  },
  {
    "gene": "ATP7B",
    "phenotype": "Wilson disease [MIM: 277900]",
    "omimEntry": "606882",
    "inheritance": "AR"
  },
  {
    "gene": "ATP8A2",
    "phenotype": "Cerebellar ataxia, impaired intellectual development, and dysequilibrium syndrome 4 [MIM: 615268]",
    "omimEntry": "605870",
    "inheritance": "AR"
  },
  {
    "gene": "ATPAF2",
    "phenotype": "Mitochondrial complex V (ATP synthase) deficiency, nuclear type 1 [MIM: 604273]",
    "omimEntry": "608918",
    "inheritance": "AR"
  },
  {
    "gene": "ATRX",
    "phenotype": "Alpha-thalassemia myelodysplasia syndrome, somatic [MIM: 300448]; Alpha-thalassemia/impaired intellectual development syndrome [MIM: 301040]; Intellectual disability-hypotonic facies syndrome, X-linked [MIM: 309580]",
    "omimEntry": "300032",
    "inheritance": "XLD, XLR"
  },
  {
    "gene": "ATXN1",
    "phenotype": "Spinocerebellar ataxia 1 [MIM: 164400]",
    "omimEntry": "601556",
    "inheritance": "AD"
  },
  {
    "gene": "ATXN10",
    "phenotype": "Spinocerebellar ataxia 10 [MIM: 603516]",
    "omimEntry": "611150",
    "inheritance": "AD"
  },
  {
    "gene": "ATXN2",
    "phenotype": "Spinocerebellar ataxia 2 [MIM: 183090]; {Amyotrophic lateral sclerosis susceptibility to 13} [MIM: 183090]; {Parkinson disease late-onset susceptibility to} [MIM: 168600]",
    "omimEntry": "601517",
    "inheritance": "AD, Multifactorial"
  },
  {
    "gene": "ATXN3",
    "phenotype": "Machado-Joseph disease [MIM: 109150]; {Parkinson disease late-onset susceptibility to} [MIM: 168600]",
    "omimEntry": "607047",
    "inheritance": "AD, Multifactorial"
  },
  {
    "gene": "ATXN7",
    "phenotype": "Spinocerebellar ataxia 7 [MIM: 164500]",
    "omimEntry": "607640",
    "inheritance": "AD"
  },
  {
    "gene": "ATXN8/ATXN8OS",
    "phenotype": "Spinocerebellar ataxia 8 [MIM: 608768]; {Parkinson disease susceptibility to} [MIM: 168600]",
    "omimEntry": "613289; 603680",
    "inheritance": "AD, Multifactorial"
  },
  {
    "gene": "AUH",
    "phenotype": "3-methylglutaconic aciduria, type I [MIM: 250950]",
    "omimEntry": "600529",
    "inheritance": "AR"
  },
  {
    "gene": "B3GALNT2",
    "phenotype": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 11 [MIM; 615181]",
    "omimEntry": "610194",
    "inheritance": "AR"
  },
  {
    "gene": "B3GALT6",
    "phenotype": "l-Gazali syndrome [MIM: 609465]; Ehlers-Danlos syndrome, spondylodysplastic type, 2 [MIM: 615349]; Spondyloepimetaphyseal dysplasia with joint laxity, type 1, with or without fractures [MIM: 271640]",
    "omimEntry": "615291",
    "inheritance": "AR"
  },
  {
    "gene": "B4GALNT1",
    "phenotype": "Spastic paraplegia 26, autosomal recessive [MIM: 609195]",
    "omimEntry": "601873",
    "inheritance": "AR"
  },
  {
    "gene": "B4GAT1",
    "phenotype": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 13 [MIM: 615287]",
    "omimEntry": "605517",
    "inheritance": "AR"
  },
  {
    "gene": "B9D1",
    "phenotype": "Meckel syndrome 9 [MIM: 614209]; Joubert syndrome 27 [MIM: 617120]",
    "omimEntry": "614144",
    "inheritance": "AR"
  },
  {
    "gene": "BAG3",
    "phenotype": "Neuronopathy, distal hereditary motor, autosomal dominant 15 [MIM: 621094]; Cardiomyopathy, dilated, 1HH [MIM: 613381]; Charcot-Marie-Tooth disease, axonal, type 2JJ [MIM; 621095]; Myopathy, myofibrillar, 6 [MIM: 612954]",
    "omimEntry": "603883",
    "inheritance": "AD"
  },
  {
    "gene": "BBS1",
    "phenotype": "Bardet-Biedl syndrome 1 [MIM: 209900]",
    "omimEntry": "209901",
    "inheritance": "AD, AR"
  },
  {
    "gene": "BBS10",
    "phenotype": "Bardet-Biedl syndrome 10 [MIM: 615987]",
    "omimEntry": "610148",
    "inheritance": "AR"
  },
  {
    "gene": "BBS12",
    "phenotype": "Bardet-Biedl syndrome 12 [MIM: 615989]",
    "omimEntry": "610683",
    "inheritance": "AR"
  },
  {
    "gene": "BBS2",
    "phenotype": "Bardet-Biedl syndrome 2 [MIM: 615981]; Retinitis pigmentosa 74 [MIM: 616562]",
    "omimEntry": "606151",
    "inheritance": "AR"
  },
  {
    "gene": "BBS4",
    "phenotype": "Bardet-Biedl syndrome 4 [MIM: 615982]",
    "omimEntry": "600374",
    "inheritance": "AR"
  },
  {
    "gene": "BBS5",
    "phenotype": "Bardet-Biedl syndrome 5 [MIM: 615983]",
    "omimEntry": "603650",
    "inheritance": "AR"
  },
  {
    "gene": "BBS7",
    "phenotype": "Bardet-Biedl syndrome 7 [MIM: 615984]",
    "omimEntry": "607590",
    "inheritance": "AR"
  },
  {
    "gene": "BBS9",
    "phenotype": "Bardet-Biedl syndrome 9 [MIM: 615986]",
    "omimEntry": "615986",
    "inheritance": "AR"
  },
  {
    "gene": "BCAP31",
    "phenotype": "Deafness, dystonia, and cerebral hypomyelination [MIM: 300475]",
    "omimEntry": "300398",
    "inheritance": "XLR"
  },
  {
    "gene": "BCKDHA",
    "phenotype": "Maple syrup urine disease, type Ia [MIM: 248600]",
    "omimEntry": "608348",
    "inheritance": "AR"
  },
  {
    "gene": "BCKDHB",
    "phenotype": "Maple syrup urine disease, type Ib [MIM: 620698]",
    "omimEntry": "248611",
    "inheritance": "AR"
  },
  {
    "gene": "BCL11B",
    "phenotype": "Immunodeficiency 49, severe combined [MIM: 617237]; Intellectual developmental disorder with dysmorphic facies, speech delay, and T-cell abnormalities [MIM: 618092]",
    "omimEntry": "606558",
    "inheritance": "AD"
  },
  {
    "gene": "BCOR",
    "phenotype": "Microphthalmia, syndromic 2 [MIM: 300166]",
    "omimEntry": "300485",
    "inheritance": "XLD"
  },
  {
    "gene": "BCS1L",
    "phenotype": "Bjornstad syndrome [MIM: 262000]; GRACILE syndrome [MIM: 603358]; Mitochondrial complex III deficiency, nuclear type 1 [MIM: 124000]",
    "omimEntry": "603647",
    "inheritance": "AR"
  },
  {
    "gene": "BEAN1",
    "phenotype": "Spinocerebellar ataxia 31 [MIM: 117210]",
    "omimEntry": "612051",
    "inheritance": "AD"
  },
  {
    "gene": "BICD2",
    "phenotype": "Spinal muscular atrophy, lower extremity-predominant, 2A, autosomal dominant [MIM: 615290]; Spinal muscular atrophy, lower extremity-predominant, 2B, autosomal dominant [MIM: 618291]",
    "omimEntry": "609797",
    "inheritance": "AD"
  },
  {
    "gene": "BIN1",
    "phenotype": "Centronuclear myopathy 2 [MIM: 255200]",
    "omimEntry": "601248",
    "inheritance": "AR"
  },
  {
    "gene": "BOLA3",
    "phenotype": "Multiple mitochondrial dysfunctions syndrome 2 with hyperglycinemia [MIM: 614299]",
    "omimEntry": "613183",
    "inheritance": "AR"
  },
  {
    "gene": "BRAT1",
    "phenotype": "Neurodevelopmental disorder with cerebellar atrophy and with or without seizures [MIM: 618056]; Rigidity and multifocal seizure syndrome, lethal neonatal [MIM: 614498]",
    "omimEntry": "614506",
    "inheritance": "AR"
  },
  {
    "gene": "BSCL2",
    "phenotype": "Encephalopathy, progressive, with or without lipodystrophy [MIM: 615942]; Lipodystrophy, congenital generalized, type 2 [MIM: 269700]; Neuronopathy, distal hereditary motor, autosomal dominant 13 [MIM: 619122]; Silver spastic paraplegia syndrome [MIM: 270685]",
    "omimEntry": "606158",
    "inheritance": "AD, AR"
  },
  {
    "gene": "BTD",
    "phenotype": "Biotinidase deficiency [MIM: 253260]",
    "omimEntry": "609019",
    "inheritance": "AR"
  },
  {
    "gene": "C19orf12",
    "phenotype": "Spastic paraplegia 43, autosomal recessive [MIM: 615043]; Neurodegeneration with brain iron accumulation 4 [MIM: 614298]",
    "omimEntry": "614297",
    "inheritance": "AD, AR"
  },
  {
    "gene": "C1QBP",
    "phenotype": "Combined oxidative phosphorylation deficiency 33 [MIM: 617773]",
    "omimEntry": "601269",
    "inheritance": "AR"
  },
  {
    "gene": "C9orf72",
    "phenotype": "Frontotemporal dementia and/or amyotrophic lateral sclerosis 1 [MIM: 105550]",
    "omimEntry": "614260",
    "inheritance": "AD"
  },
  {
    "gene": "CA8",
    "phenotype": "Spinocerebellar ataxia, autosomal recessive 34 [MIM: 613227]",
    "omimEntry": "114815",
    "inheritance": "AR"
  },
  {
    "gene": "CACNA1A",
    "phenotype": "Spinocerebellar ataxia 6 [MIM: 183086]",
    "omimEntry": "601011",
    "inheritance": "AD"
  },
  {
    "gene": "CACNA1B",
    "phenotype": "Neurodevelopmental disorder with seizures and nonepileptic hyperkinetic movements [MIM: 618497]",
    "omimEntry": "601012",
    "inheritance": "AR"
  },
  {
    "gene": "CACNA1D",
    "phenotype": "Primary aldosteronism, seizures, and neurologic abnormalities [MIM: 615474]; Sinoatrial node dysfunction and deafness [MIM: 614896]",
    "omimEntry": "114206",
    "inheritance": "AD, AR"
  },
  {
    "gene": "CACNA1G",
    "phenotype": "Spinocerebellar ataxia 42 [MIM: 616795]; Spinocerebellar ataxia 42, early-onset, severe, with neurodevelopmental deficits [MIM: 618087]",
    "omimEntry": "604065",
    "inheritance": "AD"
  },
  {
    "gene": "CACNA1S",
    "phenotype": "{Malignant hyperthermia susceptibility 5} [MIM: 601887]; {Thyrotoxic periodic paralysis, susceptibility to, 1} [MIM: 188580]; Congenital myopathy 18 due to dihydropyridine receptor defect [MIM: 620246]; Hypokalemic periodic paralysis, type 1 [MIM: 170400]",
    "omimEntry": "114208",
    "inheritance": "AD, AR"
  },
  {
    "gene": "CACNA2D2",
    "phenotype": "Cerebellar atrophy with seizures and variable developmental delay [MIM: 618501]",
    "omimEntry": "607082",
    "inheritance": "AR"
  },
  {
    "gene": "CACNB4",
    "phenotype": "Episodic ataxia, type 5 [MIM: 613855]; {Epilepsy, idiopathic generalized, susceptibility to, 9}  [MIM: 607682]; {Epilepsy, juvenile myoclonic, susceptibility to, 6} [MIM: 607682]",
    "omimEntry": "601949",
    "inheritance": "AD"
  },
  {
    "gene": "CAMTA1",
    "phenotype": "Cerebellar dysfunction with variable cognitive and behavioral abnormalities [MIM: 614756]",
    "omimEntry": "611501",
    "inheritance": "AD"
  },
  {
    "gene": "CAPN1",
    "phenotype": "Spastic paraplegia 76, autosomal recessive [MIM: 616907]",
    "omimEntry": "114220",
    "inheritance": "AR"
  },
  {
    "gene": "CAPN3",
    "phenotype": "Muscular dystrophy, limb-girdle, autosomal dominant 4 [MIM: 618129]; Muscular dystrophy, limb-girdle, autosomal recessive 1 [MIM: 253600]",
    "omimEntry": "114240",
    "inheritance": "AD, AR"
  },
  {
    "gene": "CARS2",
    "phenotype": "Combined oxidative phosphorylation deficiency 27 [MIM: 616672]",
    "omimEntry": "612800",
    "inheritance": "AR"
  },
  {
    "gene": "CASK",
    "phenotype": "FG syndrome 4 [MIM: 300422]; Intellectual developmental disorder and microcephaly with pontine and cerebellar hypoplasia [MIM: 300749]; Intellectual developmental disorder, with or without nystagmus [MIM: 300422]",
    "omimEntry": "300172",
    "inheritance": "XL, XLR"
  },
  {
    "gene": "CASQ1",
    "phenotype": "Myopathy, vacuolar, with CASQ1 aggregates [MIM: 616231]",
    "omimEntry": "114250",
    "inheritance": "AD"
  },
  {
    "gene": "CAV1",
    "phenotype": "Lipodystrophy, congenital generalized, type 3 [MIM: 612526]; Lipodystrophy, familial partial, type 7 [MIM: 606721]; Pulmonary hypertension, primary, 3 [MIM: 615343]",
    "omimEntry": "601047",
    "inheritance": "AD, AR"
  },
  {
    "gene": "CAV3",
    "phenotype": "Cardiomyopathy, familial hypertrophic [MIM: 192600]; Creatine phosphokinase, elevated serum [MIM: 123320]; Long QT syndrome 9 [MIM: 611818]; Myopathy, distal, Tateyama type [MIM: 614321]; Rippling muscle disease 2 [MIM: 606072]",
    "omimEntry": "601253",
    "inheritance": "AD, DD"
  },
  {
    "gene": "CAVIN1",
    "phenotype": "Lipodystrophy, congenital generalized, type 4 [MIM: 613327]",
    "omimEntry": "603198",
    "inheritance": "AR"
  },
  {
    "gene": "CC2D2A",
    "phenotype": "COACH syndrome 2 [MIM: 619111]; Joubert syndrome 9 [MIM: 612285]; Meckel syndrome 6 [MIM: 612284]; Retinitis pigmentosa 93\t[MIM: 619845]",
    "omimEntry": "612013",
    "inheritance": "AR"
  },
  {
    "gene": "CCDC28B",
    "phenotype": "{Bardet-Biedl syndrome 1, modifier of} [MIM: 209900]",
    "omimEntry": "610162",
    "inheritance": "AD, AR"
  },
  {
    "gene": "CCDC78",
    "phenotype": "Centronuclear myopathy 4 [MIM: 614807]",
    "omimEntry": "614666",
    "inheritance": "AD"
  },
  {
    "gene": "CCDC88C",
    "phenotype": "Spinocerebellar ataxia 40 [MIM: 616053]; Hydrocephalus, congenital, 1 [MIM: 236600]",
    "omimEntry": "611204",
    "inheritance": "AD, AR"
  },
  {
    "gene": "CCT5",
    "phenotype": "Neuropathy, hereditary sensory, with spastic paraplegia [MIM: 256840]",
    "omimEntry": "610150",
    "inheritance": "AR"
  },
  {
    "gene": "CDKL5",
    "phenotype": "Developmental and epileptic encephalopathy 2 [MIM: 300672]",
    "omimEntry": "300203",
    "inheritance": "XLD"
  },
  {
    "gene": "CEP104",
    "phenotype": "Intellectual developmental disorder, autosomal recessive 77 [MIM: 619988]; Joubert syndrome 25 [MIM: 616781]",
    "omimEntry": "616690",
    "inheritance": "AR"
  },
  {
    "gene": "CEP120",
    "phenotype": "Joubert syndrome 31 [MIM: 617761]; Short-rib thoracic dysplasia 13 with or without polydactyly [MIM: 616300]",
    "omimEntry": "613446",
    "inheritance": "AR"
  },
  {
    "gene": "CEP152",
    "phenotype": "Microcephaly 9, primary, autosomal recessive [MIM: 614852]; Seckel syndrome 5 [MIM: 613823]",
    "omimEntry": "613529",
    "inheritance": "AR"
  },
  {
    "gene": "CEP290",
    "phenotype": "Bardet-Biedl syndrome 14 [MIM: 615991]; Joubert syndrome 5 [MIM: 610188]; Leber congenital amaurosis 10 [MIM: 611755]; Meckel syndrome 4 [MIM: 611134]; Senior-Loken syndrome 6 \t[MIM: 610189]",
    "omimEntry": "610142",
    "inheritance": "AR"
  },
  {
    "gene": "CEP41",
    "phenotype": "Joubert syndrome 15 [MIM: 614464]",
    "omimEntry": "610523",
    "inheritance": "AR"
  },
  {
    "gene": "CFH",
    "phenotype": "{Hemolytic uremic syndrome, atypical, susceptibility to, 1} [MIM: 235400]; {Macular degeneration, age-related, 4} [MIM: 610698]; Basal laminar drusen \t[MIM: 126700]; Complement factor H deficiency [MIM: 609814]",
    "omimEntry": "134370",
    "inheritance": "AD, AR"
  },
  {
    "gene": "CFL2",
    "phenotype": "Nemaline myopathy 7, autosomal recessive [MIM 610687]",
    "omimEntry": "601443",
    "inheritance": "AR"
  },
  {
    "gene": "CHAMP1",
    "phenotype": "Neurodevelopmental disorder with hypotonia, impaired language, and dysmorphic features [MIM: 616579]",
    "omimEntry": "",
    "inheritance": ""
  },
  {
    "gene": "CHAT",
    "phenotype": "Myasthenic syndrome, congenital, 6, presynaptic [MIM: 254210]",
    "omimEntry": "118490",
    "inheritance": "AR"
  },
  {
    "gene": "CHCHD10",
    "phenotype": "Myopathy, isolated mitochondrial, autosomal dominant [MIM: 616209]; Frontotemporal dementia and/or amyotrophic lateral sclerosis 2 [MIM: 615911]; Spinal muscular atrophy, Jokela type [MIM: 615048]",
    "omimEntry": "615903",
    "inheritance": "AD"
  },
  {
    "gene": "CHKB",
    "phenotype": "Muscular dystrophy, congenital, megaconial type [MIM: 602541]",
    "omimEntry": "612395",
    "inheritance": "AR"
  },
  {
    "gene": "CHMP1A",
    "phenotype": "Pontocerebellar hypoplasia, type 8 [MIM: 614961]",
    "omimEntry": "164010",
    "inheritance": "AR"
  },
  {
    "gene": "CHMP2B",
    "phenotype": "Frontotemporal dementia and/or amyotrophic lateral sclerosis 7 [MIM: 600795]",
    "omimEntry": "609512",
    "inheritance": "AD"
  },
  {
    "gene": "CHP1",
    "phenotype": "Spastic ataxia 9, autosomal recessive [MIM: 618438]",
    "omimEntry": "606988",
    "inheritance": "AR"
  },
  {
    "gene": "CHRNA1",
    "phenotype": "Multiple pterygium syndrome, lethal type [MIM: 253290]; Myasthenic syndrome, congenital, 1A, slow-channel [MIM: 601462]; Myasthenic syndrome, congenital, 1B, fast-channel [MIM: 608930]",
    "omimEntry": "100690",
    "inheritance": "AD, AR"
  },
  {
    "gene": "CHRNB1",
    "phenotype": "Myasthenic syndrome, congenital, 2C, associated with acetylcholine receptor deficiency [MIM: 616314]; Myasthenic syndrome, congenital, 2A, slow-channel [MIM: 616313]",
    "omimEntry": "100710",
    "inheritance": "AD, AR"
  },
  {
    "gene": "CHRND",
    "phenotype": "Myasthenic syndrome, congenital, 3A, slow-channel [MIM: 616321]; Myasthenic syndrome, congenital, 3C, associated with acetylcholine receptor deficiency [MIM: 616323]; Multiple pterygium syndrome, lethal type [MIM: 253290]; Myasthenic syndrome, congenital, 3B, fast-channel [MIM: 616322]",
    "omimEntry": "100720",
    "inheritance": "AD, AR"
  },
  {
    "gene": "CHRNE",
    "phenotype": "Myasthenic syndrome, congenital, 4A, slow-channel [MIM: 605809]; Myasthenic syndrome, congenital, 4B, fast-channel [MIM: 616324]; Myasthenic syndrome, congenital, 4C, associated with acetylcholine receptor deficiency [MIM: 608931]",
    "omimEntry": "100725",
    "inheritance": "AD, AR"
  },
  {
    "gene": "CHRNG",
    "phenotype": "Escobar syndrome [MIM: 265000] Multiple pterygium syndrome, lethal type [MIM: 253290]",
    "omimEntry": "100730",
    "inheritance": "AR"
  },
  {
    "gene": "CHST14",
    "phenotype": "Ehlers-Danlos syndrome, musculocontractural type 1 [MIM: 601776]",
    "omimEntry": "608429",
    "inheritance": "AR"
  },
  {
    "gene": "CIT",
    "phenotype": "Microcephaly 17, primary, autosomal recessive [MIM: 617090]",
    "omimEntry": "605629",
    "inheritance": "AR"
  },
  {
    "gene": "CKAP2L",
    "phenotype": "Filippi syndrome [MIM: 272440]",
    "omimEntry": "616174",
    "inheritance": "AR"
  },
  {
    "gene": "CLCN1",
    "phenotype": "Myotonia congenita, dominant [MIM: 160880]; Myotonia congenita, recessive [MIM: 255700]; Myotonia levior [MIM: 160800]",
    "omimEntry": "118425",
    "inheritance": "AD, AR"
  },
  {
    "gene": "CLCN2",
    "phenotype": "{Epilepsy, idiopathic generalized, susceptibility to, 11} [MIM:\t607628]; {Epilepsy, juvenile absence, susceptibility to, 2} [MIM: 607628]; {Epilepsy, juvenile myoclonic, susceptibility to, 8} [MIM: 607628];  Hyperaldosteronism, familial, type II [MIM: 605635]; Leukoencephalopathy with ataxia [MIM: 615651]",
    "omimEntry": "600570",
    "inheritance": "AD, AR"
  },
  {
    "gene": "CLN3",
    "phenotype": "Ceroid lipofuscinosis, neuronal, 3 [MIM: 204200]",
    "omimEntry": "607042",
    "inheritance": "AR"
  },
  {
    "gene": "CLN5",
    "phenotype": "Ceroid lipofuscinosis, neuronal, 5 [MIM: 256731]",
    "omimEntry": "608102",
    "inheritance": "AR"
  },
  {
    "gene": "CLN6",
    "phenotype": "Ceroid lipofuscinosis, neuronal, 6A [MIM: 601780]; Ceroid lipofuscinosis, neuronal, 6B (Kufs type) [MIM: 204300]",
    "omimEntry": "606725",
    "inheritance": "AR"
  },
  {
    "gene": "CLN8",
    "phenotype": "Ceroid lipofuscinosis, neuronal, 8 [MIM: 600143]; Ceroid lipofuscinosis, neuronal, 8, Northern epilepsy variant [MIM: 610003]",
    "omimEntry": "607837",
    "inheritance": "AR"
  },
  {
    "gene": "CLP1",
    "phenotype": "Pontocerebellar hypoplasia, type 10 [MIM: 615803]",
    "omimEntry": "608757",
    "inheritance": "AR"
  },
  {
    "gene": "CLPB",
    "phenotype": "3-methylglutaconic aciduria, type VIIA, autosomal dominant [MIM: 619835]; 3-methylglutaconic aciduria, type VIIB, autosomal recessive [MIM: 616271]; Neutropenia, severe congenital, 9, autosomal dominant [MIM: 619813]",
    "omimEntry": "616254",
    "inheritance": "AD, AR"
  },
  {
    "gene": "CLPP",
    "phenotype": "Perrault syndrome 3 [MIM: 614129]",
    "omimEntry": "601119",
    "inheritance": "AR"
  },
  {
    "gene": "CLTC",
    "phenotype": "Intellectual developmental disorder, autosomal dominant 56 [MIM: 617854]",
    "omimEntry": "118955",
    "inheritance": "AD"
  },
  {
    "gene": "CNBP",
    "phenotype": "Myotonic dystrophy 2 [MIM: 602668]",
    "omimEntry": "116955",
    "inheritance": "AD"
  },
  {
    "gene": "CNTN1",
    "phenotype": "Congenital myopathy 12 [MIM: 612540]",
    "omimEntry": "600016",
    "inheritance": "AR"
  },
  {
    "gene": "CNTN2",
    "phenotype": "Epilepsy, early-onset, 5, with or without developmental delay [MIM: 615400]",
    "omimEntry": "190197",
    "inheritance": "AR"
  },
  {
    "gene": "CNTNAP1",
    "phenotype": "Hypomyelinating neuropathy, congenital, 3 [MIM: 618186]; Lethal congenital contracture syndrome 7 [MIM: 616286]",
    "omimEntry": "602346",
    "inheritance": "AR"
  },
  {
    "gene": "CNTNAP2",
    "phenotype": "{Autism susceptibility 15} [MIM: 612100]; Pitt-Hopkins like syndrome 1 [MIM: 610042]",
    "omimEntry": "604569",
    "inheritance": "AR"
  },
  {
    "gene": "COA3",
    "phenotype": "Mitochondrial complex IV deficiency, nuclear type 14 [MIM: 619058]",
    "omimEntry": "614775",
    "inheritance": "AR"
  },
  {
    "gene": "COA7",
    "phenotype": "Spinocerebellar ataxia, autosomal recessive, with axonal neuropathy 3 [MIM: 618387]",
    "omimEntry": "615623",
    "inheritance": "AR"
  },
  {
    "gene": "COA8",
    "phenotype": "Mitochondrial complex IV deficiency, nuclear type 17 [MIM: 619061]",
    "omimEntry": "616003",
    "inheritance": "AR"
  },
  {
    "gene": "COASY",
    "phenotype": "Neurodegeneration with brain iron accumulation 6 [MIM: 615643]; Pontocerebellar hypoplasia, type 12 [MIM: 618266]",
    "omimEntry": "609855",
    "inheritance": "AR"
  },
  {
    "gene": "COG2",
    "phenotype": "Congenital disorder of glycosylation, type IIq [MIM: 617395]",
    "omimEntry": "606974",
    "inheritance": "AR"
  },
  {
    "gene": "COG4",
    "phenotype": "Congenital disorder of glycosylation, type Iij [MIM: 613489]; Saul-Wilson syndrome [MIM: 618150]",
    "omimEntry": "606976",
    "inheritance": "AD, AR"
  },
  {
    "gene": "COG5",
    "phenotype": "Congenital disorder of glycosylation, type Iii [MIM: 613612]",
    "omimEntry": "606821",
    "inheritance": "AR"
  },
  {
    "gene": "COL12A1",
    "phenotype": "Ullrich congenital muscular dystrophy 2 [mim: 616470]; Bethlem myopathy 2 [MIM: 616471]",
    "omimEntry": "120320",
    "inheritance": "AD, AR"
  },
  {
    "gene": "COL13A1",
    "phenotype": "Myasthenic syndrome, congenital, 19 [MIM: 616720]",
    "omimEntry": "120350",
    "inheritance": "AR"
  },
  {
    "gene": "COL18A1",
    "phenotype": "Glaucoma, primary closed-angle [MIM: 618880]; Knobloch syndrome, type 1 [MIM: 267750]",
    "omimEntry": "120328",
    "inheritance": "AD. AR"
  },
  {
    "gene": "COL25A1",
    "phenotype": "Fibrosis of extraocular muscles, congenital, 5 [MIM: 616219]",
    "omimEntry": "610004",
    "inheritance": "AR"
  },
  {
    "gene": "COL4A1",
    "phenotype": "Retinal arteries, tortuosity of [MIM: 180000]; {Hemorrhage, intracerebral, susceptibility to} [MIM: 614519]; Angiopathy, hereditary, with nephropathy, aneurysms, and muscle cramps [MIM: 611773]; Brain small vessel disease with or without ocular anomalies\t[MIM: 175780]; Microangiopathy and leukoencephalopathy, pontine, autosomal dominant [MIM: 618564]",
    "omimEntry": "120130",
    "inheritance": "AD"
  },
  {
    "gene": "COL4A2",
    "phenotype": "{Hemorrhage, intracerebral, susceptibility to} [MIM: 614519]; Brain small vessel disease 2A, autosomal dominant [MIM: 614483]; Brain small vessel disease 2B, autosomal recessive [MIM: 621414]",
    "omimEntry": "120090",
    "inheritance": "AD, AR"
  },
  {
    "gene": "COL6A1",
    "phenotype": "Bethlem myopathy 1A [MIM: 158810]; Ullrich congenital muscular dystrophy 1A [MIM: 254090]",
    "omimEntry": "120220",
    "inheritance": "AD, AR"
  },
  {
    "gene": "COL6A2",
    "phenotype": "Myosclerosis, congenital [MIM: 255600]; Bethlem myopathy 1B [MIM: 620725]; Ullrich congenital muscular dystrophy 1B [MIM: 620727]",
    "omimEntry": "120240",
    "inheritance": "AD, AR"
  },
  {
    "gene": "COL6A3",
    "phenotype": "Bethlem myopathy 1C [MIM: 620726]; Dystonia 27 [MIM; 616411]; Ullrich congenital muscular dystrophy 1C [MIM: 620728]",
    "omimEntry": "120250",
    "inheritance": "AD, AR"
  },
  {
    "gene": "COLQ",
    "phenotype": "Myasthenic syndrome, congenital, 5 [MIM: 603034]",
    "omimEntry": "603033",
    "inheritance": "AR"
  },
  {
    "gene": "COQ2",
    "phenotype": "{Multiple system atrophy, susceptibility to} [MIM: 146500]; Coenzyme Q10 deficiency, primary, 1 [MIM: 607426]",
    "omimEntry": "609825",
    "inheritance": "AD, AR"
  },
  {
    "gene": "COQ4",
    "phenotype": "Coenzyme Q10 deficiency, primary, 7 [MIM: 616276]; Spastic ataxia 10, autosomal recessive [MIM: 620666]",
    "omimEntry": "612898",
    "inheritance": "AR"
  },
  {
    "gene": "COQ5",
    "phenotype": "Coenzyme Q10 deficiency, primary, 9 (MIM: 619028]",
    "omimEntry": "616359",
    "inheritance": "AR"
  },
  {
    "gene": "COQ6",
    "phenotype": "Coenzyme Q10 deficiency, primary, 6 [MIM: 614650]",
    "omimEntry": "614647",
    "inheritance": "AR"
  },
  {
    "gene": "COQ7",
    "phenotype": "Coenzyme Q10 deficiency, primary, 8 [MIM: 616733]; Neuronopathy, distal hereditary motor, autosomal recessive 9 [MIM: 620402]",
    "omimEntry": "601683",
    "inheritance": "AR"
  },
  {
    "gene": "COQ8A",
    "phenotype": "Coenzyme Q10 deficiency, primary, 4 [MIM: 612016]",
    "omimEntry": "606980",
    "inheritance": "AR"
  },
  {
    "gene": "COQ9",
    "phenotype": "Coenzyme Q10 deficiency, primary, 5 [MIM: 614654]",
    "omimEntry": "612837",
    "inheritance": "AR"
  },
  {
    "gene": "COX10",
    "phenotype": "Mitochondrial complex IV deficiency, nuclear type 3 [MIM: 619046]",
    "omimEntry": "602125",
    "inheritance": "AR"
  },
  {
    "gene": "COX14",
    "phenotype": "Mitochondrial complex IV deficiency, nuclear type 10 [MIM: 619053]",
    "omimEntry": "614478",
    "inheritance": "AR"
  },
  {
    "gene": "COX15",
    "phenotype": "Mitochondrial complex IV deficiency, nuclear type 6 [MIM: 615119]",
    "omimEntry": "603646",
    "inheritance": "AR"
  },
  {
    "gene": "COX20",
    "phenotype": "Mitochondrial complex IV deficiency, nuclear type 11 [MIM: 619054]",
    "omimEntry": "614698",
    "inheritance": "AR"
  },
  {
    "gene": "COX6B1",
    "phenotype": "Mitochondrial complex IV deficiency, nuclear type 7 [MIM: 619051]",
    "omimEntry": "124089",
    "inheritance": "AR"
  },
  {
    "gene": "COX8A",
    "phenotype": "Mitochondrial complex IV deficiency, nuclear type 15 [MIM: 619059]",
    "omimEntry": "123870",
    "inheritance": "AR"
  },
  {
    "gene": "COXFA4",
    "phenotype": "Mitochondrial complex IV deficiency, nuclear type 21 [MIM: 619065]",
    "omimEntry": "603833",
    "inheritance": "AR"
  },
  {
    "gene": "CP",
    "phenotype": "Aceruloplasminemia [MIM: 604290]",
    "omimEntry": "117700",
    "inheritance": "AR"
  },
  {
    "gene": "CPLANE1",
    "phenotype": "Joubert syndrome 17 [MIM: 614615]; Orofaciodigital syndrome VI [MIM: 277170]",
    "omimEntry": "614571",
    "inheritance": "AR"
  },
  {
    "gene": "CPS1",
    "phenotype": "Carbamoylphosphate synthetase I deficiency [MIM: 237300]",
    "omimEntry": "608307",
    "inheritance": "AR"
  },
  {
    "gene": "CPT1C",
    "phenotype": "Spastic paraplegia 73, autosomal dominant [MIM: 616282]",
    "omimEntry": "608846",
    "inheritance": "AD"
  },
  {
    "gene": "CPT2",
    "phenotype": "{Encephalopathy, acute, infection-induced, 4, susceptibility to} [MIM: 614212]; CPT II deficiency, infantile [MIM: 600649]; CPT II deficiency, lethal neonatal [MIM: 608836]; CPT II deficiency, myopathic, stress-induced [MIM: 255110]",
    "omimEntry": "600650",
    "inheritance": "AD, AR"
  },
  {
    "gene": "CREBBP",
    "phenotype": "Menke-Hennekam syndrome 1 [MIM: 618332]; Rubinstein-Taybi syndrome 1 [MIM: 180849]",
    "omimEntry": "600140",
    "inheritance": "AD"
  },
  {
    "gene": "CRLF1",
    "phenotype": "Cold-induced sweating syndrome 1 [MIM: 272430]",
    "omimEntry": "604237",
    "inheritance": "AR"
  },
  {
    "gene": "CRPPA",
    "phenotype": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 7 [MIM: 614643]; Muscular dystrophy-dystroglycanopathy (limb-girdle), type C, 7 [MIM: 616052]",
    "omimEntry": "614631",
    "inheritance": "AR"
  },
  {
    "gene": "CRYAB",
    "phenotype": "Cardiomyopathy, dilated, 1II [MIM: 615184]; Cataract 16, multiple types [MIM: 613763]; Myopathy, myofibrillar, 2A, adult-onset [MIM: 608810]; Myopathy, myofibrillar, 2B, infantile-onset [MIM: 613869]",
    "omimEntry": "123590",
    "inheritance": "AD, AR"
  },
  {
    "gene": "CSF1R",
    "phenotype": "Brain abnormalities, neurodegeneration, and dysosteosclerosis [MIM: 618476]; Leukoencephalopathy, diffuse hereditary, with spheroids 1 [MIM: 221820]",
    "omimEntry": "164770",
    "inheritance": "AD, AR"
  },
  {
    "gene": "CSPP1",
    "phenotype": "Joubert syndrome 21 [MIM: 615636]",
    "omimEntry": "611654",
    "inheritance": "AR"
  },
  {
    "gene": "CSTB",
    "phenotype": "Epilepsy, progressive myoclonic 1A (Unverricht and Lundborg) [MIM: 254800]",
    "omimEntry": "601145",
    "inheritance": "AR"
  },
  {
    "gene": "CTBP1",
    "phenotype": "Hypotonia, ataxia, developmental delay, and tooth enamel defect syndrome [MIM: 617915]",
    "omimEntry": "602618",
    "inheritance": "AD"
  },
  {
    "gene": "CTC1",
    "phenotype": "Cerebroretinal microangiopathy with calcifications and cysts [MIM: 612199]",
    "omimEntry": "613129",
    "inheritance": "AR"
  },
  {
    "gene": "CTDP1",
    "phenotype": "Congenital cataracts, facial dysmorphism, and neuropathy [MIM: 604168]",
    "omimEntry": "604927",
    "inheritance": "AR"
  },
  {
    "gene": "CTNNB1",
    "phenotype": "Colorectal cancer, somatic [MIM: 114500]; Exudative vitreoretinopathy 7\t[MIM: 617572]; Hepatocellular carcinoma, somatic [MIM: 114550]; Medulloblastoma, somatic [MIM: 155255]; Neurodevelopmental disorder with spastic diplegia and visual defects [MIM: 615075]; Ovarian cancer, somatic [MIM: 167000]; Pilomatricoma, somatic [MIM: 132600]",
    "omimEntry": "116806",
    "inheritance": "AD"
  },
  {
    "gene": "CTSD",
    "phenotype": "Ceroid lipofuscinosis, neuronal, 10 [MIM: 610127]",
    "omimEntry": "116840",
    "inheritance": "AR"
  },
  {
    "gene": "CTSF",
    "phenotype": "Ceroid lipofuscinosis, neuronal, 13 (Kufs type) [MIM: 615362]",
    "omimEntry": "603539",
    "inheritance": "AR"
  },
  {
    "gene": "CUL4B",
    "phenotype": "Intellectual developmental disorder, X-linked syndromic, Cabezas type [MIM: 300354]",
    "omimEntry": "300304",
    "inheritance": "XLR"
  },
  {
    "gene": "CWF19L1",
    "phenotype": "Spinocerebellar ataxia, autosomal recessive 17 [MIM: 616127]",
    "omimEntry": "616120",
    "inheritance": "AR"
  },
  {
    "gene": "CYB5R3",
    "phenotype": "Methemoglobinemia, type I [MIM: 250800]; Methemoglobinemia, type II [MIM: 250800]",
    "omimEntry": "613213",
    "inheritance": "AR"
  },
  {
    "gene": "CYC1",
    "phenotype": "Mitochondrial complex III deficiency, nuclear type 6 [MIM: 615453]",
    "omimEntry": "123980",
    "inheritance": "AR"
  },
  {
    "gene": "CYP27A1",
    "phenotype": "Cerebrotendinous xanthomatosis [MIM: 213700]",
    "omimEntry": "606530",
    "inheritance": "AR"
  },
  {
    "gene": "CYP2U1",
    "phenotype": "Spastic paraplegia 56, autosomal recessive [MIM: 615030]",
    "omimEntry": "610670",
    "inheritance": "AR"
  },
  {
    "gene": "CYP7B1",
    "phenotype": "Bile acid synthesis defect, congenital, 3 [MIM: 613812]; Spastic paraplegia 5A, autosomal recessive [MIM: 270800]",
    "omimEntry": "603711",
    "inheritance": "AR"
  },
  {
    "gene": "DAB1",
    "phenotype": "Spinocerebellar ataxia 37 [MIM: 615945]",
    "omimEntry": "603448",
    "inheritance": "AD"
  },
  {
    "gene": "DAG1",
    "phenotype": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 9 [MIM: 616538]; Muscular dystrophy-dystroglycanopathy (limb-girdle), type C, 9 [MIM: 613818]",
    "omimEntry": "128239",
    "inheritance": "AR"
  },
  {
    "gene": "DARS1",
    "phenotype": "Hypomyelination with brainstem and spinal cord involvement and leg spasticity [MIM: 615281]",
    "omimEntry": "603084",
    "inheritance": "AR"
  },
  {
    "gene": "DARS2",
    "phenotype": "Leukoencephalopathy with brain stem and spinal cord involvement and lactate elevation [MIM: 611105]",
    "omimEntry": "610956",
    "inheritance": "AR"
  },
  {
    "gene": "DBT",
    "phenotype": "Maple syrup urine disease, type II [MIM: 620699]",
    "omimEntry": "248610",
    "inheritance": "AR"
  },
  {
    "gene": "DCAF17",
    "phenotype": "Woodhouse-Sakati syndrome [MIM: 241080]",
    "omimEntry": "612515",
    "inheritance": "AR"
  },
  {
    "gene": "DCC",
    "phenotype": "Colorectal cancer, somatic [MIM: 114500]; Esophageal carcinoma, somatic [MIM: 133239]; Gaze palsy, familial horizontal, with progressive scoliosis, 2 [MIM: 617542]; Mirror movements 1 and/or agenesis of the corpus callosum [MIM:157600]",
    "omimEntry": "120470",
    "inheritance": "AD, AR"
  },
  {
    "gene": "DCPS",
    "phenotype": "Al-Raqad syndrome [MIM: 616459]",
    "omimEntry": "610534",
    "inheritance": "AR"
  },
  {
    "gene": "DCTN1",
    "phenotype": "{Amyotrophic lateral sclerosis, susceptibility to} [MIM: 105400]; Neuronopathy, distal hereditary motor, autosomal dominant 14 [MIM: 607641]; perry syndrome [MIM: 168605]",
    "omimEntry": "601143",
    "inheritance": "AD, AR"
  },
  {
    "gene": "DCX",
    "phenotype": "Lissencephaly, X-linked [MIM: 300067]; Subcortical laminal heterotopia, X-linked [MIM: 300067]",
    "omimEntry": "300121",
    "inheritance": "XL"
  },
  {
    "gene": "DDC",
    "phenotype": "Aromatic L-amino acid decarboxylase deficiency [MIM: 608643]",
    "omimEntry": "107930",
    "inheritance": "AR"
  },
  {
    "gene": "DDHD1",
    "phenotype": "Spastic paraplegia 28, autosomal recessive [MIM: 609340]",
    "omimEntry": "614603",
    "inheritance": "AR"
  },
  {
    "gene": "DDHD2",
    "phenotype": "Spastic paraplegia 54, autosomal recessive [MIM: 615033]",
    "omimEntry": "615003",
    "inheritance": "AR"
  },
  {
    "gene": "DDX3X",
    "phenotype": "Intellectual developmental disorder, X-linked syndromic, Snijders Blok type [MIM: 300958]",
    "omimEntry": "300160",
    "inheritance": "XLD, XLR"
  },
  {
    "gene": "DEAF1",
    "phenotype": "Neurodevelopmental disorder with hypotonia, impaired expressive language, and with or without seizures [MIM: 617171]; Vulto-van Silfout-de Vries syndrome [MIM: 615828]",
    "omimEntry": "602635",
    "inheritance": "AD, AR"
  },
  {
    "gene": "DES",
    "phenotype": "Cardiomyopathy, dilated, 1I [MIM: 604765]; Myopathy, myofibrillar, 1 [MIM: 601419]; Scapuloperoneal syndrome, neurogenic, Kaeser type [MIM: 181400]",
    "omimEntry": "125660",
    "inheritance": "AD, AR"
  },
  {
    "gene": "DHCR24",
    "phenotype": "Desmosterolosis [MIM: 602398]",
    "omimEntry": "606418",
    "inheritance": "AR"
  },
  {
    "gene": "DHFR",
    "phenotype": "Megaloblastic anemia due to dihydrofolate reductase deficiency [MIM: 613839]",
    "omimEntry": "126060",
    "inheritance": "AR"
  },
  {
    "gene": "DHPS",
    "phenotype": "Neurodevelopmental disorder with seizures and speech and walking impairment [MIM: 618480]",
    "omimEntry": "600944",
    "inheritance": "AR"
  },
  {
    "gene": "DKC1",
    "phenotype": "Cataracts, hearing impairment, nephrotic syndrome, and enterocolitis 1  [MIM: 301108]; Dyskeratosis congenita, X-linked [MIM: 305000]",
    "omimEntry": "300126",
    "inheritance": "XLD, XLR"
  },
  {
    "gene": "DLAT",
    "phenotype": "Pyruvate dehydrogenase E2 deficiency [MIM: 245348]",
    "omimEntry": "608770",
    "inheritance": "AR"
  },
  {
    "gene": "DLD",
    "phenotype": "Dihydrolipoamide dehydrogenase deficiency [MIM: 246900]",
    "omimEntry": "238331",
    "inheritance": "AR"
  },
  {
    "gene": "DMD",
    "phenotype": "Becker muscular dystrophy [MIM: 300376]; Cardiomyopathy, dilated, 3B [MIM: 302045]; Duchenne muscular dystrophy [MIM: 310200]",
    "omimEntry": "300377",
    "inheritance": "XL, XLR"
  },
  {
    "gene": "DMPK",
    "phenotype": "Myotonic dystrophy 1 [MIM: 160900]",
    "omimEntry": "605377",
    "inheritance": "AD"
  },
  {
    "gene": "DMXL2",
    "phenotype": "Deafness, autosomal dominant 71 [MIM: 617605]; Polyendocrine-polyneuropathy syndrome [MIM: 616113]; Developmental and epileptic encephalopathy 81 [MIM: 618663]",
    "omimEntry": "612186",
    "inheritance": "AD, AR"
  },
  {
    "gene": "DNA2",
    "phenotype": "Progressive external ophthalmoplegia with mitochondrial DNA deletions, autosomal dominant 6 [MIM: 615156]; Rothmund-Thomson syndrome, type 4 [MIM: 620819]; Seckel syndrome 8 [MIM: 615807]",
    "omimEntry": "601810",
    "inheritance": "AD, AR"
  },
  {
    "gene": "DNAJB2",
    "phenotype": "Neuronopathy, distal hereditary motor, autosomal recessive 5 [MIM: 614881]",
    "omimEntry": "604139",
    "inheritance": "AR"
  },
  {
    "gene": "DNAJB4",
    "phenotype": "Congenital myopathy 21 with early respiratory failure [MIM: 620326]",
    "omimEntry": "611327",
    "inheritance": "AR"
  },
  {
    "gene": "DNAJB6",
    "phenotype": "Muscular dystrophy, limb-girdle, autosomal dominant 1 [MIM: 603511]",
    "omimEntry": "611332",
    "inheritance": "AD"
  },
  {
    "gene": "DNAJC12",
    "phenotype": "Hyperphenylalaninemia, mild, non-BH4-deficient [MIM: 617384]",
    "omimEntry": "606060",
    "inheritance": "AR"
  },
  {
    "gene": "DNAJC19",
    "phenotype": "3-methylglutaconic aciduria, type V [MIM: 610198]",
    "omimEntry": "608977",
    "inheritance": "AR"
  },
  {
    "gene": "DNAJC3",
    "phenotype": "Ataxia, combined cerebellar and peripheral, with hearing loss and diabetes mellitus [MIM: 616192]",
    "omimEntry": "601184",
    "inheritance": "AR"
  },
  {
    "gene": "DNAJC5",
    "phenotype": "Ceroid lipofuscinosis, neuronal, 4 (Kufs type), autosomal dominant [MIM: 162350]",
    "omimEntry": "611203",
    "inheritance": "AD"
  },
  {
    "gene": "DNAJC6",
    "phenotype": "Parkinson disease 19a, juvenile-onset [MIM: 615528]; Parkinson disease 19b, early-onset [MIM: 615528]",
    "omimEntry": "608375",
    "inheritance": "AR"
  },
  {
    "gene": "DNM1L",
    "phenotype": "Encephalopathy, lethal, due to defective mitochondrial peroxisomal fission 1 [MIM: 614388]; Optic atrophy 5 [MIM: 610708]",
    "omimEntry": "603850",
    "inheritance": "AD, AR"
  },
  {
    "gene": "DNM2",
    "phenotype": "Centronuclear myopathy 1 [MIM: 160150]; Charcot-Marie-Tooth disease, axonal type 2M [MIM: 606482]; Charcot-Marie-Tooth disease, dominant intermediate B [MIM: 606482]; Lethal congenital contracture syndrome 5 [MIM; 615368]",
    "omimEntry": "602378",
    "inheritance": "AD, AR"
  },
  {
    "gene": "DNMT1",
    "phenotype": "Cerebellar ataxia, deafness, and narcolepsy, autosomal dominant [MIM: 604121]; Neuropathy, hereditary sensory, type IE [MIM: 614116]",
    "omimEntry": "126375",
    "inheritance": "AD"
  },
  {
    "gene": "DOCK3",
    "phenotype": "Neurodevelopmental disorder with impaired intellectual development, hypotonia, and ataxia [MIM: 618292]",
    "omimEntry": "603123",
    "inheritance": "AR"
  },
  {
    "gene": "DOCK8",
    "phenotype": "Hyper-IgE syndrome 2, autosomal recessive, with recurrent infections [MIM: 243700]",
    "omimEntry": "611432",
    "inheritance": "AR"
  },
  {
    "gene": "DOK7",
    "phenotype": "Fetal akinesia deformation sequence 3 [MIM: 618389]; Myasthenic syndrome, congenital, 10 [MIM: 254300]",
    "omimEntry": "610285",
    "inheritance": "AR"
  },
  {
    "gene": "DOLK",
    "phenotype": "Congenital disorder of glycosylation, type Im [MIM: 610768]",
    "omimEntry": "610746",
    "inheritance": "AR"
  },
  {
    "gene": "DPAGT1",
    "phenotype": "Congenital disorder of glycosylation, type Ij [MIM: 608093]; Myasthenic syndrome, congenital, 13, with tubular aggregates [MIM: 614750]",
    "omimEntry": "191350",
    "inheritance": "AR"
  },
  {
    "gene": "DPM1",
    "phenotype": "Congenital disorder of glycosylation, type Ie [MIM: 608799]",
    "omimEntry": "603503",
    "inheritance": "AR"
  },
  {
    "gene": "DPM2",
    "phenotype": "Congenital disorder of glycosylation, type Iu [MIM: 615042]",
    "omimEntry": "603564",
    "inheritance": "AR"
  },
  {
    "gene": "DPM3",
    "phenotype": "Muscular dystrophy-dystroglycanopathy (congenital with impaired intellectual development), type B, 15 [MIM: 618992]; Muscular dystrophy-dystroglycanopathy (limb-girdle), type C, 15 [MIM: 612937]",
    "omimEntry": "605951",
    "inheritance": "AR"
  },
  {
    "gene": "DPYD",
    "phenotype": "5-fluorouracil toxicity [MIM: 274270]; Dihydropyrimidine dehydrogenase deficiency [MIM: 274270]",
    "omimEntry": "612779",
    "inheritance": "AR"
  },
  {
    "gene": "DPYS",
    "phenotype": "Dihydropyrimidinuria [MIM: 222748]",
    "omimEntry": "613326",
    "inheritance": "AR"
  },
  {
    "gene": "DRD3",
    "phenotype": "{Essential tremor, hereditary, 1} [MIM: 190300]; {Schizophrenia, susceptibility to} [MIM: 181500]",
    "omimEntry": "126451",
    "inheritance": "AD"
  },
  {
    "gene": "DRD5",
    "phenotype": "{Attention deficit-hyperactivity disorder, susceptibility to} [MIM: 143465]; {Blepharospasm, primary benign} [MIM: 606798]",
    "omimEntry": "126453",
    "inheritance": "AD"
  },
  {
    "gene": "DTNA",
    "phenotype": "Left ventricular noncompaction 1, with or without congenital heart defects [MIM: 604169]; Myopathy with myalgia, increased serum creatine kinase, and with or without episodic rhabdomyolysis 2 [MIM: 620971]",
    "omimEntry": "601239",
    "inheritance": "AD"
  },
  {
    "gene": "DYNC1H1",
    "phenotype": "Charcot-Marie-Tooth disease, axonal, type 2O [MIM: 614228]; Cortical dysplasia, complex, with other brain malformations 13 [MIM: 614563]; Spinal muscular atrophy, lower extremity-predominant 1, AD [MIM: 158600]",
    "omimEntry": "600112",
    "inheritance": "AD"
  },
  {
    "gene": "DYRK1A",
    "phenotype": "Intellectual developmental disorder, autosomal dominant 7 [MIM: 614104]",
    "omimEntry": "600855",
    "inheritance": "AD"
  },
  {
    "gene": "DYSF",
    "phenotype": "Miyoshi muscular dystrophy 1 [MIM: 254130]; Muscular dystrophy, limb-girdle, autosomal recessive 2 [MIM: 253601]; Myopathy, distal, with anterior tibial onset [MIM: 606768]",
    "omimEntry": "603009",
    "inheritance": "AR"
  },
  {
    "gene": "EARS2",
    "phenotype": "Combined oxidative phosphorylation deficiency 12 [MIM: 614924]",
    "omimEntry": "612799",
    "inheritance": "AR"
  },
  {
    "gene": "EBF3",
    "phenotype": "Hypotonia, ataxia, and delayed development syndrome [MIM: 617330]",
    "omimEntry": "607407",
    "inheritance": "AD"
  },
  {
    "gene": "ECEL1",
    "phenotype": "Arthrogryposis, distal, type 5D [MIM: 615065]",
    "omimEntry": "605896",
    "inheritance": "AR"
  },
  {
    "gene": "ECHS1",
    "phenotype": "Mitochondrial short-chain enoyl-CoA hydratase 1 deficiency [MIM: 616277]",
    "omimEntry": "602292",
    "inheritance": "AR"
  },
  {
    "gene": "EEF2",
    "phenotype": "Spinocerebellar ataxia 26 [MIM: 609306]",
    "omimEntry": "130610",
    "inheritance": "ad"
  },
  {
    "gene": "EGR2",
    "phenotype": "Charcot-Marie-Tooth disease, type 1D [MIM: 607678]; Dejerine-Sottas disease [MIM: 145900]; Hypomyelinating neuropathy, congenital, 1 [MIM: 605253]",
    "omimEntry": "129010",
    "inheritance": "AD, AR"
  },
  {
    "gene": "EIF2B1",
    "phenotype": "Leukoencephalopathy with vanishing white matter 1, with or without ovarian failure [MIM: 603896]",
    "omimEntry": "606686",
    "inheritance": "AR"
  },
  {
    "gene": "EIF2B2",
    "phenotype": "Leukoencephalopathy with vanishing white matter 2, with or without ovarian failure [MIM: 620312]",
    "omimEntry": "606454",
    "inheritance": "AR"
  },
  {
    "gene": "EIF2B3",
    "phenotype": "Leukoencephalopathy with vanishing white matter 3, with or without ovarian failure [MIM: 620313]",
    "omimEntry": "606273",
    "inheritance": "AR"
  },
  {
    "gene": "EIF2B4",
    "phenotype": "Leukoencephalopathy with vanishing white matter 4, with or without ovarian failure [MIM: 620314]",
    "omimEntry": "606687",
    "inheritance": "AR"
  },
  {
    "gene": "EIF2B5",
    "phenotype": "Leukoencephalopathy with vanishing white matter 5, with or without ovarian failure [MIM: 620315]",
    "omimEntry": "603945",
    "inheritance": "AR"
  },
  {
    "gene": "EIF4G1",
    "phenotype": "{Parkinson disease 18} [MIM: 614251]",
    "omimEntry": "600495",
    "inheritance": "AD"
  },
  {
    "gene": "ELOVL1",
    "phenotype": "Ichthyotic keratoderma, spasticity, hypomyelination, and dysmorphic facies [MIM: 618527]",
    "omimEntry": "611813",
    "inheritance": "AD, AR"
  },
  {
    "gene": "ELOVL4",
    "phenotype": "Ichthyosis, spastic quadriplegia, and impaired intellectual development [MIM: 614457]; Spinocerebellar ataxia 34 [MIM: 133190]; Stargardt disease 3 [MIM: 600110]",
    "omimEntry": "605512",
    "inheritance": "AD, AR"
  },
  {
    "gene": "ELOVL5",
    "phenotype": "Spinocerebellar ataxia 38 [MIM: 615957]",
    "omimEntry": "611805",
    "inheritance": "AD"
  },
  {
    "gene": "ELP2",
    "phenotype": "Intellectual developmental disorder, autosomal recessive 58 [MIM: 617270]",
    "omimEntry": "616054",
    "inheritance": "AR"
  },
  {
    "gene": "EMC1",
    "phenotype": "Cerebellar atrophy, visual impairment, and psychomotor retardation [MIM: 616875]",
    "omimEntry": "616846",
    "inheritance": "AR"
  },
  {
    "gene": "EMD",
    "phenotype": "Emery-Dreifuss muscular dystrophy 1, X-linked [MIM: 310300]",
    "omimEntry": "300384",
    "inheritance": "XLR"
  },
  {
    "gene": "EML1",
    "phenotype": "Band heterotopia [MIM: 600348]",
    "omimEntry": "602033",
    "inheritance": "AR"
  },
  {
    "gene": "ENO3",
    "phenotype": "Glycogen storage disease XIII [MIM: 612932]",
    "omimEntry": "131370",
    "inheritance": "AR"
  },
  {
    "gene": "ENTPD1",
    "phenotype": "Spastic paraplegia 64, autosomal recessive [MIM: 615683]",
    "omimEntry": "601752",
    "inheritance": "AR"
  },
  {
    "gene": "EPG5",
    "phenotype": "Vici syndrome [ MIM: 242820]",
    "omimEntry": "615068",
    "inheritance": "AR"
  },
  {
    "gene": "EPM2A",
    "phenotype": "Myoclonic epilepsy of Lafora 1 [MIM: 254780]",
    "omimEntry": "607566",
    "inheritance": "AR"
  },
  {
    "gene": "ERAL1",
    "phenotype": "Perrault syndrome 6 [MIM: 617565]",
    "omimEntry": "607435",
    "inheritance": "AR"
  },
  {
    "gene": "ERBB4",
    "phenotype": "Amyotrophic lateral sclerosis 19 [MIM: 615515]",
    "omimEntry": "600543",
    "inheritance": "AD"
  },
  {
    "gene": "ERCC1",
    "phenotype": "Cerebrooculofacioskeletal syndrome 4 [MIM: 610758]",
    "omimEntry": "126380",
    "inheritance": "AR"
  },
  {
    "gene": "ERCC2",
    "phenotype": "Cerebrooculofacioskeletal syndrome 2 [MIM: 610756]; Trichothiodystrophy 1, photosensitive [MIM: 601675];\nXeroderma pigmentosum, group D [MIM: 278730]",
    "omimEntry": "126340",
    "inheritance": "AR"
  },
  {
    "gene": "ERCC3",
    "phenotype": "Trichothiodystrophy 2, photosensitive [MIM: 616390]; Xeroderma pigmentosum, group B [MIM: 610651]",
    "omimEntry": "133510",
    "inheritance": "AR"
  },
  {
    "gene": "ERCC4",
    "phenotype": "Fanconi anemia, complementation group Q [MIM: 615272]; Xeroderma pigmentosum, group F [MIM: 278760]; Xeroderma pigmentosum, type F/Cockayne syndrome [MIM: 278760]; XFE progeroid syndrome [MIM: 610965]",
    "omimEntry": "133520",
    "inheritance": "AR"
  },
  {
    "gene": "ERCC5",
    "phenotype": "Cerebrooculofacioskeletal syndrome 3 [MIM: 616570]; Xeroderma pigmentosum, group G [MIM: 278780];\nXeroderma pigmentosum, group G/Cockayne syndrome [MIM: 278780]",
    "omimEntry": "133530",
    "inheritance": "AR"
  },
  {
    "gene": "ERCC6",
    "phenotype": "?De Sanctis-Cacchione syndrome [MIM: 278800]; {Lung cancer, susceptibility to} [MIM: 211980]; {Macular degeneration, age-related, susceptibility to, 5} [MIM: 613761]; Cerebrooculofacioskeletal syndrome 1 [MIM: 214150]; Cockayne syndrome, type B [MIM: 133540]; Premature ovarian failure 11 [MIM: 616946]; UV-sensitive syndrome 1 [MIM: 600630]",
    "omimEntry": "609413",
    "inheritance": "AD, AR, Smu"
  },
  {
    "gene": "ERCC8",
    "phenotype": "Cockayne syndrome, type A [MIM: 216400]; UV-sensitive syndrome 2 [MIM: 614621]",
    "omimEntry": "609412",
    "inheritance": "AR"
  },
  {
    "gene": "ERLIN1",
    "phenotype": "Spastic paraplegia 62, autosomal recessive [MIM: 615681]",
    "omimEntry": "611604",
    "inheritance": "AR"
  },
  {
    "gene": "ERLIN2",
    "phenotype": "Spastic paraplegia 18A, autosomal dominant [MIM: 620512]; Spastic paraplegia 18B, autosomal recessive [MIM: 611225]",
    "omimEntry": "611605",
    "inheritance": "AD, AR"
  },
  {
    "gene": "ETFA",
    "phenotype": "Glutaric acidemia IIA [MIM: 231680]",
    "omimEntry": "608053",
    "inheritance": "AR"
  },
  {
    "gene": "ETFB",
    "phenotype": "Glutaric acidemia IIB [MIM: 231680]",
    "omimEntry": "130410",
    "inheritance": "AR"
  },
  {
    "gene": "ETFDH",
    "phenotype": "Glutaric acidemia IIC [MIM: 231680]",
    "omimEntry": "231675",
    "inheritance": "AR"
  },
  {
    "gene": "ETHE1",
    "phenotype": "Ethylmalonic encephalopathy [MIM: 602473]",
    "omimEntry": "608451",
    "inheritance": "AR"
  },
  {
    "gene": "EXOSC3",
    "phenotype": "Pontocerebellar hypoplasia, type 1B [MIM: 614678]",
    "omimEntry": "606489",
    "inheritance": "AR"
  },
  {
    "gene": "EXOSC8",
    "phenotype": "Pontocerebellar hypoplasia, type 1C [MIM: 616081]",
    "omimEntry": "616081",
    "inheritance": "AR"
  },
  {
    "gene": "EXOSC9",
    "phenotype": "Pontocerebellar hypoplasia, type 1D [MIM: 618065]",
    "omimEntry": "606180",
    "inheritance": "AR"
  },
  {
    "gene": "EXT2",
    "phenotype": "Exostoses, multiple, type 2 [MIM: 133701]; Seizures, scoliosis, and macrocephaly syndrome [MIM: 616682]",
    "omimEntry": "608210",
    "inheritance": "AD, AR"
  },
  {
    "gene": "EZH2",
    "phenotype": "Weaver syndrome [MIM: 277590]",
    "omimEntry": "601573",
    "inheritance": "AD"
  },
  {
    "gene": "FA2H",
    "phenotype": "Spastic paraplegia 35, autosomal recessive [MIM: 612319]",
    "omimEntry": "611026",
    "inheritance": "AR"
  },
  {
    "gene": "FAR1",
    "phenotype": "Cataracts, spastic paraparesis, and speech delay [MIM: 619338]; Peroxisomal fatty acyl-CoA reductase 1 disorder [MIM: 616154]",
    "omimEntry": "616107",
    "inheritance": "AD, AR"
  },
  {
    "gene": "FARS2",
    "phenotype": "Combined oxidative phosphorylation deficiency 14 [MIM: 614946]; Spastic paraplegia 77, autosomal recessive\t [MIM: 617046]",
    "omimEntry": "611592",
    "inheritance": "AR"
  },
  {
    "gene": "FASTKD2",
    "phenotype": "Combined oxidative phosphorylation deficiency 44 [MIM: 618855]",
    "omimEntry": "612322",
    "inheritance": "AR"
  },
  {
    "gene": "FAT2",
    "phenotype": "Spinocerebellar ataxia 45 [MIM: 617769]",
    "omimEntry": "604269",
    "inheritance": "AD"
  },
  {
    "gene": "FBXL4",
    "phenotype": "Mitochondrial DNA depletion syndrome 13 (encephalomyopathic type) [MIM: 615471]",
    "omimEntry": "605654",
    "inheritance": "AR"
  },
  {
    "gene": "FBXO38",
    "phenotype": "Neuronopathy, distal hereditary motor, autosomal dominant 6 [MIM: 625575]",
    "omimEntry": "608553",
    "inheritance": "AD"
  },
  {
    "gene": "FBXO7",
    "phenotype": "Parkinson disease 15, autosomal recessive [MIM: 260300]",
    "omimEntry": "605648",
    "inheritance": "AR"
  },
  {
    "gene": "FDX2",
    "phenotype": "Mitochondrial myopathy, episodic, with optic atrophy and reversible leukoencephalopathy [MIM: 251900]",
    "omimEntry": "614585",
    "inheritance": "AR"
  },
  {
    "gene": "FERRY3",
    "phenotype": "Intellectual developmental disorder, autosomal recessive 66 [MIM: 618221]",
    "omimEntry": "616082",
    "inheritance": "AR"
  },
  {
    "gene": "FGD4",
    "phenotype": "Charcot-Marie-Tooth disease, type 4H [MIM: 609311]",
    "omimEntry": "611104",
    "inheritance": "AR"
  },
  {
    "gene": "FGF12",
    "phenotype": "Developmental and epileptic encephalopathy 47 [MIM: 617166]",
    "omimEntry": "601513",
    "inheritance": "AD"
  },
  {
    "gene": "FGF14",
    "phenotype": "Spinocerebellar ataxia 27A [MIM: 193003]; Spinocerebellar ataxia 27B, late-onset [MIM: 620174]",
    "omimEntry": "601515",
    "inheritance": "AD"
  },
  {
    "gene": "FGFR1",
    "phenotype": "Encephalocraniocutaneous lipomatosis, somatic mosaic [MIM: 613001]; Hartsfield syndrome [MIM: 615465]; Hypogonadotropic hypogonadism 2 with or without anosmia [MIM: 147950]; Jackson-Weiss syndrome [MIM: 123150]; Osteoglophonic dysplasia [MIM: 166250]; Pfeiffer syndrome [MIM: 101600]; Trigonocephaly 1 [MIM: 190440]",
    "omimEntry": "136350",
    "inheritance": "AD"
  },
  {
    "gene": "FHL1",
    "phenotype": "Uruguay faciocardiomusculoskeletal syndrome [MIM: 300280]; Emery-Dreifuss muscular dystrophy 6, X-linked [MIM: 300696]; Myopathy, X-linked, with postural muscle atrophy [MIM: 300696]; Reducing body myopathy, X-linked 1a, severe, infantile or early childhood onset [MIM: 300717]; Reducing body myopathy, X-linked 1b, with late childhood or adult onset [MIM: 300718]; Scapuloperoneal myopathy, X-linked dominant [MIM: 300695]",
    "omimEntry": "300163",
    "inheritance": "XL, XLR, XLD"
  },
  {
    "gene": "FIG4",
    "phenotype": "Polymicrogyria, bilateral temporooccipital [MIM: 612691]; Amyotrophic lateral sclerosis 11 [MIM: 612577]; Charcot-Marie-Tooth disease, type 4J [MIM: 611228]; Yunis-Varon syndrome [MIM: 216340]",
    "omimEntry": "609390",
    "inheritance": "AD, AR"
  },
  {
    "gene": "FITM2",
    "phenotype": "Siddiqi syndrome [MIM: 618635]",
    "omimEntry": "612029",
    "inheritance": "AR"
  },
  {
    "gene": "FKBP14",
    "phenotype": "Ehlers-Danlos syndrome, kyphoscoliotic type, 2 [MIM: 614557]",
    "omimEntry": "614505",
    "inheritance": "AR"
  },
  {
    "gene": "FKRP",
    "phenotype": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 5 [MIM: 613153]; Muscular dystrophy-dystroglycanopathy (congenital with or without impaired intellectual development), type B, 5 [MIM: 606612]; Muscular dystrophy-dystroglycanopathy (limb-girdle), type C, 5 [MIM: 607155]",
    "omimEntry": "606596",
    "inheritance": "AR"
  },
  {
    "gene": "FKTN",
    "phenotype": "Cardiomyopathy, dilated, 1X [MIM: 611615]; Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 4 [MIM: 253800]; Muscular dystrophy-dystroglycanopathy (congenital without impaired intellectual development), type B, 4 [MIM: 613152]; Muscular dystrophy-dystroglycanopathy (limb-girdle), type C, 4 [MIM: 611588]",
    "omimEntry": "607440",
    "inheritance": "AR"
  },
  {
    "gene": "FLAD1",
    "phenotype": "Lipid storage myopathy due to flavin adenine dinucleotide synthetase deficiency [MIM: 255100]",
    "omimEntry": "610595",
    "inheritance": "AR"
  },
  {
    "gene": "FLNA",
    "phenotype": "FG syndrome 2 [MIM: 300321]; Cardiac valvular dysplasia, X-linked [MIM: 314400]; Congenital short bowel syndrome [MIM: 300048]; Frontometaphyseal dysplasia 1 [MIM: 305620]; Heterotopia, periventricular, 1 [MIM: 300049]; Intestinal pseudoobstruction, neuronal [MIM: 300048]; Melnick-Needles syndrome [MIM: 309350]; Otopalatodigital syndrome, type I [MIM: 311300]; Otopalatodigital syndrome, type II [MIM: 304120]; Terminal osseous dysplasia [MIM: 300244]",
    "omimEntry": "300017",
    "inheritance": "XL, XLR, XLD"
  },
  {
    "gene": "FLNC",
    "phenotype": "Arrhythmogenic right ventricular dysplasia, familial [MIM: 617047]; Cardiomyopathy, familial hypertrophic, 26 [MIM: 617047]; Cardiomyopathy, familial restrictive 5 [MIM: 617047]; Myopathy, distal, 4 [MIM: 614065]; Myopathy, myofibrillar, 5 [MIM: 609524]",
    "omimEntry": "102565",
    "inheritance": "AD"
  },
  {
    "gene": "FLVCR1",
    "phenotype": "Neurodevelopmental disorder with microcephaly, absent speech, and hypotonia [MIM: 621060]; Retinopathy-sensory neuropathy syndrome [MIM: 609033]",
    "omimEntry": "609144",
    "inheritance": "AR"
  },
  {
    "gene": "FMR1",
    "phenotype": "Fragile X syndrome [MIM: 300624]; Fragile X tremor/ataxia syndrome [MIM 300623]; Premature ovarian failure 1 [MIM: 311360]",
    "omimEntry": "309550",
    "inheritance": "XLD, XL"
  },
  {
    "gene": "FOLR1",
    "phenotype": "Neurodegeneration due to cerebral folate transport deficiency [MIM: 613068]",
    "omimEntry": "136430",
    "inheritance": "AR"
  },
  {
    "gene": "FOXG1",
    "phenotype": "Rett syndrome, congenital variant [MIM: 613454]",
    "omimEntry": "164874",
    "inheritance": "AD"
  },
  {
    "gene": "FOXRED1",
    "phenotype": "Mitochondrial complex I deficiency, nuclear type 19 [MIM: 618241]",
    "omimEntry": "613622",
    "inheritance": "AR"
  },
  {
    "gene": "FRMD4A",
    "phenotype": "Corpus callosum, agenesis of, with facial anomalies and cerebellar ataxia [MIM: 616819]",
    "omimEntry": "616305",
    "inheritance": "AR"
  },
  {
    "gene": "FRRS1L",
    "phenotype": "Developmental and epileptic encephalopathy 37 [MIM: 616981]",
    "omimEntry": "604574",
    "inheritance": "AR"
  },
  {
    "gene": "FTL",
    "phenotype": "Hyperferritinemia-cataract syndrome [MIM: 600886]; L-ferritin deficiency, dominant and recessive [MIM: 615604]; Neurodegeneration with brain iron accumulation 3 [MIM: 606159]",
    "omimEntry": "134790",
    "inheritance": "AD, AR"
  },
  {
    "gene": "FUCA1",
    "phenotype": "Fucosidosis [MIM: 230000]",
    "omimEntry": "612280",
    "inheritance": "AR"
  },
  {
    "gene": "FUS",
    "phenotype": "Amyotrophic lateral sclerosis 6, with or without frontotemporal dementia [MIM: 608030]; Essential tremor, hereditary, 4 [MIM: 614782]",
    "omimEntry": "137070",
    "inheritance": "AD"
  },
  {
    "gene": "FXN",
    "phenotype": "Friedreich ataxia [MIM: 229300]; Friedreich ataxia with retained reflexes [MIM: 229300]",
    "omimEntry": "606829",
    "inheritance": "AR"
  },
  {
    "gene": "FXR1",
    "phenotype": "Congenital myopathy 9A with respiratory insufficiency and bone fractures [MIM: 618822]; Congenital myopathy 9B, proximal, with minicore lesions [MIM: 618823]",
    "omimEntry": "600819",
    "inheritance": "AR"
  },
  {
    "gene": "GAA",
    "phenotype": "Pompe disease, infantile-onset [MIM: 232300]; Pompe disease, late-onset [MIM: 621314]",
    "omimEntry": "606800",
    "inheritance": "AR"
  },
  {
    "gene": "GABRB1",
    "phenotype": "Developmental and epileptic encephalopathy 45 [MIM: 617153]",
    "omimEntry": "137190",
    "inheritance": "AD"
  },
  {
    "gene": "GABRB2",
    "phenotype": "Developmental and epileptic encephalopathy 92 [MIM: 617829]",
    "omimEntry": "600232",
    "inheritance": "AD"
  },
  {
    "gene": "GABRB3",
    "phenotype": "{Epilepsy, childhood absence, susceptibility to, 5} [MIM: 612269]; Developmental and epileptic encephalopathy 43 [MIM: 617113]",
    "omimEntry": "137192",
    "inheritance": "AD"
  },
  {
    "gene": "GAD1",
    "phenotype": "Developmental and epileptic encephalopathy 89 [MIM: 619124]",
    "omimEntry": "605363",
    "inheritance": "AR"
  },
  {
    "gene": "GALC",
    "phenotype": "Krabbe disease [MIM: 245200]",
    "omimEntry": "606890",
    "inheritance": "AR"
  },
  {
    "gene": "GAMT",
    "phenotype": "Cerebral creatine deficiency syndrome 2 [MIM: 612736]",
    "omimEntry": "612736",
    "inheritance": "AR"
  },
  {
    "gene": "GAN",
    "phenotype": "Giant axonal neuropathy-1 [MIM: 256850]",
    "omimEntry": "605379",
    "inheritance": "AR"
  },
  {
    "gene": "GATAD2B",
    "phenotype": "GAND syndrome [MIM: 615074]",
    "omimEntry": "614998",
    "inheritance": "AD"
  },
  {
    "gene": "GBA1",
    "phenotype": "{Lewy body dementia, susceptibility to} [MIM: 127750]; {Parkinson disease, late-onset, susceptibility to} [MIM: 168600]; Gaucher disease, perinatal lethal [MIM: 608013]; Gaucher disease, type I [MIM: 230800]; Gaucher disease, type II [MIM: 230900]; Gaucher disease, type III [MIM: 231000]; Gaucher disease, type IIIC [MIM: 231005]",
    "omimEntry": "606463",
    "inheritance": "AD, AR, Mu"
  },
  {
    "gene": "GBA2",
    "phenotype": "Spastic paraplegia 46, autosomal recessive [MIM: 614409]",
    "omimEntry": "609471",
    "inheritance": "AR"
  },
  {
    "gene": "GBE1",
    "phenotype": "Glycogen storage disease IV [MIM: 232500]; Polyglucosan body disease, adult form [MIM: 263570]",
    "omimEntry": "607839",
    "inheritance": "AR"
  },
  {
    "gene": "GCDH",
    "phenotype": "Glutaricaciduria, type I [MIM: 231670]",
    "omimEntry": "608801",
    "inheritance": "AR"
  },
  {
    "gene": "GCH1",
    "phenotype": "Dystonia, DOPA-responsive [MIM: 128230]; Hyperphenylalaninemia, BH4-deficient, B [MIM: 233910]",
    "omimEntry": "600225",
    "inheritance": "AD, AR"
  },
  {
    "gene": "GCLC",
    "phenotype": "{Myocardial infarction, susceptibility to} [MIM: 608446]; Anemia, congenital, nonspherocytic hemolytic, 7 [MIM: 230450]",
    "omimEntry": "606857",
    "inheritance": "AR"
  },
  {
    "gene": "GDAP2",
    "phenotype": "Spinocerebellar ataxia, autosomal recessive 27 [MIM: 618369]",
    "omimEntry": "618128",
    "inheritance": "AR"
  },
  {
    "gene": "GEMIN4",
    "phenotype": "Neurodevelopmental disorder with microcephaly, cataracts, and renal abnormalities [MIM: 617913]",
    "omimEntry": "606969",
    "inheritance": "AR"
  },
  {
    "gene": "GFAP",
    "phenotype": "Alexander disease [MIM: 203450]",
    "omimEntry": "137780",
    "inheritance": "AD"
  },
  {
    "gene": "GFER",
    "phenotype": "Myopathy, mitochondrial progressive, with congenital cataract and developmental delay [MIM: 613076]",
    "omimEntry": "600924",
    "inheritance": "AR"
  },
  {
    "gene": "GFM1",
    "phenotype": "Combined oxidative phosphorylation deficiency 1 [MIM: 609060]",
    "omimEntry": "606639",
    "inheritance": "AR"
  },
  {
    "gene": "GFM2",
    "phenotype": "Combined oxidative phosphorylation deficiency 39 [MIM: 618397]",
    "omimEntry": "606544",
    "inheritance": "AR"
  },
  {
    "gene": "GFPT1",
    "phenotype": "Myasthenia, congenital, 12, with tubular aggregates [MIM: 610542]",
    "omimEntry": "138292",
    "inheritance": "AR"
  },
  {
    "gene": "GGPS1",
    "phenotype": "Muscular dystrophy, congenital hearing loss, and ovarian insufficiency syndrome [MIM: 619518]",
    "omimEntry": "606982",
    "inheritance": "AR"
  },
  {
    "gene": "GIGYF2",
    "phenotype": "{Parkinson disease 11} [MIM: 607688]",
    "omimEntry": "612003",
    "inheritance": ""
  },
  {
    "gene": "GIPC1",
    "phenotype": "Oculopharyngodistal myopathy 2 [MIM: 618940]",
    "omimEntry": "605072",
    "inheritance": "AD"
  },
  {
    "gene": "GJA1",
    "phenotype": "Craniometaphyseal dysplasia, autosomal recessive [MIM: 218400]; Erythrokeratodermia variabilis et progressiva 3 [MIM: 617525]; Oculodentodigital dysplasia [MIM: 164200]; Oculodentodigital dysplasia, autosomal recessive [MIM: 257850]; Palmoplantar keratoderma with congenital alopecia [MIM: 104100]; Syndactyly, type III [MIM: 186100]",
    "omimEntry": "121014",
    "inheritance": "AD. AR"
  },
  {
    "gene": "GJC2",
    "phenotype": "Spastic paraplegia 44, autosomal recessive [MIM: 613206]; Leukodystrophy, hypomyelinating, 2 [MIM: 608804]; Lymphatic malformation 3 [MIM: 613480]",
    "omimEntry": "608803",
    "inheritance": "AD, AR"
  },
  {
    "gene": "GLB1",
    "phenotype": "GM1-gangliosidosis, type I [MIM: 230500]; GM1-gangliosidosis, type II [MIM: 230600]; GM1-gangliosidosis, type III [MIM: 230650]; Mucopolysaccharidosis type IVB (Morquio) [MIM: 253010]",
    "omimEntry": "611458",
    "inheritance": "AR"
  },
  {
    "gene": "GLDN",
    "phenotype": "Lethal congenital contracture syndrome 11 [MIM: 617194]",
    "omimEntry": "608603",
    "inheritance": "AR"
  },
  {
    "gene": "GLE1",
    "phenotype": "Congenital arthrogryposis with anterior horn cell disease [MIM: 611890]; Lethal congenital contracture syndrome 1[ MIM: 253310]",
    "omimEntry": "603371",
    "inheritance": "AR"
  },
  {
    "gene": "GLRA1",
    "phenotype": "Hyperekplexia 1 [MIM: 149400]",
    "omimEntry": "138491",
    "inheritance": "AD, AR"
  },
  {
    "gene": "GLRX5",
    "phenotype": "Anemia, sideroblastic, 3, pyridoxine-refractory [MIM: 616860]; Spasticity, childhood-onset, with hyperglycinemia [MIM: 616859]",
    "omimEntry": "609588",
    "inheritance": "AR"
  },
  {
    "gene": "GLS",
    "phenotype": "Global developmental delay progressive ataxia and elevated glutamine [MIM: 618412]",
    "omimEntry": "138280",
    "inheritance": "AR"
  },
  {
    "gene": "GLYCTK",
    "phenotype": "D-glyceric aciduria [MIM: 220120]",
    "omimEntry": "610516",
    "inheritance": "AR"
  },
  {
    "gene": "GM2A",
    "phenotype": "GM2-gangliosidosis, AB variant [MIM: 272750]",
    "omimEntry": "613109",
    "inheritance": "AR"
  },
  {
    "gene": "GMPPA",
    "phenotype": "Alacrima, achalasia, and impaired intellectual development syndrome [MIM: 615510]",
    "omimEntry": "615495",
    "inheritance": "AR"
  },
  {
    "gene": "GMPPB",
    "phenotype": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 14 [MIM: 615350]; Muscular dystrophy-dystroglycanopathy (congenital with impaired intellectual development), type B, 14 [MIM: 615351]; Muscular dystrophy-dystroglycanopathy (limb-girdle), type C, 14 [MIM: 615352]",
    "omimEntry": "615320",
    "inheritance": "AR"
  },
  {
    "gene": "GNAL",
    "phenotype": "Dystonia 25 [MIM: 615073]",
    "omimEntry": "139312",
    "inheritance": "AD"
  },
  {
    "gene": "GNAO1",
    "phenotype": "Developmental and epileptic encephalopathy 17 [MIM: 615473]; Neurodevelopmental disorder with involuntary movements [MIM: 617493]",
    "omimEntry": "139311",
    "inheritance": "AD"
  },
  {
    "gene": "GNE",
    "phenotype": "Nonaka myopathy [MIM: 605820]; Sialuria [MIM: 269921]; Thrombocytopenia 12 with or without myopathy [MIM: 620757]",
    "omimEntry": "603824",
    "inheritance": "AD, AR"
  },
  {
    "gene": "GOLGA2",
    "phenotype": "Developmental delay with hypotonia, myopathy, and brain abnormalities [MIM: 620240]",
    "omimEntry": "602580",
    "inheritance": "AR"
  },
  {
    "gene": "GOSR2",
    "phenotype": "Epilepsy, progressive myoclonic 6 [MIM: 614018]; Muscular dystrophy, congenital, with or without seizures [MIM: 620166]",
    "omimEntry": "604027",
    "inheritance": "AR"
  },
  {
    "gene": "GPAA1",
    "phenotype": "Glycosylphosphatidylinositol biosynthesis defect 15 [MIM: 617810]",
    "omimEntry": "603048",
    "inheritance": "AR"
  },
  {
    "gene": "GPR88",
    "phenotype": "Chorea, childhood-onset, with psychomotor retardation [MIM: 616939]",
    "omimEntry": "607468",
    "inheritance": "AR"
  },
  {
    "gene": "GRIA3",
    "phenotype": "Intellectual developmental disorder, X-linked syndromic, Wu type [MIM: 300699]",
    "omimEntry": "305915",
    "inheritance": "XLR"
  },
  {
    "gene": "GRID2",
    "phenotype": "Spinocerebellar ataxia, autosomal recessive 18 [MIM: 616204]",
    "omimEntry": "602368",
    "inheritance": "AR"
  },
  {
    "gene": "GRIK2",
    "phenotype": "Intellectual developmental disorder, autosomal recessive 6 [MIM: 611092]; Neurodevelopmental disorder with impaired language and ataxia and with or without seizures [MIM: 619580]",
    "omimEntry": "138244",
    "inheritance": "AD, AR"
  },
  {
    "gene": "GRIN1",
    "phenotype": "Developmental and epileptic encephalopathy 101 [MIM: 619814]; Neurodevelopmental disorder with or without hyperkinetic movements and seizures, autosomal dominant [MIM: 614254]; Neurodevelopmental disorder with or without hyperkinetic movements and seizures, autosomal recessive [MIM: 617820]",
    "omimEntry": "138249",
    "inheritance": "AD, AR"
  },
  {
    "gene": "GRIN2B",
    "phenotype": "Developmental and epileptic encephalopathy 27 [MIM: 616139]; Intellectual developmental disorder, autosomal dominant 6, with or without seizures [MIM: 613970]",
    "omimEntry": "138252",
    "inheritance": "AD"
  },
  {
    "gene": "GRIN2D",
    "phenotype": "Developmental and epileptic encephalopathy 46 [MIM: 617162]",
    "omimEntry": "602717",
    "inheritance": "AD"
  },
  {
    "gene": "GRM1",
    "phenotype": "Spinocerebellar ataxia 44 [MIM: 617691]; Spinocerebellar ataxia, autosomal recessive 13 [MIM: 614831]",
    "omimEntry": "604473",
    "inheritance": "AD, AR"
  },
  {
    "gene": "GRN",
    "phenotype": "Aphasia, primary progressive [MIM: 607485];  Ceroid lipofuscinosis, neuronal, 11 [MIM: 614706]; Frontotemporal dementia 2 [MIM: 607485]",
    "omimEntry": "138945",
    "inheritance": "AD, AR"
  },
  {
    "gene": "GSS",
    "phenotype": "Anemia, congenital, nonspherocytic hemolytic, 6, glutatione synthetase deficient [MIM: 231900]; Glutathione synthetase deficiency [MIM: 266130]",
    "omimEntry": "601002",
    "inheritance": "AR"
  },
  {
    "gene": "GYG1",
    "phenotype": "Glycogen storage disease XV [MIM: 613507]; Polyglucosan body myopathy 2 [MIM: 616199]",
    "omimEntry": "603942",
    "inheritance": "AR"
  },
  {
    "gene": "GYS1",
    "phenotype": "Glycogen storage disease 0, muscle [MIM: 611556]",
    "omimEntry": "138570",
    "inheritance": "AR"
  },
  {
    "gene": "HACD1",
    "phenotype": "Congenital myopathy 11 [MIM: 619967]",
    "omimEntry": "610467",
    "inheritance": "AR"
  },
  {
    "gene": "HACE1",
    "phenotype": "Spastic paraplegia and psychomotor retardation with or without seizures [MIM: 616756]",
    "omimEntry": "610876",
    "inheritance": "AR"
  },
  {
    "gene": "HADHA",
    "phenotype": "Fatty liver, acute, of pregnancy [MIM: 609016]; HELLP syndrome, maternal, of pregnancy [MIM: 609016]; LCHAD deficiency [MIM: 609016]; Mitochondrial trifunctional protein deficiency 1 [MIM: 609015]",
    "omimEntry": "600890",
    "inheritance": "AR"
  },
  {
    "gene": "HADHB",
    "phenotype": "Mitochondrial trifunctional protein deficiency 2 [MIM: 620300]",
    "omimEntry": "143450",
    "inheritance": "AR"
  },
  {
    "gene": "HARS2",
    "phenotype": "Perrault syndrome 2 [MIM: 614926]",
    "omimEntry": "600783",
    "inheritance": "AR"
  },
  {
    "gene": "HCFC1",
    "phenotype": "Methylmalonic aciduria and homocysteinemia, cblX type [MIM: 309541]",
    "omimEntry": "300019",
    "inheritance": "XLR"
  },
  {
    "gene": "HCN1",
    "phenotype": "Developmental and epileptic encephalopathy 24 [MIM: 615871]; Generalized epilepsy with febrile seizures plus, type 10 [MIM: 618482]",
    "omimEntry": "602780",
    "inheritance": "AD"
  },
  {
    "gene": "HEPACAM",
    "phenotype": "Megalencephalic leukoencephalopathy with subcortical cysts 2A [MIM: 613925]; Megalencephalic leukoencephalopathy with subcortical cysts 2B, remitting, with or without impaired intellectual development [MIM: 613926]",
    "omimEntry": "611642",
    "inheritance": "AD, AR"
  },
  {
    "gene": "HERC1",
    "phenotype": "Macrocephaly, dysmorphic facies, and psychomotor retardation [MIM: 617011]",
    "omimEntry": "605109",
    "inheritance": "AR"
  },
  {
    "gene": "HEXA",
    "phenotype": "[Hex A pseudodeficiency] [MIM: 272800]; GM2-gangliosidosis, several forms [MIM: 272800]; Tay-Sachs disease [MIM: 272800]",
    "omimEntry": "606869",
    "inheritance": "AR"
  },
  {
    "gene": "HEXB",
    "phenotype": "Sandhoff disease, infantile, juvenile, and adult forms [MIM: 268800]",
    "omimEntry": "606873",
    "inheritance": "AR"
  },
  {
    "gene": "HIBCH",
    "phenotype": "3-hydroxyisobutryl-CoA hydrolase deficiency [MIM: 250620]",
    "omimEntry": "610690",
    "inheritance": "AR"
  },
  {
    "gene": "HIKESHI",
    "phenotype": "Leukodystrophy, hypomyelinating, 13 [MIM: 616881]",
    "omimEntry": "614908",
    "inheritance": "AR"
  },
  {
    "gene": "HK1",
    "phenotype": "Anemia, congenital, nonspherocytic hemolytic, 5, hexokinase deficient [MIM: 235700]; Neurodevelopmental disorder with visual defects and brain anomalies [MIM: 618547];  Neuropathy, hereditary motor and sensory, Russe type [MIM: 605285]; Retinitis pigmentosa 79 [MIM: 617460]",
    "omimEntry": "142600",
    "inheritance": "AD, AR"
  },
  {
    "gene": "HMBS",
    "phenotype": "Encephalopathy, porphyria-related [MIM:  620704]; Leukoencephalopathy, porphyria-related [MIM: 620711]; Porphyria, acute intermittent [MIM: 176000]; Porphyria, acute intermittent, nonerythroid variant [MIM: 176000]",
    "omimEntry": "609806",
    "inheritance": "AD, AR"
  },
  {
    "gene": "HMGCR",
    "phenotype": "[Low density lipoprotein cholesterol level QTL 3] [MIM: 620410]; [Statins, response to] [MIM: 620410]; Muscular dystrophy, limb-girdle, autosomal recessive 28 [MIM: 620375]",
    "omimEntry": "142910",
    "inheritance": "AR"
  },
  {
    "gene": "HNRNPA1",
    "phenotype": "Inclusion body myopathy with early-onset Paget disease without frontotemporal dementia 3  [MIM: 615424]; Myopathy, distal, 3 [MIM: 610099]; Amyotrophic lateral sclerosis 20 [MIM: 615426]",
    "omimEntry": "164017",
    "inheritance": "AD"
  },
  {
    "gene": "HNRNPA2B1",
    "phenotype": "Inclusion body myopathy with early-onset Paget disease with or without frontotemporal dementia 2 [MIM: 615422]; Oculopharyngeal muscular dystrophy 2 [MIM: 620460]",
    "omimEntry": "600124",
    "inheritance": "AD"
  },
  {
    "gene": "HNRNPDL",
    "phenotype": "Muscular dystrophy, limb-girdle, autosomal dominant 3 [MIM: 609155]",
    "omimEntry": "607137",
    "inheritance": "AD"
  },
  {
    "gene": "HNRNPH2",
    "phenotype": "Intellectual developmental disorder, X-linked syndromic, Bain type [MIM: 300986]",
    "omimEntry": "300610",
    "inheritance": "XLD"
  },
  {
    "gene": "HPCA",
    "phenotype": "Dystonia 2, torsion, autosomal recessive [MIM: 224500]",
    "omimEntry": "142622",
    "inheritance": "AR"
  },
  {
    "gene": "HPDL",
    "phenotype": "Neurodevelopmental disorder with progressive spasticity and brain white matter abnormalities [MIM: 619026]; Spastic paraplegia 83, autosomal recessive [MIM: 619027]",
    "omimEntry": "618994",
    "inheritance": "AR"
  },
  {
    "gene": "HPRT1",
    "phenotype": "Hyperuricemia, HPRT-related [MIM:300323]; Lesch-Nyhan syndrome [MIM:  300322]",
    "omimEntry": "308000",
    "inheritance": "XLR"
  },
  {
    "gene": "HSD17B10",
    "phenotype": "HSD10 mitochondrial disease [MIM: 300438]",
    "omimEntry": "300256",
    "inheritance": "XLD"
  },
  {
    "gene": "HSD17B4",
    "phenotype": "D-bifunctional protein deficiency [MIM: 261515]; Perrault syndrome 1 [MIM: 233400]",
    "omimEntry": "601860",
    "inheritance": "AR"
  },
  {
    "gene": "HSPB1",
    "phenotype": "Charcot-Marie-Tooth disease, axonal, type 2F [MIM: 606595]; Neuronopathy, distal hereditary motor, autosomal dominant 3 [MIM: 608634]",
    "omimEntry": "602195",
    "inheritance": "AD"
  },
  {
    "gene": "HSPB8",
    "phenotype": "Charcot-Marie-Tooth disease, axonal, type 2L [MIM: 608673]; Myopathy, myofibrillar, 13, with rimmed vacuoles [MIM: 621078]; Neuronopathy, distal hereditary motor, autosomal dominant 2 [MIM: 158590]",
    "omimEntry": "608014",
    "inheritance": "AD"
  },
  {
    "gene": "HSPD1",
    "phenotype": "Leukodystrophy, hypomyelinating, 4 [MIM: 612233]; Spastic paraplegia 13, autosomal dominant [MIM: 605280]",
    "omimEntry": "118190",
    "inheritance": "AD, AR"
  },
  {
    "gene": "HSPG2",
    "phenotype": "Dyssegmental dysplasia, Silverman-Handmaker type [MIM:  224410]; Schwartz-Jampel syndrome, type 1 [MIM: 255800]",
    "omimEntry": "142461",
    "inheritance": "AR"
  },
  {
    "gene": "HTRA1",
    "phenotype": "Cerebral arteriopathy, autosomal dominant, with subcortical infarcts and leukoencephalopathy 2 [MIM: 616779]; Cerebral arteriopathy, autosomal recessive, with subcortical infarcts and leukoencephalopathy 2 [MIM: 600142]",
    "omimEntry": "602194",
    "inheritance": "AD, AR"
  },
  {
    "gene": "HTRA2",
    "phenotype": "{Parkinson disease 13} [MIM: 610297]; 3-methylglutaconic aciduria, type VIII [MIM: 617248]",
    "omimEntry": "606441",
    "inheritance": "AR"
  },
  {
    "gene": "HTT",
    "phenotype": "Huntington disease [MIM: 143100]; Lopes-Maciel-Rodan syndrome [MIM: 617435]",
    "omimEntry": "613004",
    "inheritance": "AD, AR"
  },
  {
    "gene": "IBA57",
    "phenotype": "Spastic paraplegia 74, autosomal recessive [MIM: 616451]; Multiple mitochondrial dysfunctions syndrome 3 [MIM: 615330]",
    "omimEntry": "615316",
    "inheritance": "AR"
  },
  {
    "gene": "IFIH1",
    "phenotype": "Aicardi-Goutieres syndrome 7 [MIM: 615846]; Immunodeficiency 95 [MIM: 619773]; Singleton-Merten syndrome 1 [MIM: 182250]",
    "omimEntry": "606951",
    "inheritance": "AD, AR"
  },
  {
    "gene": "IFT140",
    "phenotype": "{Polycystic kidney disease 9, susceptibility to} [MIM: 621164]; Cranioectodermal dysplasia 5 [MIM: 621180]; Retinitis pigmentosa 80 [MIM: 617781]; Short-rib thoracic dysplasia 9 with or without polydactyly [MIM: 266920]",
    "omimEntry": "614620",
    "inheritance": "AD, AR"
  },
  {
    "gene": "IFT172",
    "phenotype": "Bardet-Biedl syndrome 20 [MIM: 619471]; Retinitis pigmentosa 71 [MIM: 616394]; Short-rib thoracic dysplasia 10 with or without polydactyly [MIM: 615630]",
    "omimEntry": "607386",
    "inheritance": "AR"
  },
  {
    "gene": "IFT27",
    "phenotype": "Bardet-Biedl syndrome 19 [MIM: 615996]",
    "omimEntry": "615870",
    "inheritance": "AR"
  },
  {
    "gene": "IGHMBP2",
    "phenotype": "Charcot-Marie-Tooth disease, axonal, type 2S [MIM: 616155]; Neuronopathy, distal hereditary motor, autosomal recessive 1 [MIM: 604320]",
    "omimEntry": "600502",
    "inheritance": "AR"
  },
  {
    "gene": "INPP5E",
    "phenotype": "Impaired intellectual development, truncal obesity, retinal dystrophy, and micropenis syndrome [MIM: 610156]; Joubert syndrome 1 [MIM: 213300]",
    "omimEntry": "613037",
    "inheritance": "AR"
  },
  {
    "gene": "INPP5K",
    "phenotype": "Muscular dystrophy, congenital, with cataracts and intellectual disability [MIM: 617404]",
    "omimEntry": "607875",
    "inheritance": "AR"
  },
  {
    "gene": "INTS8",
    "phenotype": "Neurodevelopmental disorder with cerebellar hypoplasia and spasticity [MIM: 618572]",
    "omimEntry": "611351",
    "inheritance": "AR"
  },
  {
    "gene": "IRF2BPL",
    "phenotype": "Neurodevelopmental disorder with regression, abnormal movements, loss of speech, and seizures [MIM: 618088]",
    "omimEntry": "611720",
    "inheritance": "AD"
  },
  {
    "gene": "ISCA2",
    "phenotype": "Multiple mitochondrial dysfunctions syndrome 4 [MIM: 616370]",
    "omimEntry": "615317",
    "inheritance": "AR"
  },
  {
    "gene": "ISCU",
    "phenotype": "Myopathy with lactic acidosis, hereditary [MIM: 255125]",
    "omimEntry": "611911",
    "inheritance": "AR"
  },
  {
    "gene": "ITGA7",
    "phenotype": "Muscular dystrophy, congenital, due to ITGA7 deficiency [MIM: 613204]",
    "omimEntry": "600536",
    "inheritance": "AR"
  },
  {
    "gene": "ITM2B",
    "phenotype": "Retinal dystrophy with inner retinal dysfunction and ganglion cell abnormalities  [MIM: 616079]; Dementia, familial British [MIM: 176500]; Dementia, familial Danish [MIM: 117300]",
    "omimEntry": "603904",
    "inheritance": "AD"
  },
  {
    "gene": "ITPR1",
    "phenotype": "Gillespie syndrome [MIM: 206700]; Spinocerebellar ataxia 15 [MIM: 606658];  Spinocerebellar ataxia 29, congenital nonprogressive [MIM: 117360]",
    "omimEntry": "147265",
    "inheritance": "AD, AR"
  },
  {
    "gene": "JAG2",
    "phenotype": "Muscular dystrophy, limb-girdle, autosomal recessive 27 [MIM: 619566]",
    "omimEntry": "602570",
    "inheritance": "AR"
  },
  {
    "gene": "JAM3",
    "phenotype": "Hemorrhagic destruction of the brain, subependymal calcification, and cataracts [MIM: 613730]",
    "omimEntry": "606871",
    "inheritance": "AR"
  },
  {
    "gene": "JPH3",
    "phenotype": "Huntington disease-like 2 [MIM: 606438]",
    "omimEntry": "605268",
    "inheritance": "AD"
  },
  {
    "gene": "KANK1",
    "phenotype": "Cerebral palsy, spastic quadriplegic, 2 [MIM: 612900]",
    "omimEntry": "607704",
    "inheritance": ""
  },
  {
    "gene": "KARS1",
    "phenotype": "Charcot-Marie-Tooth disease, recessive intermediate, B [MIM: 613641]; Deafness, autosomal recessive 89 [MIM: 613916]; Deafness, congenital, and adult-onset progressive leukoencephalopathy [MIM: 619196]; Leukoencephalopathy, progressive, infantile-onset, with or without deafness [MIM: 619147]",
    "omimEntry": "601421",
    "inheritance": "AR"
  },
  {
    "gene": "KATNIP",
    "phenotype": "Joubert syndrome 26 [MIM: 616784]",
    "omimEntry": "616650",
    "inheritance": "AR"
  },
  {
    "gene": "KBTBD13",
    "phenotype": "Nemaline myopathy 6, autosomal dominant [MIM: 609273]",
    "omimEntry": "613727",
    "inheritance": "AD"
  },
  {
    "gene": "KCNA1",
    "phenotype": "Episodic ataxia/myokymia syndrome [MIM: 160120]",
    "omimEntry": "176260",
    "inheritance": "AD"
  },
  {
    "gene": "KCNA2",
    "phenotype": "Developmental and epileptic encephalopathy 32 [MIM: 616366]",
    "omimEntry": "176262",
    "inheritance": "AD"
  },
  {
    "gene": "KCNA4",
    "phenotype": "Microcephaly, cataracts, impaired intellectual development, and dystonia with abnormal striatum [MIM: 618284]",
    "omimEntry": "176266",
    "inheritance": "AR"
  },
  {
    "gene": "KCNC1",
    "phenotype": "Epilepsy, progressive myoclonic 7 [MIM: 616187]",
    "omimEntry": "176258",
    "inheritance": "AD"
  },
  {
    "gene": "KCNC3",
    "phenotype": "Spinocerebellar ataxia 13 [MIM: 605259]",
    "omimEntry": "176264",
    "inheritance": "AD"
  },
  {
    "gene": "KCND3",
    "phenotype": "Brugada syndrome 9 [MIM: 616399]; Spinocerebellar ataxia 19 [MIM: 607346]",
    "omimEntry": "605411",
    "inheritance": "AD"
  },
  {
    "gene": "KCNJ10",
    "phenotype": "Enlarged vestibular aqueduct, digenic [MIM: 600791]; SESAME syndrome [MIM: 612780]",
    "omimEntry": "602208",
    "inheritance": "AR"
  },
  {
    "gene": "KCNJ6",
    "phenotype": "Keppen-Lubinsky syndrome [MIM: 614098]",
    "omimEntry": "600877",
    "inheritance": "AD"
  },
  {
    "gene": "KCNMA1",
    "phenotype": "{Epilepsy, idiopathic generalized, susceptibility to, 16} [MIM: 618596]; Cerebellar atrophy, developmental delay, and seizures [MIM: 617643]; Liang-Wang syndrome [MIM: 618729]; Paroxysmal nonkinesigenic dyskinesia, 3, with or without generalized epilepsy [MIM: 609446]",
    "omimEntry": "600150",
    "inheritance": "AD, AR"
  },
  {
    "gene": "KCNQ2",
    "phenotype": "Developmental and epileptic encephalopathy 7 [MIM:  613720]; Myokymia [MIM: 121200]; Seizures, benign neonatal, 1 [MIM: 121200]",
    "omimEntry": "602235",
    "inheritance": "AD"
  },
  {
    "gene": "KCNT1",
    "phenotype": "Developmental and epileptic encephalopathy 14 [MIM: 614959]; Epilepsy nocturnal frontal lobe, 5 [MIM: 615005]",
    "omimEntry": "608167",
    "inheritance": "AD"
  },
  {
    "gene": "KCTD17",
    "phenotype": "Dystonia 26, myoclonic [MIM: 616398]",
    "omimEntry": "616386",
    "inheritance": "AD"
  },
  {
    "gene": "KCTD7",
    "phenotype": "Epilepsy, progressive myoclonic 3, with or without intracellular inclusions [MIM: 611726]",
    "omimEntry": "611725",
    "inheritance": "AR"
  },
  {
    "gene": "KDM5C",
    "phenotype": "Intellectual developmental disorder, X-linked syndromic, Claes-Jensen type [MIM: 300534]",
    "omimEntry": "314690",
    "inheritance": "XLR"
  },
  {
    "gene": "KIAA0586",
    "phenotype": "Joubert syndrome 23 [MIM: 616490]; Short-rib thoracic dysplasia 14 with polydactyly [MIM: 616546]",
    "omimEntry": "610178",
    "inheritance": "AR"
  },
  {
    "gene": "KIDINS220",
    "phenotype": "Spastic paraplegia, intellectual disability, nystagmus, and obesity [MIM: 617296]; Ventriculomegaly and arthrogryposis [MIM: 619501]",
    "omimEntry": "615759",
    "inheritance": "AD, AR"
  },
  {
    "gene": "KIF1A",
    "phenotype": "NESCAV syndrome [MIM: 614255]; Neuropathy, hereditary sensory, type IIC [MIM: 614213]; Spastic paraplegia 30, autosomal dominant [MIM: 610357]; Spastic paraplegia 30, autosomal recessive [MIM: 620607]",
    "omimEntry": "601255",
    "inheritance": "AD, AR"
  },
  {
    "gene": "KIF1B",
    "phenotype": "{Neuroblastoma, susceptibility to, 1} [MIM: 256700]; Charcot-Marie-Tooth disease, type 2A1 [MIM: 118210]",
    "omimEntry": "605995",
    "inheritance": "AD, SMu"
  },
  {
    "gene": "KIF1C",
    "phenotype": "Spastic ataxia 2, autosomal recessive [MIM: 611302]",
    "omimEntry": "603060",
    "inheritance": "AR"
  },
  {
    "gene": "KIF2A",
    "phenotype": "Cortical dysplasia, complex, with other brain malformations 3 [MIM: 615411]",
    "omimEntry": "602591",
    "inheritance": "AD"
  },
  {
    "gene": "KIF5A",
    "phenotype": "{Amyotrophic lateral sclerosis, susceptibility to, 25} [MIM: 617921]; Myoclonus, intractable, neonatal [MIM: 617235]; Spastic paraplegia 10, autosomal dominant [MIM: 604187]",
    "omimEntry": "602821",
    "inheritance": "AD"
  },
  {
    "gene": "KIF5C",
    "phenotype": "Cortical dysplasia, complex, with other brain malformations 2 [MIM: 615282]",
    "omimEntry": "604593",
    "inheritance": "AD"
  },
  {
    "gene": "KIF7",
    "phenotype": "Al-Gazali-Bakalinova syndrome [MIM: 607131]; Hydrolethalus syndrome 2 [MIM:  614120]; Acrocallosal syndrome [MIM: 200990]; Joubert syndrome 12 [MIM: 200990]",
    "omimEntry": "611254",
    "inheritance": "AR"
  },
  {
    "gene": "KLC2",
    "phenotype": "Spastic paraplegia, optic atrophy, and neuropathy [MIM: 609541]",
    "omimEntry": "611729",
    "inheritance": "AR"
  },
  {
    "gene": "KLHL40",
    "phenotype": "Nemaline myopathy 8, autosomal recessive [MIM: 615348]",
    "omimEntry": "615340",
    "inheritance": "AR"
  },
  {
    "gene": "KLHL41",
    "phenotype": "Nemaline myopathy 9 [MIM: 615731]",
    "omimEntry": "607701",
    "inheritance": "AR"
  },
  {
    "gene": "KMT2B",
    "phenotype": "Dystonia 28, childhood-onset [MIM: 617284]; Intellectual developmental disorder, autosomal dominant 68 [MIM: 619934]",
    "omimEntry": "606834",
    "inheritance": "AD"
  },
  {
    "gene": "KY",
    "phenotype": "Myopathy, myofibrillar, 7 [MIM: 617114]",
    "omimEntry": "605739",
    "inheritance": "AR"
  },
  {
    "gene": "L1CAM",
    "phenotype": "Corpus callosum, partial agenesis of [MIM: 304100]; Hydrocephalus, congenital, X-linked [MIM: 307000]; MASA syndrome [MIM: 303350]",
    "omimEntry": "308840",
    "inheritance": "XLR"
  },
  {
    "gene": "L2HGDH",
    "phenotype": "L-2-hydroxyglutaric aciduria [MIM: 236792]",
    "omimEntry": "609584",
    "inheritance": "AR"
  },
  {
    "gene": "LAGE3",
    "phenotype": "Galloway-Mowat syndrome 2, X-linked [MIM: 301006]",
    "omimEntry": "300060",
    "inheritance": "XLR"
  },
  {
    "gene": "LAMA2",
    "phenotype": "Muscular dystrophy, congenital, merosin deficient or partially deficient [MIM: 607855]; Muscular dystrophy, limb-girdle, autosomal recessive 23 [MIM: 618138]",
    "omimEntry": "156225",
    "inheritance": "AR"
  },
  {
    "gene": "LAMB2",
    "phenotype": "Nephrotic syndrome, type 5, with or without ocular abnormalities [MIM: 614199]; Pierson syndrome [MIM: 609049]",
    "omimEntry": "150325",
    "inheritance": "AR"
  },
  {
    "gene": "LAMP2",
    "phenotype": "Danon disease [MIM: 300257]",
    "omimEntry": "309060",
    "inheritance": "XLD"
  },
  {
    "gene": "LARGE1",
    "phenotype": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 6 [MIM: 613154]; Muscular dystrophy-dystroglycanopathy (congenital with impaired intellectual development), type B, 6 [MIM: 608840]",
    "omimEntry": "603590",
    "inheritance": "AR"
  },
  {
    "gene": "LDB3",
    "phenotype": "Cardiomyopathy, dilated, 1C, with or without LVNC [MIM: 601493]; Cardiomyopathy, dilated, 2L [MIM: 621237]; Cardiomyopathy, hypertrophic, 24 [MIM: 601493]; Left ventricular noncompaction 3 [MIM: 601493]; Myopathy, myofibrillar, 4 [MIM: 609452]",
    "omimEntry": "605906",
    "inheritance": "AD, AR"
  },
  {
    "gene": "LDHA",
    "phenotype": "Glycogen storage disease XI [MIM: 612933]",
    "omimEntry": "150000",
    "inheritance": "AR"
  },
  {
    "gene": "LETM1",
    "phenotype": "Neurodegeneration, childhood-onset, with multisystem involvement due to mitochondrial dysfunction [MIM: 620089]",
    "omimEntry": "604407",
    "inheritance": "AR"
  },
  {
    "gene": "LGI4",
    "phenotype": "Arthrogryposis multiplex congenita 1, neurogenic, with myelin defect [MIM: 617468]",
    "omimEntry": "608303",
    "inheritance": "AR"
  },
  {
    "gene": "LIAS",
    "phenotype": "Hyperglycinemia, lactic acidosis, and seizures [MIM: 614462]",
    "omimEntry": "607031",
    "inheritance": "AR"
  },
  {
    "gene": "LIMS2",
    "phenotype": "Muscular dystrophy, autosomal recessive, with cardiomyopathy and triangular tongue [MIM: 616827]",
    "omimEntry": "607908",
    "inheritance": "AR"
  },
  {
    "gene": "LIPT1",
    "phenotype": "Lipoyltransferase 1 deficiency [MIM: 616299]",
    "omimEntry": "610284",
    "inheritance": "AR"
  },
  {
    "gene": "LIPT2",
    "phenotype": "Encephalopathy, neonatal severe, with lactic acidosis and brain abnormalities [MIM: 617668]",
    "omimEntry": "617659",
    "inheritance": "AR"
  },
  {
    "gene": "LMNA",
    "phenotype": "Cardiomyopathy, dilated, 1A [MIM: 115200]; Charcot-Marie-Tooth disease, type 2B1 [MIM: 605588]; Emery-Dreifuss muscular dystrophy 2, autosomal dominant [ MIM: 181350]; Emery-Dreifuss muscular dystrophy 3, autosomal recessive [MIM: 616516]; Heart-hand syndrome, Slovenian type [MIM: 610140]; Hutchinson-Gilford progeria [MIM: 176670]; Lipodystrophy, familial partial, type 2 [MIM: 151600]; Malouf syndrome [MIM: 212112]; Mandibuloacral dysplasia [MIM: 248370]; Muscular dystrophy, congenital [MIM: 613205]; Restrictive dermopathy 2 [MIM: 619793]",
    "omimEntry": "150330",
    "inheritance": "AD, AR"
  },
  {
    "gene": "LMNB1",
    "phenotype": "icrocephaly 26, primary, autosomal dominant [MIM: 619179]",
    "omimEntry": "150340",
    "inheritance": "AD"
  },
  {
    "gene": "LMNB2",
    "phenotype": "Epilepsy, progressive myoclonic, 9 [MIM: 616540]; {Lipodystrophy, partial, acquired, susceptibility to} [MIM: 608709]; Microcephaly 27, primary, autosomal dominant [MIM: 619180]",
    "omimEntry": "150341",
    "inheritance": "AD. AR"
  },
  {
    "gene": "LMOD3",
    "phenotype": "Nemaline myopathy 10 [MIM: 616165]",
    "omimEntry": "616112",
    "inheritance": "AR"
  },
  {
    "gene": "LPIN1",
    "phenotype": "Myoglobinuria, acute recurrent, autosomal recessive [MIM: 268200]",
    "omimEntry": "605518",
    "inheritance": "AR"
  },
  {
    "gene": "LRP12",
    "phenotype": "Amyotrophic lateral sclerosis 28 [MIM: 620452]; Oculopharyngodistal myopathy 1 [MIM: 164310]",
    "omimEntry": "618299",
    "inheritance": "AD"
  },
  {
    "gene": "LRP4",
    "phenotype": "Myasthenic syndrome, congenital, 17 [MIM: 616304]; Cenani-Lenz syndactyly syndrome [MIM: 212780]; Sclerosteosis 2 [MIM: 614305]",
    "omimEntry": "604270",
    "inheritance": "AD, AR"
  },
  {
    "gene": "LRPPRC",
    "phenotype": "Mitochondrial complex IV deficiency, nuclear type 5, (French-Canadian) [MIM: 220111]",
    "omimEntry": "607544",
    "inheritance": "AR"
  },
  {
    "gene": "LRRK2",
    "phenotype": "{Parkinson disease 8} [MIM: 607060]",
    "omimEntry": "609007",
    "inheritance": "AD"
  },
  {
    "gene": "LRSAM1",
    "phenotype": "Charcot-Marie-Tooth disease, axonal, type 2P [MIM: 614436]",
    "omimEntry": "610933",
    "inheritance": "AD, AR"
  },
  {
    "gene": "LYRM7",
    "phenotype": "Mitochondrial complex III deficiency, nuclear type 8 [MIM: 615838]",
    "omimEntry": "615831",
    "inheritance": "AR"
  },
  {
    "gene": "LYST",
    "phenotype": "Chediak-Higashi syndrome [MIM: 214500]",
    "omimEntry": "606897",
    "inheritance": "AR"
  },
  {
    "gene": "MAG",
    "phenotype": "Spastic paraplegia 75, autosomal recessive [MIM: 616680]",
    "omimEntry": "159460",
    "inheritance": "AR"
  },
  {
    "gene": "MAN2B1",
    "phenotype": "Mannosidosis, alpha-, types I and II [MIM: 248500]",
    "omimEntry": "609458",
    "inheritance": "AR"
  },
  {
    "gene": "MAP3K20",
    "phenotype": "Centronuclear myopathy 6 with fiber-type disproportion [MIM: 617760]; Split-foot malformation with mesoaxial polydactyly [MIM: 616890]",
    "omimEntry": "609479",
    "inheritance": "AR"
  },
  {
    "gene": "MAPT",
    "phenotype": "{Parkinson disease, susceptibility to} [MIM: 168600]; Frontotemporal dementia 1, with or without parkinsonism [MIM: 600274]; Pick disease [MIM: 172700]; Supranuclear palsy, progressive [MIM: 601104]; Supranuclear palsy, progressive atypical [MIM: 260540]",
    "omimEntry": "157140",
    "inheritance": "AD, AR, Mu"
  },
  {
    "gene": "MARS1",
    "phenotype": "Trichothiodystrophy 9, nonphotosensitive [MIM: 619692]; Charcot-Marie-Tooth disease, axonal, type 2U [MIM: 616280]; Interstitial lung and liver disease [MIM: 615486]; Spastic paraplegia 70, autosomal recessive [MIM: 620323]",
    "omimEntry": "156560",
    "inheritance": "AD, AR"
  },
  {
    "gene": "MARS2",
    "phenotype": "Combined oxidative phosphorylation deficiency 25 [MIM: 616430]; Spastic ataxia 3, autosomal recessive [MIM: 611390]",
    "omimEntry": "609728",
    "inheritance": "AR"
  },
  {
    "gene": "MAT1A",
    "phenotype": "Hypermethioninemia, persistent, autosomal dominant, due to methionine adenosyltransferase I/III deficiency [MIM: 250850]; Methionine adenosyltransferase deficiency, autosomal recessive [MIM: 250850]",
    "omimEntry": "610550",
    "inheritance": "AD, AR"
  },
  {
    "gene": "MATR3",
    "phenotype": "Amyotrophic lateral sclerosis 21 [MIM: 606070]",
    "omimEntry": "164015",
    "inheritance": "AD"
  },
  {
    "gene": "MB",
    "phenotype": "Myopathy, sarcoplasmic body [MIM: 620286]",
    "omimEntry": "160000",
    "inheritance": "AD"
  },
  {
    "gene": "MBD5",
    "phenotype": "Intellectual developmental disorder, autosomal dominant 1 [MIM: 156200]",
    "omimEntry": "611472",
    "inheritance": "AD"
  },
  {
    "gene": "MCCC2",
    "phenotype": "3-Methylcrotonyl-CoA carboxylase 2 deficiency [MIM: 210210]",
    "omimEntry": "609014",
    "inheritance": "AR"
  },
  {
    "gene": "MCOLN1",
    "phenotype": "Lisch epithelial corneal dystrophy [MIM: 620763]; Mucolipidosis IV [MIM: 252650]",
    "omimEntry": "605248",
    "inheritance": "AD, AR"
  },
  {
    "gene": "MDH2",
    "phenotype": "Developmental and epileptic encephalopathy 51 [MIM: 617339]",
    "omimEntry": "154100",
    "inheritance": "AR"
  },
  {
    "gene": "MECP2",
    "phenotype": "{Autism susceptibility, X-linked 3} [MIM: 300496]; Encephalopathy, neonatal severe [MIM: 300673];\nIntellectual developmental disorder, X-linked syndromic 13 [MIM: 300055]; Intellectual developmental disorder, X-linked syndromic, Lubs type [MIM: 300260]; Rett syndrome [MIM: 312750]; Rett syndrome, atypical [MIM: 312750];Rett syndrome, preserved speech variant [MIM: 312750]",
    "omimEntry": "300005",
    "inheritance": "XL, XLR, XLD"
  },
  {
    "gene": "MECR",
    "phenotype": "Dystonia, childhood-onset, with optic atrophy and basal ganglia abnormalities [MIM: 617282]; Optic atrophy 16 [MIM: 620629]",
    "omimEntry": "608205",
    "inheritance": "AR"
  },
  {
    "gene": "MED13L",
    "phenotype": "Impaired intellectual development and distinctive facial features with or without cardiac defects [MIM: 616789]",
    "omimEntry": "608771",
    "inheritance": "AD"
  },
  {
    "gene": "MED17",
    "phenotype": "Microcephaly, postnatal progressive, with seizures and brain atrophy [MIM: 613668]",
    "omimEntry": "603810",
    "inheritance": "AR"
  },
  {
    "gene": "MED25",
    "phenotype": "Basel-Vanagaite-Smirin-Yosef syndrome [MIM: 616449]",
    "omimEntry": "610197",
    "inheritance": "AR"
  },
  {
    "gene": "MEGF10",
    "phenotype": "Congenital myopathy 10A, severe variant [MIM: 614399]; Congenital myopathy 10B, mild variant [MIM: 620249]",
    "omimEntry": "612453",
    "inheritance": "AR"
  },
  {
    "gene": "MFF",
    "phenotype": "Encephalopathy due to defective mitochondrial and peroxisomal fission 2 [MIM: 617086]",
    "omimEntry": "614785",
    "inheritance": "AR"
  },
  {
    "gene": "MFN2",
    "phenotype": "Charcot-Marie-Tooth disease, axonal, type 2A2A [MIM: 609260]; Charcot-Marie-Tooth disease, axonal, type 2A2B [MIM: 617087]; Hereditary motor and sensory neuropathy VIA [MIM: 601152]; Lipomatosis, multiple symmetric, with or without peripheral neuropathy [MIM: 151800]",
    "omimEntry": "608507",
    "inheritance": "AD, AR"
  },
  {
    "gene": "MFSD2A",
    "phenotype": "Neurodevelopmental disorder with progressive microcephaly, spasticity, and brain abnormalities [MIM: 616486]",
    "omimEntry": "614397",
    "inheritance": "AR"
  },
  {
    "gene": "MFSD8",
    "phenotype": "Ceroid lipofuscinosis, neuronal, 7 [MIM: 610951]; Macular dystrophy with central cone involvement [MIM: 616170]",
    "omimEntry": "611124",
    "inheritance": "AR"
  },
  {
    "gene": "MGME1",
    "phenotype": "Mitochondrial DNA depletion syndrome 11 [MIM: 615084]",
    "omimEntry": "615076",
    "inheritance": "AR"
  },
  {
    "gene": "MICU1",
    "phenotype": "Myopathy with extrapyramidal signs [MIM: 615673]",
    "omimEntry": "605084",
    "inheritance": "AR"
  },
  {
    "gene": "MIPEP",
    "phenotype": "Combined oxidative phosphorylation deficiency 31 [MIM: 617228]",
    "omimEntry": "602241",
    "inheritance": "AR"
  },
  {
    "gene": "MKS1",
    "phenotype": "Bardet-Biedl syndrome 13 [MIM: 615990]; Joubert syndrome 28 [MIM: 617121]; Meckel syndrome 1 [MIM: 249000]",
    "omimEntry": "609883",
    "inheritance": "AR"
  },
  {
    "gene": "MLC1",
    "phenotype": "Megalencephalic leukoencephalopathy with subcortical cysts 1 [MIM: 604004]",
    "omimEntry": "605908",
    "inheritance": "AR"
  },
  {
    "gene": "MLIP",
    "phenotype": "Myopathy with myalgia, increased serum creatine kinase, and with or without episodic rhabdomyolysis [MIM: 620138]",
    "omimEntry": "614106",
    "inheritance": "AR"
  },
  {
    "gene": "MMACHC",
    "phenotype": "Methylmalonic aciduria and homocystinuria, cblC type [MIM: 277400]",
    "omimEntry": "609831",
    "inheritance": "AR"
  },
  {
    "gene": "MMADHC",
    "phenotype": "Homocystinuria-megaloblastic anemia, cblD type [MIM: 620952]; Methylmalonic aciduria and homocystinuria, cblD type [MIM: 277410]; Methylmalonic aciduria, cblD type [MIM: 620953]",
    "omimEntry": "611935",
    "inheritance": "AR"
  },
  {
    "gene": "MME",
    "phenotype": "Spinocerebellar ataxia 43 [MIM: 617018]; Charcot-Marie-Tooth disease, axonal, type 2T [MIM: 617017]",
    "omimEntry": "120520",
    "inheritance": "AD, AR"
  },
  {
    "gene": "MOCS1",
    "phenotype": "Molybdenum cofactor deficiency A [MIM: 252150]",
    "omimEntry": "603707",
    "inheritance": "AR"
  },
  {
    "gene": "MOCS2",
    "phenotype": "Molybdenum cofactor deficiency B1 [MIM: 252160]",
    "omimEntry": "603708",
    "inheritance": "AR"
  },
  {
    "gene": "MORC2",
    "phenotype": "Charcot-Marie-Tooth disease, axonal, type 2Z [MIM: 616688]; Developmental delay, impaired growth, dysmorphic facies, and axonal neuropathy [MIM: 619090]",
    "omimEntry": "616661",
    "inheritance": "AD"
  },
  {
    "gene": "MPDU1",
    "phenotype": "Congenital disorder of glycosylation, type If [MIM: 609180]",
    "omimEntry": "604041",
    "inheritance": "AR"
  },
  {
    "gene": "MPV17",
    "phenotype": "Charcot-Marie-Tooth disease, axonal, type 2EE [MIM: 618400]; Mitochondrial DNA depletion syndrome 6 (hepatocerebral type) [MIM: 256810]",
    "omimEntry": "137960",
    "inheritance": "AR"
  },
  {
    "gene": "MPZ",
    "phenotype": "Charcot-Marie-Tooth disease, dominant intermediate D [MIM: 607791]; Charcot-Marie-Tooth disease, type 1B [MIM: 118200]; Charcot-Marie-Tooth disease, type 2I [MIM: 607677]; Charcot-Marie-Tooth disease, type 2J [MIM: 607736]; Dejerine-Sottas disease [MIM: 145900]; Hypomyelinating neuropathy, congenital, 2 [MIM: 618184]; Roussy-Levy syndrome [MIM: 180800]",
    "omimEntry": "159440",
    "inheritance": "AD, AR"
  },
  {
    "gene": "MRE11",
    "phenotype": "Ataxia-telangiectasia-like disorder 1 [MIM: 604391]",
    "omimEntry": "600814",
    "inheritance": "AR"
  },
  {
    "gene": "MRPS22",
    "phenotype": "Combined oxidative phosphorylation deficiency 5 [MIM: 611719]; Ovarian dysgenesis 7 [MIM: 618117]",
    "omimEntry": "605810",
    "inheritance": "AR"
  },
  {
    "gene": "MRPS34",
    "phenotype": "Combined oxidative phosphorylation deficiency 32 [MIM: 617664]",
    "omimEntry": "611994",
    "inheritance": "AR"
  },
  {
    "gene": "MTM1",
    "phenotype": "Myopathy, centronuclear, X-linked [MIM: 310400]",
    "omimEntry": "300415",
    "inheritance": "XLR"
  },
  {
    "gene": "MTMR14",
    "phenotype": "{Centronuclear myopathy, autosomal, modifier of} [MIM: 160150]",
    "omimEntry": "611089",
    "inheritance": "AD"
  },
  {
    "gene": "MTO1",
    "phenotype": "Combined oxidative phosphorylation deficiency 10 [MIM: 614702]",
    "omimEntry": "614667",
    "inheritance": "AR"
  },
  {
    "gene": "MTPAP",
    "phenotype": "Spastic ataxia 4, autosomal recessive [MIM: 613672]",
    "omimEntry": "613669",
    "inheritance": "AR"
  },
  {
    "gene": "MTRFR",
    "phenotype": "Combined oxidative phosphorylation deficiency 7 [MIM: 613559]; Spastic paraplegia 55, autosomal recessive\t [MIM: 615035]",
    "omimEntry": "613541",
    "inheritance": "AR"
  },
  {
    "gene": "MTTP",
    "phenotype": "Abetalipoproteinemia [MIM: 200100]",
    "omimEntry": "157147",
    "inheritance": "AR"
  },
  {
    "gene": "MUSK",
    "phenotype": "Fetal akinesia deformation sequence 1 [MIM: 208150]; Myasthenic syndrome, congenital, 9, associated with acetylcholine receptor deficiency [MIM: 616325]",
    "omimEntry": "601296",
    "inheritance": "AR"
  },
  {
    "gene": "MVK",
    "phenotype": "Hyper-IgD syndrome [MIM: 260920]; Mevalonic aciduria [MIM: 610377]; Porokeratosis 3, multiple types [MIM: 175900]",
    "omimEntry": "251170",
    "inheritance": "AD, AR"
  },
  {
    "gene": "MYBPC1",
    "phenotype": "Arthrogryposis, distal, type 1B [MIM: 614335]; Congenital myopathy 16 [MIM; 618524]; Lethal congenital contracture syndrome 4 [MIM: 614915]",
    "omimEntry": "160794",
    "inheritance": "AD, AR"
  },
  {
    "gene": "MYH14",
    "phenotype": "Peripheral neuropathy, myopathy, hoarseness, and hearing loss [MIM: 614369]; Deafness, autosomal dominant 4A [MIM: 600652]",
    "omimEntry": "608568",
    "inheritance": "AD"
  },
  {
    "gene": "MYH2",
    "phenotype": "Congenital myopathy 6 with ophthalmoplegia [MIM: 605637]",
    "omimEntry": "160740",
    "inheritance": "AD, AR"
  },
  {
    "gene": "MYH3",
    "phenotype": "Arthrogryposis, distal, type 2A (Freeman-Sheldon) [MIM: 193700]; Arthrogryposis, distal, type 2B3 (Sheldon-Hall) [MIM: 618436]; Contractures, pterygia, and spondylocarpostarsal fusion syndrome 1A [MIM: 178110]; Contractures, pterygia, and spondylocarpotarsal fusion syndrome 1B [MIM: 618469]",
    "omimEntry": "160720",
    "inheritance": "AD, AR"
  },
  {
    "gene": "MYH7",
    "phenotype": "Cardiomyopathy, dilated, 1S [MIM: 613426]; Cardiomyopathy, hypertrophic, 1 [MIM: 192600]; Congenital myopathy 7A, myosin storage, autosomal dominant [MIM: 608358]; Congenital myopathy 7B, myosin storage, autosomal recessive [MIM: 255160]; Laing distal myopathy [MIM: 160500]; Left ventricular noncompaction 5 [MIM: 613426]",
    "omimEntry": "160760",
    "inheritance": "AD, AR, DD"
  },
  {
    "gene": "MYL1",
    "phenotype": "Congenital myopathy 14 [MIM: 618414]",
    "omimEntry": "160780",
    "inheritance": "AR"
  },
  {
    "gene": "MYL2",
    "phenotype": "Cardiomyopathy, hypertrophic, 10 [MIM: 608758]; Myopathy, myofibrillar, 12, infantile-onset, with cardiomyopathy [MIM: 619424]",
    "omimEntry": "160781",
    "inheritance": "AD, AR"
  },
  {
    "gene": "MYMK",
    "phenotype": "Carey-Fineman-Ziter syndrome [MIM: 254940]",
    "omimEntry": "615345",
    "inheritance": "AR"
  },
  {
    "gene": "MYO18B",
    "phenotype": "Klippel-Feil syndrome 4, autosomal recessive, with myopathy and facial dysmorphism [MIM: 616549]",
    "omimEntry": "607295",
    "inheritance": "AR"
  },
  {
    "gene": "MYO7A",
    "phenotype": "Deafness, autosomal dominant 11; 601317; Deafness, autosomal recessive 2 [MIM: 600060]; Usher syndrome, type 1B [MIM: 276900]",
    "omimEntry": "276903",
    "inheritance": "AD, AR"
  },
  {
    "gene": "MYO9A",
    "phenotype": "Myasthenic syndrome, congenital, 24, presynaptic [MIM: 618198]",
    "omimEntry": "604875",
    "inheritance": "AR"
  },
  {
    "gene": "MYOD1",
    "phenotype": "Congenital myopathy 17 [MIM: 618975]",
    "omimEntry": "159970",
    "inheritance": "AR"
  },
  {
    "gene": "MYOT",
    "phenotype": "Myopathy, myofibrillar, 3 [MIM: 609200]",
    "omimEntry": "604103",
    "inheritance": "AD"
  },
  {
    "gene": "MYPN",
    "phenotype": "Cardiomyopathy, dilated, 1KK [MIM: 615248]; Cardiomyopathy, familial restrictive, 4 [MIM: 615248]; Cardiomyopathy, hypertrophic, 22 [MIM: 615248]; Congenital myopathy 24 [MIM: 617336]",
    "omimEntry": "608517",
    "inheritance": "AD, AR"
  },
  {
    "gene": "NADK2",
    "phenotype": "2,4-dienoyl-CoA reductase deficiency [MIM: 616034]",
    "omimEntry": "615787",
    "inheritance": "AR"
  },
  {
    "gene": "NAGA",
    "phenotype": "Kanzaki disease [MIM: 609242]; Schindler disease, type I [MIM: 609241]; Schindler disease, type III [MIM: 609241]",
    "omimEntry": "104170",
    "inheritance": "AR"
  },
  {
    "gene": "NAGLU",
    "phenotype": "Charcot-Marie-Tooth disease, axonal, type 2V [MIM: 616491]; Mucopolysaccharidosis type IIIB (Sanfilippo B) [MIM: 252920]",
    "omimEntry": "609701",
    "inheritance": "AD. AR"
  },
  {
    "gene": "NALCN",
    "phenotype": "Congenital contractures of the limbs and face, hypotonia, and developmental delay [MIM: 616266]; Hypotonia, infantile, with psychomotor retardation and characteristic facies 1 [MIM: 615419]",
    "omimEntry": "611549",
    "inheritance": "AD, AR"
  },
  {
    "gene": "NANS",
    "phenotype": "Spondyloepimetaphyseal dysplasia, Genevieve type [MIM: 610442]",
    "omimEntry": "605202",
    "inheritance": "AR"
  },
  {
    "gene": "NAT8L",
    "phenotype": "N-acetylaspartate deficiency [MIM: 614063]",
    "omimEntry": "610647",
    "inheritance": "AR"
  },
  {
    "gene": "NAXE",
    "phenotype": "Encephalopathy, progressive, early-onset, with brain edema and/or leukoencephalopathy [MIM: 617186]",
    "omimEntry": "608862",
    "inheritance": "AR"
  },
  {
    "gene": "NDE1",
    "phenotype": "Lissencephaly 4 (with microcephaly) [MIM: 614019]; Microhydranencephaly [MIM: 605013]",
    "omimEntry": "609449",
    "inheritance": "AR"
  },
  {
    "gene": "NDRG1",
    "phenotype": "Charcot-Marie-Tooth disease, type 4D [MIM: 601455]",
    "omimEntry": "605262",
    "inheritance": "AR"
  },
  {
    "gene": "NDUFA1",
    "phenotype": "Mitochondrial complex I deficiency, nuclear type 12 [MIM: 301020]",
    "omimEntry": "300078",
    "inheritance": "XLR"
  },
  {
    "gene": "NDUFA10",
    "phenotype": "Mitochondrial complex I deficiency, nuclear type 22 [MIM: 618243]",
    "omimEntry": "603835",
    "inheritance": "AR"
  },
  {
    "gene": "NDUFA11",
    "phenotype": "Mitochondrial complex I deficiency, nuclear type 14 [MIM: 618236]",
    "omimEntry": "612638",
    "inheritance": "AR"
  },
  {
    "gene": "NDUFA12",
    "phenotype": "Mitochondrial complex I deficiency, nuclear type 23 [MIM: 618244]",
    "omimEntry": "614530",
    "inheritance": "AR"
  },
  {
    "gene": "NDUFA13",
    "phenotype": "{Thyroid carcinoma, Hurthle cell}\t [MIM: 607464]; Mitochondrial complex I deficiency, nuclear type 28 [MIM: 618249]",
    "omimEntry": "609435",
    "inheritance": "AR"
  },
  {
    "gene": "NDUFA2",
    "phenotype": "Mitochondrial complex I deficiency, nuclear type 13 [MIM: 618235]",
    "omimEntry": "602137",
    "inheritance": "AR"
  },
  {
    "gene": "NDUFA9",
    "phenotype": "Mitochondrial complex I deficiency, nuclear type 26 [MIM: 618247]",
    "omimEntry": "603834",
    "inheritance": "AR"
  },
  {
    "gene": "NDUFAF1",
    "phenotype": "Mitochondrial complex I deficiency, nuclear type 11 [MIM: 618234]",
    "omimEntry": "606934",
    "inheritance": "AR"
  },
  {
    "gene": "NDUFAF2",
    "phenotype": "Mitochondrial complex I deficiency, nuclear type 10 [MIM: 618233]",
    "omimEntry": "609653",
    "inheritance": "AR"
  },
  {
    "gene": "NDUFAF3",
    "phenotype": "Mitochondrial complex I deficiency, nuclear type 18 [MIM: 618240]",
    "omimEntry": "612911",
    "inheritance": "AR"
  },
  {
    "gene": "NDUFAF4",
    "phenotype": "Mitochondrial complex I deficiency, nuclear type 15 [MIM: 618237]",
    "omimEntry": "611776",
    "inheritance": "AR"
  },
  {
    "gene": "NDUFAF5",
    "phenotype": "Mitochondrial complex I deficiency, nuclear type 16 [MIM: 618238]",
    "omimEntry": "612360",
    "inheritance": "AR"
  },
  {
    "gene": "NDUFAF6",
    "phenotype": "Fanconi renotubular syndrome 5 [MIM: 618913]; Mitochondrial complex I deficiency, nuclear type 17 [MIM: 618239]",
    "omimEntry": "612392",
    "inheritance": "AR"
  },
  {
    "gene": "NDUFB3",
    "phenotype": "Mitochondrial complex I deficiency, nuclear type 25 [MIM: 618246]",
    "omimEntry": "603839",
    "inheritance": "AR"
  },
  {
    "gene": "NDUFB9",
    "phenotype": "Mitochondrial complex I deficiency, nuclear type 24 [MIM: 618245]",
    "omimEntry": "601445",
    "inheritance": "AR"
  },
  {
    "gene": "NDUFS1",
    "phenotype": "Mitochondrial complex I deficiency, nuclear type 5 [MIM: 618226]",
    "omimEntry": "157655",
    "inheritance": "AR"
  },
  {
    "gene": "NDUFS2",
    "phenotype": "Leber-like hereditary optic neuropathy, autosomal recessive 2 [MIM: 620569]; Mitochondrial complex I deficiency, nuclear type 6 [MIM: 618228]",
    "omimEntry": "602985",
    "inheritance": "AR"
  },
  {
    "gene": "NDUFS3",
    "phenotype": "Mitochondrial complex I deficiency, nuclear type 8 [MIM: 618230]",
    "omimEntry": "603846",
    "inheritance": "AR"
  },
  {
    "gene": "NDUFS4",
    "phenotype": "Mitochondrial complex I deficiency, nuclear type 1 [MIM: 252010]",
    "omimEntry": "602694",
    "inheritance": "AR"
  },
  {
    "gene": "NDUFS6",
    "phenotype": "Mitochondrial complex I deficiency, nuclear type 9 [MIM: 618232]",
    "omimEntry": "603848",
    "inheritance": "AR"
  },
  {
    "gene": "NDUFS7",
    "phenotype": "Mitochondrial complex I deficiency, nuclear type 3 [MIM: 618224]",
    "omimEntry": "601825",
    "inheritance": "AR"
  },
  {
    "gene": "NDUFS8",
    "phenotype": "Mitochondrial complex I deficiency, nuclear type 2 [MIM: 618222]",
    "omimEntry": "602141",
    "inheritance": "AR"
  },
  {
    "gene": "NDUFV1",
    "phenotype": "Mitochondrial complex I deficiency, nuclear type 4 [MIM: 618225]",
    "omimEntry": "161015",
    "inheritance": "AR"
  },
  {
    "gene": "NDUFV2",
    "phenotype": "Mitochondrial complex I deficiency, nuclear type 7 [MIM: 618229]",
    "omimEntry": "600532",
    "inheritance": "AR"
  },
  {
    "gene": "NEB",
    "phenotype": "Arthrogryposis multiplex congenita 6 [MIM: 619334]; Nemaline myopathy 2, autosomal recessive [MIM: 256030]",
    "omimEntry": "161650",
    "inheritance": "AR"
  },
  {
    "gene": "NECAP1",
    "phenotype": "Developmental and epileptic encephalopathy 21 [MIM: 615833]",
    "omimEntry": "611623",
    "inheritance": "AR"
  },
  {
    "gene": "NEFH",
    "phenotype": "{Amyotrophic lateral sclerosis, susceptibility to} [MIM: 105400]; Charcot-Marie-Tooth disease, axonal, type 2CC [MIM: 616924]",
    "omimEntry": "162230",
    "inheritance": "AD, AR"
  },
  {
    "gene": "NEFL",
    "phenotype": "Charcot-Marie-Tooth disease, dominant intermediate G [MIM: 617882]; Charcot-Marie-Tooth disease, type 1F [MIM: 607734]; Charcot-Marie-Tooth disease, type 2E [MIM: 607684]",
    "omimEntry": "162280",
    "inheritance": "AD, AR"
  },
  {
    "gene": "NEU1",
    "phenotype": "Sialidosis, type I [MIM: 256550]; Sialidosis, type II [MIM: 256550]",
    "omimEntry": "608272",
    "inheritance": "AR"
  },
  {
    "gene": "NEXMIF",
    "phenotype": "Intellectual developmental disorder, X-linked 98 [MIM: 300912]",
    "omimEntry": "300524",
    "inheritance": "XLD"
  },
  {
    "gene": "NF1",
    "phenotype": "Leukemia, juvenile myelomonocytic [MIM: 607785]; Neurofibromatosis-Noonan syndrome [MIM: 601321]; Neurofibromatosis, familial spinal [MIM: 162210]; Neurofibromatosis, type 1 [MIM: 162200]; Watson syndrome [MIM: 193520]",
    "omimEntry": "613113",
    "inheritance": "AD, SMu"
  },
  {
    "gene": "NF2",
    "phenotype": "Meningioma, NF2-related, somatic [MIM: 607174]; Schwannomatosis, somatic [MIM: 101000]; Schwannomatosis, vestibular [MIM: 101000]",
    "omimEntry": "607379",
    "inheritance": "AD"
  },
  {
    "gene": "NFASC",
    "phenotype": "Neurodevelopmental disorder with central and peripheral motor dysfunction [MIM: 618356]",
    "omimEntry": "609145",
    "inheritance": "AR"
  },
  {
    "gene": "NGLY1",
    "phenotype": "Congenital disorder of deglycosylation 1 [MIM: 615273]",
    "omimEntry": "610661",
    "inheritance": "AR"
  },
  {
    "gene": "NHLRC1",
    "phenotype": "Myoclonic epilepsy of Lafora 2 [MIM: 620681]",
    "omimEntry": "608072",
    "inheritance": "AR"
  },
  {
    "gene": "NIPA1",
    "phenotype": "Spastic paraplegia 6, autosomal dominant [MIM: 600363]",
    "omimEntry": "608145",
    "inheritance": "AD"
  },
  {
    "gene": "NKX2-1",
    "phenotype": "{Thyroid cancer, nonmedullary, 1} [MIM: 188550]; Chorea, hereditary benign [MIM: 118700]; Choreoathetosis, hypothyroidism, and neonatal respiratory distress [MIM: 610978]",
    "omimEntry": "600635",
    "inheritance": "AD"
  },
  {
    "gene": "NKX6-2",
    "phenotype": "Spastic ataxia 8, autosomal recessive, with hypomyelinating leukodystrophy [MIM: 617560]",
    "omimEntry": "605955",
    "inheritance": "AR"
  },
  {
    "gene": "NMNAT1",
    "phenotype": "Leber congenital amaurosis 9 [MIM: 608553]; Spondyloepiphyseal dysplasia, sensorineural hearing loss, intellectual developmental disorder, and Leber congenital amaurosis [MIM: 619260]",
    "omimEntry": "608700",
    "inheritance": "AR"
  },
  {
    "gene": "NOL3",
    "phenotype": "Myoclonus, familial, 1 [MIM: 614937]",
    "omimEntry": "605235",
    "inheritance": "AD"
  },
  {
    "gene": "NOP56",
    "phenotype": "Spinocerebellar ataxia 36 [MIM: 614153]",
    "omimEntry": "614154",
    "inheritance": "AD"
  },
  {
    "gene": "NOTCH2NLC",
    "phenotype": "Neuronal Intranuclear Inclusion Disease [MIM: 603472]; Oculopharyngodistal Myopathy 3 [MIM: 619473]; Tremor Hereditary Essential 6 [MIM: 618866]",
    "omimEntry": "618025",
    "inheritance": "AD"
  },
  {
    "gene": "NOTCH3",
    "phenotype": "Myofibromatosis, infantile 2 [MIM: 615293]; Cerebral arteriopathy, autosomal dominant, with subcortical infarcts and leukoencephalopathy 1 [MIM: 125310]; Cerebral arteriopathy, autosomal recessive, with subcortical infarcts and leukoencephalopathy 1 [MIM: 621295]; Lateral meningocele syndrome [MIM: 130720]; Lipodystrophy, familial partial, type 1 [MIM: 608600]",
    "omimEntry": "600276",
    "inheritance": "AD, AR"
  },
  {
    "gene": "NPC1",
    "phenotype": "Niemann-Pick disease, type C1 [MIM: 257220]; Niemann-Pick disease, type D [MIM: 257220]",
    "omimEntry": "607623",
    "inheritance": "AR"
  },
  {
    "gene": "NPC2",
    "phenotype": "Niemann-pick disease, type C2 [MIM: 607625]",
    "omimEntry": "601015",
    "inheritance": "AR"
  },
  {
    "gene": "NPHP1",
    "phenotype": "Joubert syndrome 4 [MIM: 609583]; Nephronophthisis 1, juvenile [MIM: 256100]; Senior-Loken syndrome-1 [MIM: 266900]",
    "omimEntry": "607100",
    "inheritance": "AR"
  },
  {
    "gene": "NR4A2",
    "phenotype": "Intellectual developmental disorder with language impairment and early-onset DOPA-responsive dystonia-parkinsonism [MIM: 619911]",
    "omimEntry": "601828",
    "inheritance": "AD"
  },
  {
    "gene": "NSUN2",
    "phenotype": "Intellectual developmental disorder, autosomal recessive 5 [MIM: 611091]",
    "omimEntry": "610916",
    "inheritance": "AR"
  },
  {
    "gene": "NT5C2",
    "phenotype": "Spastic paraplegia 45, autosomal recessive [MIM: 613162]",
    "omimEntry": "600417",
    "inheritance": "AR"
  },
  {
    "gene": "NUBPL",
    "phenotype": "Mitochondrial complex I deficiency, nuclear type 21 [MIM: 618242]",
    "omimEntry": "613621",
    "inheritance": "AR"
  },
  {
    "gene": "NUP62",
    "phenotype": "Striatonigral degeneration, infantile [MIM: 271930]",
    "omimEntry": "605815",
    "inheritance": "AR"
  },
  {
    "gene": "NUTM2B-AS1",
    "phenotype": "Oculopharyngeal myopathy with leukoencephalopathy 1 [MIM: 618637]",
    "omimEntry": "618639",
    "inheritance": "AD"
  },
  {
    "gene": "OCLN",
    "phenotype": "Pseudo-TORCH syndrome 1 [MIM: 251290]",
    "omimEntry": "602876",
    "inheritance": "AR"
  },
  {
    "gene": "OFD1",
    "phenotype": "Retinitis pigmentosa 23 [MIM: 300424]; Joubert syndrome 10 [MIM: 300804]; Orofaciodigital syndrome I [MIM: 311200]; Simpson-Golabi-Behmel syndrome, type 2 [MIM: 300209]",
    "omimEntry": "300170",
    "inheritance": "XLR, XLD"
  },
  {
    "gene": "OPA1",
    "phenotype": "Mitochondrial DNA depletion syndrome 14 (encephalocardiomyopathic type) [MIM: 616896]; {Glaucoma, normal tension, susceptibility to} [MIM: 606657]; Behr syndrome [MIM: 210000]; Optic atrophy 1 [MIM: 165500]; Optic atrophy plus syndrome [MIM: 125250]",
    "omimEntry": "605290",
    "inheritance": "AD, AR"
  },
  {
    "gene": "OPA3",
    "phenotype": "3-methylglutaconic aciduria, type III [MIM: 258501]; Optic atrophy 3 with cataract [MIM: 165300]",
    "omimEntry": "606580",
    "inheritance": "AD, AR"
  },
  {
    "gene": "OPHN1",
    "phenotype": "Intellectual developmental disorder, X-linked syndromic, Billuart type [MIM: 300486]",
    "omimEntry": "300127",
    "inheritance": "XLR"
  },
  {
    "gene": "OPTN",
    "phenotype": "{Glaucoma, normal tension, susceptibility to} [MIM: 606657]; Amyotrophic lateral sclerosis 12 with or without frontotemporal dementia [MIM: 613435]; Glaucoma 1, open angle, E [MIM: 137760]",
    "omimEntry": "602432",
    "inheritance": "AD, AR"
  },
  {
    "gene": "ORAI1",
    "phenotype": "Immunodeficiency 9 [MIM: 612782]; Myopathy, tubular aggregate, 2 [MIM: 615883]",
    "omimEntry": "610277",
    "inheritance": "AD, AR"
  },
  {
    "gene": "OSGEP",
    "phenotype": "Galloway-Mowat syndrome 3 [MIM: 617729]",
    "omimEntry": "610107",
    "inheritance": "AR"
  },
  {
    "gene": "OTC",
    "phenotype": "Ornithine transcarbamylase deficiency [MIM: 311250]",
    "omimEntry": "300461",
    "inheritance": "XL"
  },
  {
    "gene": "PABPN1",
    "phenotype": "Oculopharyngeal muscular dystrophy [MIM: 164300]",
    "omimEntry": "602279",
    "inheritance": "AD"
  },
  {
    "gene": "PAFAH1B1",
    "phenotype": "Lissencephaly 1 [MIM: 607432]; Subcortical laminar heterotopia [MIM: 607432]",
    "omimEntry": "601545",
    "inheritance": "AD"
  },
  {
    "gene": "PANK2",
    "phenotype": "Neurodegeneration with brain iron accumulation 1 [MIM: 234200]",
    "omimEntry": "606157",
    "inheritance": "AR"
  },
  {
    "gene": "PARK7",
    "phenotype": "Parkinson disease 7, autosomal recessive early-onset [MIM: 606324]",
    "omimEntry": "606324",
    "inheritance": "AR"
  },
  {
    "gene": "PARN",
    "phenotype": "Dyskeratosis congenita, autosomal recessive 6 [MIM: 616353]; Pulmonary fibrosis and/or bone marrow failure syndrome, telomere-related, 4 [MIM: 616371]",
    "omimEntry": "604212",
    "inheritance": "AD, AR"
  },
  {
    "gene": "PARS2",
    "phenotype": "Developmental and epileptic encephalopathy 75 [MIM: 618437]",
    "omimEntry": "612036",
    "inheritance": "AR"
  },
  {
    "gene": "PAX7",
    "phenotype": "Congenital myopathy 19 [MIM: 618578]; Rhabdomyosarcoma 2, alveolar [MIM: 268220]",
    "omimEntry": "167410",
    "inheritance": "AR, Smu"
  },
  {
    "gene": "PC",
    "phenotype": "Pyruvate carboxylase deficiency [MIM: 266150]",
    "omimEntry": "608786",
    "inheritance": "AR"
  },
  {
    "gene": "PCCA",
    "phenotype": "Propionicacidemia [MIM: 606054]",
    "omimEntry": "232000",
    "inheritance": "AR"
  },
  {
    "gene": "PCCB",
    "phenotype": "Propionicacidemia [MIM: 606054]",
    "omimEntry": "232050",
    "inheritance": "AR"
  },
  {
    "gene": "PCDH12",
    "phenotype": "Diencephalic-mesencephalic junction dysplasia syndrome 1 [MIM: 251280]",
    "omimEntry": "605622",
    "inheritance": "AR"
  },
  {
    "gene": "PCDH19",
    "phenotype": "Developmental and epileptic encephalopathy 9 [MIM: 300088]",
    "omimEntry": "300460",
    "inheritance": "XL"
  },
  {
    "gene": "PCLO",
    "phenotype": "Pontocerebellar hypoplasia, type 3 [MIM: 608027]",
    "omimEntry": "604918",
    "inheritance": "AR"
  },
  {
    "gene": "PCNA",
    "phenotype": "Ataxia-telangiectasia-like disorder 2 [MIM: 615919]",
    "omimEntry": "176740",
    "inheritance": "AR"
  },
  {
    "gene": "PDE10A",
    "phenotype": "Dyskinesia, limb and orofacial, infantile-onset [MIM: 616921]; Striatal degeneration, autosomal dominant [MIM: 616922]",
    "omimEntry": "610652",
    "inheritance": "AD, AR"
  },
  {
    "gene": "PDE6D",
    "phenotype": "Joubert syndrome 22 [MIM: 615665]",
    "omimEntry": "602676",
    "inheritance": "AR"
  },
  {
    "gene": "PDE8B",
    "phenotype": "Pigmented nodular adrenocortical disease, primary, 3 [MIM: 614190]; Striatal degeneration, autosomal dominant [MIM: 609161]",
    "omimEntry": "603390",
    "inheritance": "AD"
  },
  {
    "gene": "PDGFB",
    "phenotype": "Basal ganglia calcification, idiopathic, 5 [MIM: 615483]; Meningioma, SIS-related [MIM: 607174]",
    "omimEntry": "190040",
    "inheritance": "AD"
  },
  {
    "gene": "PDGFRB",
    "phenotype": "Ocular pterygium-digital keloid dysplasia syndrome [MIM: 621091]; Basal ganglia calcification, idiopathic, 4 [MIM: 615007]; Kosaki overgrowth syndrome [MIM: 616592]; Myofibromatosis, infantile, 1 [MIM: 228550]; Premature aging syndrome, Penttinen type [MIM: 601812]",
    "omimEntry": "173410",
    "inheritance": "AD"
  },
  {
    "gene": "PDHA1",
    "phenotype": "Pyruvate dehydrogenase E1-alpha deficiency [MIM: 312170]",
    "omimEntry": "300502",
    "inheritance": "XLD"
  },
  {
    "gene": "PDHB",
    "phenotype": "Pyruvate dehydrogenase E1-beta deficiency [MIM: 614111]",
    "omimEntry": "179060",
    "inheritance": "AR"
  },
  {
    "gene": "PDHX",
    "phenotype": "Lacticacidemia due to PDX1 deficiency [MIM: 245349]",
    "omimEntry": "608769",
    "inheritance": "AR"
  },
  {
    "gene": "PDP1",
    "phenotype": "Pyruvate dehydrogenase phosphatase deficiency [MIM: 608782]",
    "omimEntry": "605993",
    "inheritance": "AR"
  },
  {
    "gene": "PDSS1",
    "phenotype": "Coenzyme Q10 deficiency, primary, 2 [MIM: 614651]",
    "omimEntry": "607429",
    "inheritance": "AR"
  },
  {
    "gene": "PDSS2",
    "phenotype": "Coenzyme Q10 deficiency, primary, 3 [MIM: 614652]",
    "omimEntry": "610564",
    "inheritance": "AR"
  },
  {
    "gene": "PDYN",
    "phenotype": "Spinocerebellar ataxia 23 [MIM: 610245]",
    "omimEntry": "131340",
    "inheritance": "AD"
  },
  {
    "gene": "PET100",
    "phenotype": "Mitochondrial complex IV deficiency, nuclear type 12 [MIM: 619055]",
    "omimEntry": "614770",
    "inheritance": "AR"
  },
  {
    "gene": "PEX1",
    "phenotype": "Heimler syndrome 1 [MIM: 234580]; Peroxisome biogenesis disorder 1A (Zellweger) [MIM: 214100]; Peroxisome biogenesis disorder 1B (NALD/IRD) [MIM: 601539]",
    "omimEntry": "602136",
    "inheritance": "AR"
  },
  {
    "gene": "PEX10",
    "phenotype": "Peroxisome biogenesis disorder 6A (Zellweger) [MIM: 614870]; Peroxisome biogenesis disorder 6B [MIM: 614871]",
    "omimEntry": "602859",
    "inheritance": "AR"
  },
  {
    "gene": "PEX11B",
    "phenotype": "Peroxisome biogenesis disorder 14B [MIM: 614920]",
    "omimEntry": "603867",
    "inheritance": "AR"
  },
  {
    "gene": "PEX12",
    "phenotype": "Peroxisome biogenesis disorder 3A (Zellweger) [MIM: 614859]; Peroxisome biogenesis disorder 3B [MIM: 266510]",
    "omimEntry": "601758",
    "inheritance": "AR"
  },
  {
    "gene": "PEX13",
    "phenotype": "Peroxisome biogenesis disorder 11A (Zellweger) [MIM: 614883]; Peroxisome biogenesis disorder 11B [MIM: 614885]",
    "omimEntry": "601789",
    "inheritance": "AR"
  },
  {
    "gene": "PEX14",
    "phenotype": "Peroxisome biogenesis disorder 13A (Zellweger) [MIM: 614887]",
    "omimEntry": "601791",
    "inheritance": "AR"
  },
  {
    "gene": "PEX16",
    "phenotype": "Peroxisome biogenesis disorder 8A (Zellweger) [MIM: 614876]; Peroxisome biogenesis disorder 8B [MIM: 614877]",
    "omimEntry": "603360",
    "inheritance": "AR"
  },
  {
    "gene": "PEX19",
    "phenotype": "Peroxisome biogenesis disorder 12A (Zellweger) [MIM: 614886]",
    "omimEntry": "600279",
    "inheritance": "AR"
  },
  {
    "gene": "PEX2",
    "phenotype": "Peroxisome biogenesis disorder 5A (Zellweger) [MIM: 614866]; Peroxisome biogenesis disorder 5B [MIM: 614867]",
    "omimEntry": "170993",
    "inheritance": "AR"
  },
  {
    "gene": "PEX26",
    "phenotype": "Peroxisome biogenesis disorder 7A (Zellweger) [MIM: 614872]; Peroxisome biogenesis disorder 7B [MIM: 614873]",
    "omimEntry": "608666",
    "inheritance": "AR"
  },
  {
    "gene": "PEX3",
    "phenotype": "Peroxisome biogenesis disorder 10B [MIM: 617370]; Peroxisome biogenesis disorder 10A (Zellweger) [MIM: 614882]",
    "omimEntry": "603164",
    "inheritance": "AR"
  },
  {
    "gene": "PEX5",
    "phenotype": "Peroxisome biogenesis disorder 2A (Zellweger) [MIM: 214110]; Peroxisome biogenesis disorder 2B [MIM: 202370]; Rhizomelic chondrodysplasia punctata, type 5 [MIM: 616716]",
    "omimEntry": "600414",
    "inheritance": "AR"
  },
  {
    "gene": "PEX6",
    "phenotype": "Heimler syndrome 2 [MIM: 616617]; Peroxisome biogenesis disorder 4A (Zellweger) [MIM: 614862]; Peroxisome biogenesis disorder 4B [MIM: 614863]",
    "omimEntry": "601498",
    "inheritance": "AD, AR"
  },
  {
    "gene": "PEX7",
    "phenotype": "Peroxisome biogenesis disorder 9B [MIM: 614879]; Rhizomelic chondrodysplasia punctata, type 1\t [MIM: 215100]",
    "omimEntry": "601757",
    "inheritance": "AR"
  },
  {
    "gene": "PFKM",
    "phenotype": "Glycogen storage disease VII [MIM: 232800]",
    "omimEntry": "610681",
    "inheritance": "AR"
  },
  {
    "gene": "PFN1",
    "phenotype": "Amyotrophic lateral sclerosis 18 [MIM: 614808]",
    "omimEntry": "176610",
    "inheritance": ""
  },
  {
    "gene": "PGAM2",
    "phenotype": "Glycogen storage disease X [MIM: 261670]",
    "omimEntry": "612931",
    "inheritance": "AR"
  },
  {
    "gene": "PGAP1",
    "phenotype": "Neurodevelopmental disorder with dysmorphic features, spasticity, and brain abnormalities [MIM: 615802]",
    "omimEntry": "611655",
    "inheritance": "AR"
  },
  {
    "gene": "PGK1",
    "phenotype": "Phosphoglycerate kinase 1 deficiency [MIM: 300653]",
    "omimEntry": "311800",
    "inheritance": "XLR"
  },
  {
    "gene": "PGM1",
    "phenotype": "Congenital disorder of glycosylation, type It [MIM: 614921]",
    "omimEntry": "171900",
    "inheritance": "AR"
  },
  {
    "gene": "PGM3",
    "phenotype": "Immunodeficiency 23 [MIM: 615816]",
    "omimEntry": "172100",
    "inheritance": "AR"
  },
  {
    "gene": "PHGDH",
    "phenotype": "Neu-Laxova syndrome 1 [MIM: 256520]; Phosphoglycerate dehydrogenase deficiency [MIM: 601815]",
    "omimEntry": "606879",
    "inheritance": "AR"
  },
  {
    "gene": "PHKA1",
    "phenotype": "Muscle glycogenosis [MIM: 300559]",
    "omimEntry": "311870",
    "inheritance": "XLR"
  },
  {
    "gene": "PHKB",
    "phenotype": "Phosphorylase kinase deficiency of liver and muscle, autosomal recessive [MIM: 261750]",
    "omimEntry": "172490",
    "inheritance": "AR"
  },
  {
    "gene": "PHYH",
    "phenotype": "Refsum disease [MIM: 266500]",
    "omimEntry": "602026",
    "inheritance": "AR"
  },
  {
    "gene": "PIBF1",
    "phenotype": "Joubert syndrome 33 [MIM: 617767]",
    "omimEntry": "607532",
    "inheritance": "AR"
  },
  {
    "gene": "PIEZO2",
    "phenotype": "Marden-Walker syndrome [MIM: 248700]; Arthrogryposis, distal, type 3 [MIM: 114300]; Arthrogryposis, distal, type 5 [MIM: 108145]; Arthrogryposis, distal, with impaired proprioception and touch [MIM: 617146]",
    "omimEntry": "613629",
    "inheritance": "AD, AR"
  },
  {
    "gene": "PIGA",
    "phenotype": "Multiple congenital anomalies-hypotonia-seizures syndrome 2 [MIM: 300868]; Neurodevelopmental disorder with epilepsy and hemochromatosis [MIM: 301072]; Paroxysmal nocturnal hemoglobinuria, somatic [MIM: 300818]",
    "omimEntry": "311770",
    "inheritance": "XLR"
  },
  {
    "gene": "PIGG",
    "phenotype": "[Blood group, EMM system] [MIM: 619812]; Neurodevelopmental disorder with or without hypotonia, seizures, and cerebellar atrophy [MIM: 616917]",
    "omimEntry": "616918",
    "inheritance": "AR"
  },
  {
    "gene": "PIGN",
    "phenotype": "Multiple congenital anomalies-hypotonia-seizures syndrome 1 [MIM: 614080]",
    "omimEntry": "606097",
    "inheritance": "AR"
  },
  {
    "gene": "PIGQ",
    "phenotype": "Multiple congenital anomalies-hypotonia-seizures syndrome 4 [MIM: 618548]",
    "omimEntry": "605754",
    "inheritance": "AR"
  },
  {
    "gene": "PIGS",
    "phenotype": "Developmental and epileptic encephalopathy 95 [MIM: 618143]",
    "omimEntry": "610271",
    "inheritance": "AR"
  },
  {
    "gene": "PIK3R5",
    "phenotype": "Ataxia-oculomotor apraxia 3 [MIM: 615217]",
    "omimEntry": "611317",
    "inheritance": "AR"
  },
  {
    "gene": "PINK1",
    "phenotype": "Parkinson disease 6, early onset [MIM: 605909]",
    "omimEntry": "608309",
    "inheritance": "AR"
  },
  {
    "gene": "PITRM1",
    "phenotype": "Spinocerebellar ataxia, autosomal recessive 30 [MIM: 619405]",
    "omimEntry": "618211",
    "inheritance": "AR"
  },
  {
    "gene": "PLA2G6",
    "phenotype": "Infantile neuroaxonal dystrophy 1 [MIM: 256600]; Neurodegeneration with brain iron accumulation 2B [MIM: 610217]; Parkinson disease 14, autosomal recessive [MIM: 612953]",
    "omimEntry": "603604",
    "inheritance": "AR"
  },
  {
    "gene": "PLAA",
    "phenotype": "Neurodevelopmental disorder with progressive microcephaly, spasticity, and brain anomalies [MIM: 617527]",
    "omimEntry": "603873",
    "inheritance": "AR"
  },
  {
    "gene": "PLCB1",
    "phenotype": "Developmental and epileptic encephalopathy 12 [MIM: 613722]",
    "omimEntry": "607120",
    "inheritance": "AR"
  },
  {
    "gene": "PLD3",
    "phenotype": "Spinocerebellar ataxia 46 [MIM: 617770]",
    "omimEntry": "615698",
    "inheritance": "AD"
  },
  {
    "gene": "PLEC",
    "phenotype": "Epidermolysis bullosa simplex 5D, generalized intermediate, autosomal recessive [MIM: 616487]; Epidermolysis bullosa simplex 5A, Ogna type [MIM: 131950]; Epidermolysis bullosa simplex 5B, with muscular dystrophy [MIM: 226670]; Epidermolysis bullosa simplex 5C, with pyloric atresia [MIM: 612138]; Muscular dystrophy, limb-girdle, autosomal recessive 17 [MIM: 613723]",
    "omimEntry": "601282",
    "inheritance": "AD, AR"
  },
  {
    "gene": "PLEKHG2",
    "phenotype": "Leukodystrophy and acquired microcephaly with or without dystonia [MIM: 616673]",
    "omimEntry": "611893",
    "inheritance": "AR"
  },
  {
    "gene": "PLEKHG5",
    "phenotype": "Charcot-Marie-Tooth disease, recessive intermediate C [MIM: 615376]; Neuronopathy, distal hereditary motor, autosomal recessive 4 [MIM: 611067]",
    "omimEntry": "611101",
    "inheritance": "AR"
  },
  {
    "gene": "PLP1",
    "phenotype": "Pelizaeus-Merzbacher disease [MIM: 312080]; Spastic paraplegia 2, X-linked [MIM: 312920]",
    "omimEntry": "300401",
    "inheritance": "XLR"
  },
  {
    "gene": "PLXND1",
    "phenotype": "Congenital heart defects, multiple types, 9 [MIM: 620294]",
    "omimEntry": "604282",
    "inheritance": "AR"
  },
  {
    "gene": "PMM2",
    "phenotype": "Congenital disorder of glycosylation, type Ia [MIM: 212605]",
    "omimEntry": "601785",
    "inheritance": "AR"
  },
  {
    "gene": "PMP22",
    "phenotype": "Neuropathy, inflammatory demyelinating [MIM: 139393]; Charcot-Marie-Tooth disease, type 1A [MIM: 118220'; Charcot-Marie-Tooth disease, type 1E [MIM: 118300]; Dejerine-Sottas disease [MIM: 145900]; Neuropathy, recurrent, with pressure palsies [MIM: 162500]; Roussy-Levy syndrome [MIM: 180800]",
    "omimEntry": "601097",
    "inheritance": "AD, AR"
  },
  {
    "gene": "PMPCA",
    "phenotype": "Spinocerebellar ataxia, autosomal recessive 2 [MIM: 213200]",
    "omimEntry": "613036",
    "inheritance": "AR"
  },
  {
    "gene": "PNKD",
    "phenotype": "Paroxysmal nonkinesigenic dyskinesia 1 [MIM: 118800]",
    "omimEntry": "609023",
    "inheritance": "AD"
  },
  {
    "gene": "PNKP",
    "phenotype": "Charcot-Marie-Tooth disease, type 2B2 [MIM: 605589]; Ataxia-oculomotor apraxia 4 [MIM: 616267]; Microcephaly, seizures, and developmental delay [MIM: 613402]",
    "omimEntry": "605610",
    "inheritance": "AR"
  },
  {
    "gene": "PNP",
    "phenotype": "Immunodeficiency due to purine nucleoside phosphorylase deficiency [MIM: 613179]",
    "omimEntry": "164050",
    "inheritance": "AR"
  },
  {
    "gene": "PNPLA2",
    "phenotype": "Neutral lipid storage disease with myopathy {MIM: 610717]",
    "omimEntry": "609059",
    "inheritance": "AR"
  },
  {
    "gene": "PNPLA6",
    "phenotype": "Laurence-Moon syndrome [MIM: 245800]; Boucher-Neuhauser syndrome [MIM: 215470]; Oliver-McFarlane syndrome [MIM: 275400]; Spastic paraplegia 39, autosomal recessive [MIM: 612020];",
    "omimEntry": "603197",
    "inheritance": "AR"
  },
  {
    "gene": "PNPLA8",
    "phenotype": "Mitochondrial myopathy with lactic acidosis [MIM: 251950]",
    "omimEntry": "612123",
    "inheritance": "AR"
  },
  {
    "gene": "PNPT1",
    "phenotype": "Combined oxidative phosphorylation deficiency 13 [MIM: 614932]; Deafness, autosomal recessive 70, with or without adult-onset neurodegeneration [MIM: 614934]; Spinocerebellar ataxia 25 [MIM: 608703]",
    "omimEntry": "610316",
    "inheritance": "AD, AR"
  },
  {
    "gene": "POGLUT1",
    "phenotype": "Dowling-Degos disease 4 [MIM: 615696]; Muscular dystrophy, limb-girdle, autosomal recessive 21 [MIM: 617232]",
    "omimEntry": "615618",
    "inheritance": "AD, AR"
  },
  {
    "gene": "POLG",
    "phenotype": "Mitochondrial DNA depletion syndrome 4A (Alpers type) [MIM: 203700]; Mitochondrial DNA depletion syndrome 4B (MNGIE type) [MIM: 613662]; Mitochondrial recessive ataxia syndrome (includes SANDO and SCAE) [MIM: 607459]; Progressive external ophthalmoplegia, autosomal dominant 1 [mim: 157640]; Progressive external ophthalmoplegia, autosomal recessive 1 [MIM: 258450]",
    "omimEntry": "174763",
    "inheritance": "AD, AR"
  },
  {
    "gene": "POLG2",
    "phenotype": "Mitochondrial DNA depletion syndrome 16 (hepatic type [MIM: 618258]; Mitochondrial DNA depletion syndrome 16B (neuroophthalmic type) [MIM: 619425]; Progressive external ophthalmoplegia with mitochondrial DNA deletions, autosomal dominant 4 [MIM: 610131]",
    "omimEntry": "604983",
    "inheritance": "AD, AR"
  },
  {
    "gene": "POLR1C",
    "phenotype": "Leukodystrophy, hypomyelinating, 11 [MIM: 616494]; Treacher Collins syndrome 3 [MIM: 248390]",
    "omimEntry": "610060",
    "inheritance": "AR"
  },
  {
    "gene": "POLR3A",
    "phenotype": "Leukodystrophy, hypomyelinating, 7, with or without oligodontia and/or hypogonadotropic hypogonadism [MIM: 607694]; Wiedemann-Rautenstrauch syndrome [MIM: 264090]",
    "omimEntry": "614258",
    "inheritance": "AR"
  },
  {
    "gene": "POLR3B",
    "phenotype": "Charcot-Marie-Tooth disease, demyelinating, type 1I [MIM: 619742]; Leukodystrophy, hypomyelinating, 8, with or without oligodontia and/or hypogonadotropic hypogonadism [MIM: 614381]",
    "omimEntry": "614366",
    "inheritance": "AD, AR"
  },
  {
    "gene": "POMGNT1",
    "phenotype": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 3 [MIM: 253280]; Muscular dystrophy-dystroglycanopathy (congenital with impaired intellectual development), type B, 3 [MIM: 613151]; Muscular dystrophy-dystroglycanopathy (limb-girdle), type C, 3 [MIM: 613157]; Retinitis pigmentosa 76 [MIM: 617123]",
    "omimEntry": "606822",
    "inheritance": "AR"
  },
  {
    "gene": "POMGNT2",
    "phenotype": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 8 [MIM: 614830]; Muscular dystrophy-dystroglycanopathy (limb-girdle) type C, 8 [MIM: 618135]",
    "omimEntry": "614828",
    "inheritance": "AR"
  },
  {
    "gene": "POMK",
    "phenotype": "Muscular dystrophy-dystroglycanopathy (limb-girdle), type C, 12 [MIM: 616094]; Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 12 [MIM: 615249]",
    "omimEntry": "615247",
    "inheritance": "AR"
  },
  {
    "gene": "POMT1",
    "phenotype": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 1 [MIM: 236670]; Muscular dystrophy-dystroglycanopathy (congenital with impaired intellectual development), type B, 1 [MIM: 613155]; Muscular dystrophy-dystroglycanopathy (limb-girdle), type C, 1 [MIM: 609308]",
    "omimEntry": "607423",
    "inheritance": "AR"
  },
  {
    "gene": "POMT2",
    "phenotype": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 2 [MIM: 613150]; Muscular dystrophy-dystroglycanopathy (congenital with impaired intellectual development), type B, 2 [MIM: 613156]; Muscular dystrophy-dystroglycanopathy (limb-girdle), type C, 2 [MIM: 613158]",
    "omimEntry": "607439",
    "inheritance": "AR"
  },
  {
    "gene": "POPDC1",
    "phenotype": "Muscular dystrophy, limb-girdle, autosomal recessive 25 [MIM: 616812]",
    "omimEntry": "604577",
    "inheritance": "AR"
  },
  {
    "gene": "POPDC3",
    "phenotype": "Muscular dystrophy, limb-girdle, autosomal recessive 26 [MIM: 618848]",
    "omimEntry": "605824",
    "inheritance": "AR"
  },
  {
    "gene": "PPP1R15B",
    "phenotype": "Microcephaly, short stature, and impaired glucose metabolism 2 [MIM: 616817]",
    "omimEntry": "613257",
    "inheritance": "AR"
  },
  {
    "gene": "PPP2R2B",
    "phenotype": "Spinocerebellar ataxia 12 [MIM: 604326]",
    "omimEntry": "604325",
    "inheritance": "AD"
  },
  {
    "gene": "PPP3CA",
    "phenotype": "Arthrogryposis, cleft palate, craniosynostosis, and impaired intellectual development [MIM: 618265]; Developmental and epileptic encephalopathy 91 [MIM: 617711]",
    "omimEntry": "114105",
    "inheritance": "AD"
  },
  {
    "gene": "PPT1",
    "phenotype": "Ceroid lipofuscinosis, neuronal, 1 [MIM: 256730]",
    "omimEntry": "600722",
    "inheritance": "AR"
  },
  {
    "gene": "PQBP1",
    "phenotype": "Renpenning syndrome [MIM: 309500]",
    "omimEntry": "300463",
    "inheritance": "XLR"
  },
  {
    "gene": "PRDM8",
    "phenotype": "Epilepsy, progressive myoclonic, 10 [MIM: 616640]",
    "omimEntry": "616639",
    "inheritance": "AR"
  },
  {
    "gene": "PREPL",
    "phenotype": "Myasthenic syndrome, congenital, 22 [MIM: 616224]",
    "omimEntry": "609557",
    "inheritance": "AR"
  },
  {
    "gene": "PRF1",
    "phenotype": "Aplastic anemia [MIM: 609135]; Hemophagocytic lymphohistiocytosis, familial, 2 [MIM: 603553]; Lymphoma, non-Hodgkin [MIM: 605027]",
    "omimEntry": "170280",
    "inheritance": "AR"
  },
  {
    "gene": "PRICKLE1",
    "phenotype": "Epilepsy, progressive myoclonic 1B [MIM: 612437]",
    "omimEntry": "608500",
    "inheritance": "AR"
  },
  {
    "gene": "PRKCG",
    "phenotype": "Spinocerebellar ataxia 14 [MIM: 605361]",
    "omimEntry": "176980",
    "inheritance": "AD"
  },
  {
    "gene": "PRKN",
    "phenotype": "Adenocarcinoma of lung, somatic [MIM: 211980]; Ovarian cancer, somatic [MIM: 167000]; Parkinson disease, juvenile, type 2 [MIM: 600116]",
    "omimEntry": "602544",
    "inheritance": "AR"
  },
  {
    "gene": "PRKRA",
    "phenotype": "Dystonia 16 [MIM: 612067]",
    "omimEntry": "603424",
    "inheritance": "AR"
  },
  {
    "gene": "PROK2",
    "phenotype": "Hypogonadotropic hypogonadism 4 with or without anosmia [MIM: 610628]",
    "omimEntry": "607002",
    "inheritance": "AD, AR"
  },
  {
    "gene": "PROKR2",
    "phenotype": "Hypogonadotropic hypogonadism 3 with or without anosmia [MIM: 244200]",
    "omimEntry": "607123",
    "inheritance": "AD, AR"
  },
  {
    "gene": "PRPH",
    "phenotype": "{Amyotrophic lateral sclerosis, susceptibility to} [MIM: 105400]",
    "omimEntry": "170710",
    "inheritance": "AD, AR"
  },
  {
    "gene": "PRPS1",
    "phenotype": "Arts syndrome [MIM: 301835]; Charcot-Marie-Tooth disease, X-linked recessive, 5 [MIM: 311070];\nDeafness, X-linked 1 [MIM: 304500]; Gout, PRPS-related [MIM: 300661]; Phosphoribosylpyrophosphate synthetase superactivity [MIM: 300661]",
    "omimEntry": "311850",
    "inheritance": "XL, XLR"
  },
  {
    "gene": "PRRT2",
    "phenotype": "Convulsions, familial infantile, with paroxysmal choreoathetosis [MIM: 602066]; Episodic kinesigenic dyskinesia 1 [MIM: 128200]; Seizures, benign familial infantile, 2 [MIM: 605751]",
    "omimEntry": "614386",
    "inheritance": "AD"
  },
  {
    "gene": "PRX",
    "phenotype": "Charcot-Marie-Tooth disease, type 4F [MIM: 614895]; Dejerine-Sottas disease [MIM: 145900]",
    "omimEntry": "605725",
    "inheritance": "AD, AR"
  },
  {
    "gene": "PSAP",
    "phenotype": "{Parkinson disease 24, autosomal dominant, susceptibility to} [MIM: 619491]; Combined SAP deficiency [MIM: 611721]; Gaucher disease, atypical [MIM: 610539]; Krabbe disease, atypical [MIM: 611722]; Metachromatic leukodystrophy due to SAP-b deficiency [MIM: 249900]",
    "omimEntry": "176801",
    "inheritance": "AD, AR"
  },
  {
    "gene": "PSAT1",
    "phenotype": "Neu-Laxova syndrome 2 [MIM: 616038]; Phosphoserine aminotransferase deficiency [MIM: 610992]",
    "omimEntry": "610936",
    "inheritance": "AR"
  },
  {
    "gene": "PSEN1",
    "phenotype": "Acne inversa, familial, 3 [MIM: 613737]; Cardiomyopathy, dilated, 1U [MIM: 613694]; Alzheimer disease, type 3, with or without spastic paraparesis [MIM: 607822]; Dementia, frontotemporal [MIM: 600274]; Pick disease [MIM: 172700]",
    "omimEntry": "104311",
    "inheritance": "AD"
  },
  {
    "gene": "PSEN2",
    "phenotype": "Alzheimer disease-4 [606889]; Cardiomyopathy, dilated, 1V [MIM: 613697]",
    "omimEntry": "600759",
    "inheritance": "AD"
  },
  {
    "gene": "PSMB8",
    "phenotype": "Proteasome-associated autoinflammatory syndrome 1 and digenic forms [MIM:256040]",
    "omimEntry": "177046",
    "inheritance": "AR"
  },
  {
    "gene": "PTEN",
    "phenotype": "{Glioma susceptibility 2} [MIM: 613028]; {Meningioma} [MIM: 607174]; Cowden syndrome 1 [MIM: 158350]; Lhermitte-Duclos disease [MIM: 158350]; Macrocephaly/autism syndrome [MIM: 605309]; Prostate cancer, somatic [MIM: 176807]",
    "omimEntry": "601728",
    "inheritance": "AD"
  },
  {
    "gene": "PTF1A",
    "phenotype": "Pancreatic agenesis 2 [MIM: 615935]; Pancreatic and cerebellar agenesis [MIM: 609069]",
    "omimEntry": "607194",
    "inheritance": "AR"
  },
  {
    "gene": "PTPN23",
    "phenotype": "Neurodevelopmental disorder and structural brain anomalies with or without seizures and spasticity [MIM: 618890]",
    "omimEntry": "606584",
    "inheritance": "AR"
  },
  {
    "gene": "PTRH2",
    "phenotype": "Infantile-onset multisystem neurologic, endocrine, and pancreatic disease [MIM: 616263]",
    "omimEntry": "608625",
    "inheritance": "AR"
  },
  {
    "gene": "PTRHD1",
    "phenotype": "Neurodevelopmental disorder with early-onset parkinsonism and behavioral abnormalities [MIM: 620747]",
    "omimEntry": "617342",
    "inheritance": "AR"
  },
  {
    "gene": "PTS",
    "phenotype": "Hyperphenylalaninemia, BH4-deficient, A [MIM: 261640]",
    "omimEntry": "612719",
    "inheritance": "AR"
  },
  {
    "gene": "PUM1",
    "phenotype": "Neurodevelopmental disorder with motor abnormalities, and facial dysmorphism [MIM: 620719]",
    "omimEntry": "607204",
    "inheritance": "AD"
  },
  {
    "gene": "PURA",
    "phenotype": "Neurodevelopmental disorder with neonatal respiratory insufficiency, hypotonia, and feeding difficulties [MIM: 616158]",
    "omimEntry": "600473",
    "inheritance": "AD"
  },
  {
    "gene": "PUS1",
    "phenotype": "Myopathy, lactic acidosis, and sideroblastic anemia 1 [MIM: 600462]",
    "omimEntry": "608109",
    "inheritance": "AR"
  },
  {
    "gene": "PYCR2",
    "phenotype": "Leukodystrophy, hypomyelinating, 10 [MIM: 616420]",
    "omimEntry": "616406",
    "inheritance": "AR"
  },
  {
    "gene": "PYGM",
    "phenotype": "McArdle disease [MIM: 232600]",
    "omimEntry": "608455",
    "inheritance": "AR"
  },
  {
    "gene": "PYROXD1",
    "phenotype": "Myopathy, myofibrillar, 8 [MIM: 617258]",
    "omimEntry": "617220",
    "inheritance": "AR"
  },
  {
    "gene": "QARS1",
    "phenotype": "Microcephaly, progressive, seizures, and cerebral and cerebellar atrophy [MIM: 615760]",
    "omimEntry": "603727",
    "inheritance": "AR"
  },
  {
    "gene": "QDPR",
    "phenotype": "Hyperphenylalaninemia, BH4-deficient, C [MIM: 261630]",
    "omimEntry": "612676",
    "inheritance": "AR"
  },
  {
    "gene": "RAB18",
    "phenotype": "Warburg micro syndrome 3 [MIM: 614222]",
    "omimEntry": "602207",
    "inheritance": "AR"
  },
  {
    "gene": "RAB27A",
    "phenotype": "Griscelli syndrome, type 2 [MIM: 607624]",
    "omimEntry": "603868",
    "inheritance": "AR"
  },
  {
    "gene": "RAB39B",
    "phenotype": "Intellectual developmental disorder, X-linked 72 [MIM: 300271]; Waisman syndrome [MIM: 311510]",
    "omimEntry": "300774",
    "inheritance": "XLR"
  },
  {
    "gene": "RAB3GAP1",
    "phenotype": "Martsolf syndrome 2 [MIM: 619420]; Warburg micro syndrome 1 [MIM: 600118]",
    "omimEntry": "602536",
    "inheritance": "AR"
  },
  {
    "gene": "RAD50",
    "phenotype": "Nijmegen breakage syndrome-like disorder [MIM: 613078]",
    "omimEntry": "604040",
    "inheritance": "AR"
  },
  {
    "gene": "RAPGEF2",
    "phenotype": "Familial Adult Myoclonic Epilepsy 7 [MIM: 618075]",
    "omimEntry": "609530",
    "inheritance": "AD"
  },
  {
    "gene": "RAPSN",
    "phenotype": "Fetal akinesia deformation sequence 2 [MIM: 618388]; Myasthenic syndrome, congenital, 11, associated with acetylcholine receptor deficiency [MIM: 616236]",
    "omimEntry": "601592",
    "inheritance": "AR"
  },
  {
    "gene": "RARS1",
    "phenotype": "Leukodystrophy, hypomyelinating, 9 [MIM: 616140]",
    "omimEntry": "107820",
    "inheritance": "AR"
  },
  {
    "gene": "RARS2",
    "phenotype": "Pontocerebellar hypoplasia, type 6 [MIM: 611523]",
    "omimEntry": "611524",
    "inheritance": "AR"
  },
  {
    "gene": "RBCK1",
    "phenotype": "Polyglucosan body myopathy 1 with or without immunodeficiency [MIM: 615895]",
    "omimEntry": "610924",
    "inheritance": "AR"
  },
  {
    "gene": "REEP1",
    "phenotype": "Neuronopathy, distal hereditary motor, autosomal dominant 12 [MIM: 614751]; Neuronopathy, distal hereditary motor, autosomal recessive 6 [MIM: 620011]; Spastic paraplegia 31, autosomal dominant [MIM: 610250]",
    "omimEntry": "609139",
    "inheritance": "AD, AR"
  },
  {
    "gene": "REEP2",
    "phenotype": "Spastic paraplegia 72B, autosomal recessive [MIM: 620606]; Spastic paraplegia 72A, autosomal dominant [MIM: 615625]",
    "omimEntry": "609347",
    "inheritance": "AD, AR"
  },
  {
    "gene": "RETREG1",
    "phenotype": "Neuropathy, hereditary sensory and autonomic, type IIB [MIM: 613115]",
    "omimEntry": "613114",
    "inheritance": "AR"
  },
  {
    "gene": "RFC1",
    "phenotype": "Cerebellar ataxia neuropathy and vestibular areflexia syndrome [MIM: 614575]",
    "omimEntry": "102579",
    "inheritance": "AR"
  },
  {
    "gene": "RFT1",
    "phenotype": "Congenital disorder of glycosylation, type In [MIM: 612015]",
    "omimEntry": "611908",
    "inheritance": "AR"
  },
  {
    "gene": "RHOBTB2",
    "phenotype": "Developmental and epileptic encephalopathy 64 [MIM: 618004]",
    "omimEntry": "607352",
    "inheritance": "AD"
  },
  {
    "gene": "RLIM",
    "phenotype": "Tonne-Kalscheuer syndrome [MIM: 300978]",
    "omimEntry": "300379",
    "inheritance": "XL"
  },
  {
    "gene": "RNASEH1",
    "phenotype": "Progressive external ophthalmoplegia with mitochondrial DNA deletions, autosomal recessive 2 [MIM: 616479]",
    "omimEntry": "604123",
    "inheritance": "AR"
  },
  {
    "gene": "RNASEH2A",
    "phenotype": "Aicardi-Goutieres syndrome 4 [MIM: 610333]",
    "omimEntry": "606034",
    "inheritance": "AR"
  },
  {
    "gene": "RNASEH2B",
    "phenotype": "Aicardi-Goutieres syndrome 2 [MIM: 610181]",
    "omimEntry": "610326",
    "inheritance": "AR"
  },
  {
    "gene": "RNASEH2C",
    "phenotype": "Aicardi-Goutieres syndrome 3 [MIM: 610329]",
    "omimEntry": "610330",
    "inheritance": "AR"
  },
  {
    "gene": "RNASET2",
    "phenotype": "Leukoencephalopathy, cystic, without megalencephaly [MIM: 612951]",
    "omimEntry": "612944",
    "inheritance": "AR"
  },
  {
    "gene": "RNF113A",
    "phenotype": "Trichothiodystrophy 5, nonphotosensitive [MIM: 300953]",
    "omimEntry": "300951",
    "inheritance": "XL"
  },
  {
    "gene": "RNF125",
    "phenotype": "Tenorio syndrome [MIM: 616260]",
    "omimEntry": "610432",
    "inheritance": "AD"
  },
  {
    "gene": "RNF168",
    "phenotype": "RIDDLE syndrome [MIM: 611943]",
    "omimEntry": "612688",
    "inheritance": "AR"
  },
  {
    "gene": "RNF170",
    "phenotype": "Ataxia, sensory, 1, autosomal dominant [MIM: 608984]; Spastic paraplegia 85, autosomal recessive [MIM: 619686]",
    "omimEntry": "614649",
    "inheritance": "AD, AR"
  },
  {
    "gene": "RNF216",
    "phenotype": "Cerebellar ataxia and hypogonadotropic hypogonadism [MIM: 212840]",
    "omimEntry": "609948",
    "inheritance": "AR"
  },
  {
    "gene": "ROGDI",
    "phenotype": "Kohlschutter-Tonz syndrome [MIM: 226750]",
    "omimEntry": "614574",
    "inheritance": "AR"
  },
  {
    "gene": "RORA",
    "phenotype": "Intellectual developmental disorder with or without epilepsy or cerebellar ataxia [MIM: 618060]",
    "omimEntry": "600825",
    "inheritance": "AD"
  },
  {
    "gene": "RPGRIP1L",
    "phenotype": "COACH syndrome 3  [MIM: 619113]; Joubert syndrome 7 [MIM: 611560]; Meckel syndrome 5 [MIM: 611561]",
    "omimEntry": "610937",
    "inheritance": "AR"
  },
  {
    "gene": "RPIA",
    "phenotype": "Ribose 5-phosphate isomerase deficiency [MIM: 608611]",
    "omimEntry": "180430",
    "inheritance": "AR"
  },
  {
    "gene": "RPL10",
    "phenotype": "{Autism, susceptibility to, X-linked 5} [MIM: 300847]; Intellectual developmental disorder, X-linked syndromic 35 [MIM: 300998]",
    "omimEntry": "312173",
    "inheritance": "XLR"
  },
  {
    "gene": "RRM2B",
    "phenotype": "Mitochondrial DNA depletion syndrome 8A (encephalomyopathic type with renal tubulopathy) [MIM: 612075]; Mitochondrial DNA depletion syndrome 8B (MNGIE type) [MIM: 612075]; Progressive external ophthalmoplegia with mitochondrial DNA deletions, autosomal dominant 5 [MIM: 613077]; Rod-cone dystrophy, sensorineural deafness, and Fanconi-type renal dysfunction [MIM: 268315]",
    "omimEntry": "604712",
    "inheritance": "AD, AR"
  },
  {
    "gene": "RTN2",
    "phenotype": "Neuronopathy, distal hereditary motor, autosomal recessive 11, with spasticity [MIM: 620854]; Spastic paraplegia 12, autosomal dominant [MIM: 604805]",
    "omimEntry": "603183",
    "inheritance": "AD, AR"
  },
  {
    "gene": "RTN4IP1",
    "phenotype": "Optic atrophy 10 with or without ataxia, impaired intellectual development and seizures [MIM: 616732]",
    "omimEntry": "610502",
    "inheritance": "AR"
  },
  {
    "gene": "RTTN",
    "phenotype": "Microcephaly, short stature, and polymicrogyria with seizures [MIM: 614833]",
    "omimEntry": "610436",
    "inheritance": "AR"
  },
  {
    "gene": "RUBCN",
    "phenotype": "Spinocerebellar ataxia, autosomal recessive 15 [MIM: 615705]",
    "omimEntry": "613516",
    "inheritance": "AR"
  },
  {
    "gene": "RXYLT1",
    "phenotype": "Muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type A, 10 [MIM: 615041]",
    "omimEntry": "605862",
    "inheritance": "AR"
  },
  {
    "gene": "RYR1",
    "phenotype": "{Malignant hyperthermia susceptibility 1} [MIM: 145600]; Congenital myopathy 1A, autosomal dominant, with susceptibility to malignant hyperthermia [MIM: 117000]; Congenital myopathy 1B, autosomal recessive [MIM: 255320]; King-Denborough syndrome [MIM: 619542]",
    "omimEntry": "180901",
    "inheritance": "AD, AR"
  },
  {
    "gene": "RYR3",
    "phenotype": "Congenital myopathy 20 [MIM: 620310]",
    "omimEntry": "180903",
    "inheritance": "AR"
  },
  {
    "gene": "SACS",
    "phenotype": "Spastic ataxia, Charlevoix-Saguenay type [MIM: 270550]",
    "omimEntry": "604490",
    "inheritance": "AR"
  },
  {
    "gene": "SAMD12",
    "phenotype": "Familial Adult Myoclonic Epilepsy 1 [MIM: 601068]",
    "omimEntry": "618073",
    "inheritance": "AD"
  },
  {
    "gene": "SAMD9L",
    "phenotype": "Spinocerebellar ataxia 49 [MIM: 619806]; Ataxia-pancytopenia syndrome [MIM: 159550]; Monosomy 7 myelodysplasia and leukemia syndrome 1 [MIM: 252270]",
    "omimEntry": "611170",
    "inheritance": "AD"
  },
  {
    "gene": "SAMHD1",
    "phenotype": "Chilblain lupus 2  [MIM: 614415]; Aicardi-Goutieres syndrome 5 [MIM: 612952]",
    "omimEntry": "606754",
    "inheritance": "AD, AR"
  },
  {
    "gene": "SARS1",
    "phenotype": "Neurodevelopmental disorder with microcephaly, ataxia, and seizures [MIM: 617709]",
    "omimEntry": "607529",
    "inheritance": "AR"
  },
  {
    "gene": "SCARB2",
    "phenotype": "Epilepsy, progressive myoclonic 4, with or without renal failure [MIM: 254900]",
    "omimEntry": "602257",
    "inheritance": "AR"
  },
  {
    "gene": "SCN1A",
    "phenotype": "Developmental and epileptic encephalopathy 6B, non-Dravet [MIM: 619317]; Dravet syndrome [MIM: 607208]; Febrile seizures, familial, 3A [MIM: 604403]; Generalized epilepsy with febrile seizures plus, type 2 [MIM: 604403]; Migraine, familial hemiplegic, 3 [MIM: 609634]",
    "omimEntry": "182389",
    "inheritance": "AD"
  },
  {
    "gene": "SCN1B",
    "phenotype": "Atrial fibrillation, familial, 13 [MIM: 615377]; Brugada syndrome 5 [MIM: 612838]; Cardiac conduction defect, nonspecific [MIM: 612838]; Developmental and epileptic encephalopathy 52 [MIM: 617350]; Generalized epilepsy with febrile seizures plus, type 1 [MIM: 604233]",
    "omimEntry": "600235",
    "inheritance": "AD, AR"
  },
  {
    "gene": "SCN2A",
    "phenotype": "Developmental and epileptic encephalopathy 11 [MIM: 613721]; Episodic ataxia, type 9 [MIM: 618924]; Seizures, benign familial infantile, 3 [MIM: 607745]",
    "omimEntry": "182390",
    "inheritance": "AD"
  },
  {
    "gene": "SCN4A",
    "phenotype": "Congenital myopathy 22A, classic [MIM: 620351]; Congenital myopathy 22B, severe fetal [MIM: 620369]; Hyperkalemic periodic paralysis [MIM: 170500]; Hypokalemic periodic paralysis, type 2 [MIM: 613345]; Myasthenic syndrome, congenital, 16 [MIM: 614198]; Myotonia congenita, atypical, acetazolamide-responsive [MIM: 608390]; Paramyotonia congenita [MIM: 168300]",
    "omimEntry": "603967",
    "inheritance": "AD, AR"
  },
  {
    "gene": "SCN8A",
    "phenotype": "Myoclonus, familial, 2 [MIM: 618364]; Cognitive impairment with or without cerebellar ataxia [MIM: 614306]; Developmental and epileptic encephalopathy 13 [MIM: 614558]; Seizures, benign familial infantile, 5 [MIM: 617080]",
    "omimEntry": "600702",
    "inheritance": "AD"
  },
  {
    "gene": "SCN9A",
    "phenotype": "Erythermalgia, primary [MIM: 133020]; Insensitivity to pain, congenital [MIM: 243000]; Neuropathy, hereditary sensory and autonomic, type IID [MIM: 243000]; Paroxysmal extreme pain disorder [MIM: 167400]; Small fiber neuropathy [MIM: 133020]",
    "omimEntry": "603415",
    "inheritance": "AD, AR"
  },
  {
    "gene": "SCO1",
    "phenotype": "Mitochondrial complex IV deficiency, nuclear type 4 [MIM: 619048]",
    "omimEntry": "603644",
    "inheritance": "AR"
  },
  {
    "gene": "SCO2",
    "phenotype": "Mitochondrial complex IV deficiency, nuclear type 2 [MIM: 604377]; Myopia 6 [MIM: 608908]",
    "omimEntry": "604272",
    "inheritance": "AD. AR"
  },
  {
    "gene": "SCP2",
    "phenotype": "Leukoencephalopathy with dystonia and motor neuropathy [MIM: 613724]",
    "omimEntry": "184755",
    "inheritance": "AR"
  },
  {
    "gene": "SCYL1",
    "phenotype": "Spinocerebellar ataxia, autosomal recessive 21 [MIM: 616719]",
    "omimEntry": "607982",
    "inheritance": "AR"
  },
  {
    "gene": "SDHA",
    "phenotype": "Cardiomyopathy, dilated, 1GG [MIM: 613642]; Mitochondrial complex II deficiency, nuclear type 1 [MIM: 252011]; Neurodegeneration with ataxia and late-onset optic atrophy [MIM: 619259]; Pheochromocytoma/paraganglioma syndrome 5 [MIM: 614165]",
    "omimEntry": "600857",
    "inheritance": "AD, AR"
  },
  {
    "gene": "SDHAF1",
    "phenotype": "Mitochondrial complex II deficiency, nuclear type 2 [MIM: 619166]",
    "omimEntry": "612848",
    "inheritance": "AR"
  },
  {
    "gene": "SDHB",
    "phenotype": "Gastrointestinal stromal tumor [MIM: 606764]; Mitochondrial complex II deficiency, nuclear type 4 [MIM: 619224];  Paraganglioma and gastric stromal sarcoma [MIM: 606864]; Pheochromocytoma/paraganglioma syndrome 4 [MIM: 115310]",
    "omimEntry": "185470",
    "inheritance": "AD, AR, IC"
  },
  {
    "gene": "SDHD",
    "phenotype": "Mitochondrial complex II deficiency, nuclear type 3 [MIM: 619167]; Paraganglioma and gastric stromal sarcoma [MIM: 606864]; Pheochromocytoma/paraganglioma syndrome 1 [MIM: 168000]",
    "omimEntry": "602690",
    "inheritance": "AD, AR"
  },
  {
    "gene": "SELENOI",
    "phenotype": "Spastic paraplegia 81, autosomal recessive [MIM: 618768]",
    "omimEntry": "607915",
    "inheritance": "AR"
  },
  {
    "gene": "SELENON",
    "phenotype": "Congenital myopathy 3 with rigid spine [MIM: 602771]",
    "omimEntry": "606210",
    "inheritance": "AR"
  },
  {
    "gene": "SEPSECS",
    "phenotype": "Pontocerebellar hypoplasia type 2D [MIM: 613811]",
    "omimEntry": "613009",
    "inheritance": "AR"
  },
  {
    "gene": "SERAC1",
    "phenotype": "3-methylglutaconic aciduria with deafness, encephalopathy, and Leigh-like syndrome [MIM: 614739]",
    "omimEntry": "614725",
    "inheritance": "AR"
  },
  {
    "gene": "SETX",
    "phenotype": "Amyotrophic lateral sclerosis 4, juvenile [MIM: 602433]; Spinocerebellar ataxia, autosomal recessive, with axonal neuropathy 2 [MIM: 606002]",
    "omimEntry": "608465",
    "inheritance": "AD, AR"
  },
  {
    "gene": "SFXN4",
    "phenotype": "Combined oxidative phosphorylation deficiency 18 [MIM: 615578]",
    "omimEntry": "615564",
    "inheritance": "AR"
  },
  {
    "gene": "SGCA",
    "phenotype": "Muscular dystrophy, limb-girdle, autosomal recessive 3 [MIM: 608099]",
    "omimEntry": "600119",
    "inheritance": "AR"
  },
  {
    "gene": "SGCB",
    "phenotype": "Muscular dystrophy, limb-girdle, autosomal recessive 4 [MIM: 604286]",
    "omimEntry": "600900",
    "inheritance": "AR"
  },
  {
    "gene": "SGCD",
    "phenotype": "Cardiomyopathy, dilated, 1L [MIM: 606685]; Muscular dystrophy, limb-girdle, autosomal recessive 6 [MIM: 601287]",
    "omimEntry": "601411",
    "inheritance": "AR"
  },
  {
    "gene": "SGCE",
    "phenotype": "Dystonia-11, myoclonic [MIM: 159900]",
    "omimEntry": "604149",
    "inheritance": "AD"
  },
  {
    "gene": "SGCG",
    "phenotype": "Muscular dystrophy, limb-girdle, autosomal recessive 5 [MIM: 253700]",
    "omimEntry": "608896",
    "inheritance": "AR"
  },
  {
    "gene": "SGPL1",
    "phenotype": "RENI syndrome [MIM: 617575]",
    "omimEntry": "603729",
    "inheritance": "AR"
  },
  {
    "gene": "SH3TC2",
    "phenotype": "Charcot-Marie-Tooth disease, type 4C [MIM: 601596]; Mononeuropathy of the median nerve, mild [MIM: 613353]",
    "omimEntry": "608206",
    "inheritance": "AD, AR"
  },
  {
    "gene": "SHMT2",
    "phenotype": "Neurodevelopmental disorder with cardiomyopathy, spasticity, and brain abnormalities [MIM: 619121]",
    "omimEntry": "138450",
    "inheritance": "AR"
  },
  {
    "gene": "SIGMAR1",
    "phenotype": "Amyotrophic lateral sclerosis 16, juvenile [MIM: 614373]; Neuronopathy, distal hereditary motor, autosomal recessive 2 [MIM: 605726]",
    "omimEntry": "601978",
    "inheritance": "AR"
  },
  {
    "gene": "SIL1",
    "phenotype": "Marinesco-Sjogren syndrome [MIM: 248800]",
    "omimEntry": "608005",
    "inheritance": "AR"
  },
  {
    "gene": "SLC12A6",
    "phenotype": "Agenesis of the corpus callosum with peripheral neuropathy [MIM: 218000]; Charcot-Marie-Tooth disease, axonal, type 2II [MIM: 620068]",
    "omimEntry": "604878",
    "inheritance": "AD, AR"
  },
  {
    "gene": "SLC13A5",
    "phenotype": "Developmental and epileptic encephalopathy 25, with amelogenesis imperfecta [MIM: 615905]",
    "omimEntry": "608305",
    "inheritance": "AR"
  },
  {
    "gene": "SLC16A2",
    "phenotype": "Allan-Herndon-Dudley syndrome [MIM: 300523]",
    "omimEntry": "300095",
    "inheritance": "XL"
  },
  {
    "gene": "SLC17A5",
    "phenotype": "Salla disease [MIM: 604369]; Sialic acid storage disorder, infantile [MIM: 269920]",
    "omimEntry": "604322",
    "inheritance": "AR"
  },
  {
    "gene": "SLC18A2",
    "phenotype": "Parkinsonism-dystonia, infantile, 2 [MIM: 618049]",
    "omimEntry": "193001",
    "inheritance": "AR"
  },
  {
    "gene": "SLC18A3",
    "phenotype": "Myasthenic syndrome, congenital, 21, presynaptic [MIM: 617239]",
    "omimEntry": "600336",
    "inheritance": "AR"
  },
  {
    "gene": "SLC19A2",
    "phenotype": "Thiamine-responsive megaloblastic anemia syndrome [MIM: 249270]",
    "omimEntry": "603941",
    "inheritance": "AR"
  },
  {
    "gene": "SLC19A3",
    "phenotype": "Thiamine metabolism dysfunction syndrome 2 (biotin/thiamine-responsive basal ganglia disease type) [MIM: 607483]",
    "omimEntry": "606152",
    "inheritance": "AR"
  },
  {
    "gene": "SLC1A3",
    "phenotype": "Episodic ataxia, type 6 [MIM: 612656]",
    "omimEntry": "600111",
    "inheritance": "AD"
  },
  {
    "gene": "SLC1A4",
    "phenotype": "Spastic tetraplegia, thin corpus callosum, and progressive microcephaly [MIM: 616657]",
    "omimEntry": "600229",
    "inheritance": "AR"
  },
  {
    "gene": "SLC20A2",
    "phenotype": "Basal ganglia calcification, idiopathic, 1 [MIM: 213600]",
    "omimEntry": "158378",
    "inheritance": "AD"
  },
  {
    "gene": "SLC22A5",
    "phenotype": "Carnitine deficiency, systemic primary [MIM: 212140]",
    "omimEntry": "603377",
    "inheritance": "AR"
  },
  {
    "gene": "SLC25A1",
    "phenotype": "Combined D-2- and L-2-hydroxyglutaric aciduria [MIM: 615182]; Myasthenic syndrome, congenital, 23, presynaptic [MIM: 618197]",
    "omimEntry": "190315",
    "inheritance": "AR"
  },
  {
    "gene": "SLC25A12",
    "phenotype": "Developmental and epileptic encephalopathy 39 [MIM: 612949]",
    "omimEntry": "603667",
    "inheritance": "AR"
  },
  {
    "gene": "SLC25A15",
    "phenotype": "Hyperornithinemia-hyperammonemia-homocitrullinemia syndrome [MIM: 238970]",
    "omimEntry": "603861",
    "inheritance": "AR"
  },
  {
    "gene": "SLC25A20",
    "phenotype": "Carnitine-acylcarnitine translocase deficiency [MIM: 212138]",
    "omimEntry": "613698",
    "inheritance": "AR"
  },
  {
    "gene": "SLC25A22",
    "phenotype": "Developmental and epileptic encephalopathy 3 [MIM: 609304]",
    "omimEntry": "609302",
    "inheritance": "AR"
  },
  {
    "gene": "SLC25A3",
    "phenotype": "Mitochondrial phosphate carrier deficiency [MIM: 610773]",
    "omimEntry": "600370",
    "inheritance": "AR"
  },
  {
    "gene": "SLC25A4",
    "phenotype": "Mitochondrial DNA depletion syndrome 12A (cardiomyopathic type) AD [MIM: 617184]; Mitochondrial DNA depletion syndrome 12B (cardiomyopathic type) AR [MIM: 615418]; Progressive external ophthalmoplegia with mitochondrial DNA deletions, autosomal dominant 2 [MIM: 609283]",
    "omimEntry": "103220",
    "inheritance": "AD, AR"
  },
  {
    "gene": "SLC25A42",
    "phenotype": "Metabolic crises, recurrent, with variable encephalomyopathic features and neurologic regression [MIM: 618416]",
    "omimEntry": "610823",
    "inheritance": "AR"
  },
  {
    "gene": "SLC25A46",
    "phenotype": "Neuropathy, hereditary motor and sensory, type VIB [MIM: 616505]; Pontocerebellar hypoplasia, type 1E [MIM: 619303]",
    "omimEntry": "610826",
    "inheritance": "AR"
  },
  {
    "gene": "SLC2A1",
    "phenotype": "{Epilepsy, idiopathic generalized, susceptibility to, 12} [MIM: 614847]; Dystonia 9 [MIM: 601042]; GLUT1 deficiency syndrome 1, infantile onset, severe [MIM: 606777]; GLUT1 deficiency syndrome 2, childhood onset [MIM: 612126]; Stomatin-deficient cryohydrocytosis with neurologic defects [MIM: 608885]",
    "omimEntry": "138140",
    "inheritance": "AD"
  },
  {
    "gene": "SLC30A10",
    "phenotype": "Hypermanganesemia with dystonia 1 [MIM: 613280]",
    "omimEntry": "611146",
    "inheritance": "AR"
  },
  {
    "gene": "SLC30A9",
    "phenotype": "Birk-Landau-Perez syndrome [MIM: 617595]",
    "omimEntry": "604604",
    "inheritance": "AR"
  },
  {
    "gene": "SLC33A1",
    "phenotype": "Huppke-Brendel syndrome [MIM: 614482]; Spastic paraplegia 42, autosomal dominant [MIM: 612539]",
    "omimEntry": "603690",
    "inheritance": "AD, AR"
  },
  {
    "gene": "SLC39A14",
    "phenotype": "Hyperostosis cranalis interna [MIM: 144755]; Hypermanganesemia with dystonia 2 [MIM: 617013]",
    "omimEntry": "608736",
    "inheritance": "AD, AR"
  },
  {
    "gene": "SLC39A4",
    "phenotype": "Acrodermatitis enteropathica [MIM: 201100]",
    "omimEntry": "607059",
    "inheritance": "AR"
  },
  {
    "gene": "SLC44A1",
    "phenotype": "Neurodegeneration, childhood-onset, with ataxia, tremor, optic atrophy, and cognitive decline [MIM: 618868]",
    "omimEntry": "606105",
    "inheritance": "AR"
  },
  {
    "gene": "SLC46A1",
    "phenotype": "Folate malabsorption, hereditary [MIM: 229050]",
    "omimEntry": "611672",
    "inheritance": "AR"
  },
  {
    "gene": "SLC52A2",
    "phenotype": "Brown-Vialetto-Van Laere syndrome 2 [MIM: 614707]",
    "omimEntry": "607882",
    "inheritance": "AR"
  },
  {
    "gene": "SLC52A3",
    "phenotype": "Fazio-Londe disease [MIM: 211500]; Brown-Vialetto-Van Laere syndrome 1 [MIM: 211530]",
    "omimEntry": "613350",
    "inheritance": "AR"
  },
  {
    "gene": "SLC5A7",
    "phenotype": "Myasthenic syndrome, congenital, 20, presynaptic [MIM: 617143]; Neuronopathy, distal hereditary motor, autosomal dominant 7 [MIM: 158580]",
    "omimEntry": "608761",
    "inheritance": "AD, AR"
  },
  {
    "gene": "SLC6A1",
    "phenotype": "Myoclonic-atonic epilepsy [MIM: 616421]",
    "omimEntry": "137165",
    "inheritance": "AD"
  },
  {
    "gene": "SLC6A17",
    "phenotype": "Intellectual developmental disorder, autosomal recessive 48 [MIM: 616269]",
    "omimEntry": "610299",
    "inheritance": "AR"
  },
  {
    "gene": "SLC6A19",
    "phenotype": "Hartnup disorder [MIM: 234500]",
    "omimEntry": "608893",
    "inheritance": "AR"
  },
  {
    "gene": "SLC6A3",
    "phenotype": "{Nicotine dependence, protection against} [MIM: 188890]; Parkinsonism-dystonia, infantile, 1 [MIM: 613135]",
    "omimEntry": "126455",
    "inheritance": "AR"
  },
  {
    "gene": "SLC6A8",
    "phenotype": "Cerebral creatine deficiency syndrome 1 [MIM: 300352]",
    "omimEntry": "300036",
    "inheritance": "XLR"
  },
  {
    "gene": "SLC9A1",
    "phenotype": "Lichtenstein-Knorr syndrome [MIM: 616291]",
    "omimEntry": "107310",
    "inheritance": "AR"
  },
  {
    "gene": "SLC9A6",
    "phenotype": "Intellectual developmental disorder, X-linked syndromic, Christianson type [MIM: 300243]; Neurodegenerative disorder, X-linked, female-restricted, with parkinsonism and cognitive impairment [MIM: 301142]",
    "omimEntry": "300231",
    "inheritance": "XL, XLD"
  },
  {
    "gene": "SMAD4",
    "phenotype": "Juvenile polyposis/hereditary hemorrhagic telangiectasia syndrome [MIM: 175050]; Myhre syndrome [MIM: 139210]; Pancreatic cancer, somatic [MIM: 260350]; Polyposis, juvenile intestinal [MIM: 174900];",
    "omimEntry": "600993",
    "inheritance": "AD"
  },
  {
    "gene": "SMC1A",
    "phenotype": "Cornelia de Lange syndrome 2 [MIM: 300590]; Developmental and epileptic encephalopathy 85, with or without midline brain defects [MIM: 301044]",
    "omimEntry": "300040",
    "inheritance": "XLD"
  },
  {
    "gene": "SMCHD1",
    "phenotype": "Bosma arhinia microphthalmia syndrome [MIM: 603457]; Facioscapulohumeral muscular dystrophy 2, digenic [MIM: 158901]",
    "omimEntry": "614982",
    "inheritance": "AD, DD"
  },
  {
    "gene": "SMG9",
    "phenotype": "Heart and brain malformation syndrome [MIM: 616920]; Neurodevelopmental disorder with intention tremor, pyramidal signs, dyspraxia, and ocular anomalies [MIM: 619995]",
    "omimEntry": "613176",
    "inheritance": "AR"
  },
  {
    "gene": "SMPD1",
    "phenotype": "Niemann-Pick disease, type A [MIM: 257200]; Niemann-Pick disease, type B [MIM: 607616]",
    "omimEntry": "607608",
    "inheritance": "AR"
  },
  {
    "gene": "SMPX",
    "phenotype": "Deafness, X-linked 4 [MIM: 300066]; Myopathy, distal, 7, adult-onset, X-linked [MIM: 301075]",
    "omimEntry": "300226",
    "inheritance": "XLD, XLR"
  },
  {
    "gene": "SNAP25",
    "phenotype": "Developmental and epileptic encephalopathy 117 [MIM: 616330]",
    "omimEntry": "600322",
    "inheritance": "AD"
  },
  {
    "gene": "SNCA",
    "phenotype": "Dementia, Lewy body [MIM: 127750]; Parkinson disease 1\t [MIM: 168601]; Parkinson disease 4 [MIM: 605543]",
    "omimEntry": "163890",
    "inheritance": "AD"
  },
  {
    "gene": "SNORD118",
    "phenotype": "Leukoencephalopathy, brain calcifications, and cysts [MIM: 614561]",
    "omimEntry": "616663",
    "inheritance": "AR"
  },
  {
    "gene": "SNX14",
    "phenotype": "Spinocerebellar ataxia, autosomal recessive 20 [MIM: 616354]",
    "omimEntry": "616105",
    "inheritance": "AR"
  },
  {
    "gene": "SOD1",
    "phenotype": "Amyotrophic lateral sclerosis 1 [MIM: 105400]; Spastic tetraplegia and axial hypotonia, progressive [MIM: 618598]",
    "omimEntry": "147450",
    "inheritance": "AD, AR"
  },
  {
    "gene": "SOX10",
    "phenotype": "PCWH syndrome [MIM: 609136]; Waardenburg syndrome, type 2E, with or without neurologic involvement [MIM: 611584]; Waardenburg syndrome, type 4C [MIM: 613266]",
    "omimEntry": "602229",
    "inheritance": "AD"
  },
  {
    "gene": "SOX2",
    "phenotype": "Microphthalmia, syndromic 3 [MIM: 206900]; Optic nerve hypoplasia and abnormalities of the central nervous system [MIM: 206900]",
    "omimEntry": "184429",
    "inheritance": "AD"
  },
  {
    "gene": "SOX6",
    "phenotype": "Tolchin-Le Caignec syndrome [MIM: 618971]",
    "omimEntry": "607257",
    "inheritance": "AD"
  },
  {
    "gene": "SPART",
    "phenotype": "Troyer syndrome [MIM: 275900]",
    "omimEntry": "607111",
    "inheritance": "AR"
  },
  {
    "gene": "SPAST",
    "phenotype": "Spastic paraplegia 4, autosomal dominant [MIM: 182601]",
    "omimEntry": "604277",
    "inheritance": "AD"
  },
  {
    "gene": "SPEG",
    "phenotype": "Centronuclear myopathy 5 [MIM: 615959]",
    "omimEntry": "615950",
    "inheritance": "AR"
  },
  {
    "gene": "SPG11",
    "phenotype": "Amyotrophic lateral sclerosis 5, juvenile [MIM: 602099]; Charcot-Marie-Tooth disease, axonal, type 2X [MIM: 616668]; Spastic paraplegia 11, autosomal recessive [MIM: 604360]",
    "omimEntry": "610844",
    "inheritance": "AR"
  },
  {
    "gene": "SPG21",
    "phenotype": "Mast syndrome [MIM: 248900]",
    "omimEntry": "608181",
    "inheritance": "AR"
  },
  {
    "gene": "SPG7",
    "phenotype": "Spastic paraplegia 7, autosomal recessive [MIM: 607259]",
    "omimEntry": "602783",
    "inheritance": "AR"
  },
  {
    "gene": "SPR",
    "phenotype": "Dystonia, dopa-responsive, due to sepiapterin reductase deficiency [MIM: 612716]",
    "omimEntry": "182125",
    "inheritance": "AD, AR"
  },
  {
    "gene": "SPTAN1",
    "phenotype": "Developmental and epileptic encephalopathy 5 [MIM: 613477]; Developmental delay with or without epilepsy [MIM: 620540]; Neuronopathy, distal hereditary motor, autosomal dominant 11 [MIM: 620528]; Spastic paraplegia 91, autosomal dominant, with or without cerebellar ataxia [MIM: 620538]",
    "omimEntry": "182810",
    "inheritance": "AD"
  },
  {
    "gene": "SPTBN2",
    "phenotype": "Spinocerebellar ataxia 5 [MIM: 600224]; Spinocerebellar ataxia, autosomal recessive 14 [MIM: 615386]",
    "omimEntry": "604985",
    "inheritance": "AD, AR"
  },
  {
    "gene": "SPTBN4",
    "phenotype": "Neurodevelopmental disorder with hypotonia, neuropathy, and deafness [MIM: 617519]",
    "omimEntry": "606214",
    "inheritance": "AR"
  },
  {
    "gene": "SPTLC2",
    "phenotype": "Neuropathy, hereditary sensory and autonomic, type IC [MIM: 613640]",
    "omimEntry": "605713",
    "inheritance": "AD"
  },
  {
    "gene": "SQSTM1",
    "phenotype": "Frontotemporal dementia and/or amyotrophic lateral sclerosis 3 [MIM: 616437]; Myopathy, distal, with rimmed vacuoles [MIM: 617158]; Neurodegeneration with ataxia, dystonia, and gaze palsy, childhood-onset [MIM: 617145]; Paget disease of bone 3 [MIM: 167250]",
    "omimEntry": "601530",
    "inheritance": "AD, AR"
  },
  {
    "gene": "STAC3",
    "phenotype": "Congenital myopathy 13 [MIM: 255995]",
    "omimEntry": "615521",
    "inheritance": "AR"
  },
  {
    "gene": "STAMBP",
    "phenotype": "Microcephaly-capillary malformation syndrome [MIM: 614261]",
    "omimEntry": "606247",
    "inheritance": "AR"
  },
  {
    "gene": "STIM1",
    "phenotype": "Immunodeficiency 10 [MIM: 612783]; Myopathy, tubular aggregate, 1 [MIM: 160565]; Stormorken syndrome [MIM: 185070]",
    "omimEntry": "605921",
    "inheritance": "AD, AR"
  },
  {
    "gene": "STN1",
    "phenotype": "Cerebroretinal microangiopathy with calcifications and cysts 2 [MIM: 617341]",
    "omimEntry": "613128",
    "inheritance": "AR"
  },
  {
    "gene": "STUB1",
    "phenotype": "Spinocerebellar ataxia 48 [MIM: 618093]; Spinocerebellar ataxia, autosomal recessive 16 [MIM: 615768]",
    "omimEntry": "607207",
    "inheritance": "AD, AR"
  },
  {
    "gene": "STXBP1",
    "phenotype": "Developmental and epileptic encephalopathy 4 [MIM: 612164]",
    "omimEntry": "602926",
    "inheritance": "AD, AR"
  },
  {
    "gene": "SUCLA2",
    "phenotype": "Mitochondrial DNA depletion syndrome 5 (encephalomyopathic with or without methylmalonic aciduria) [MIM: 612073]",
    "omimEntry": "603921",
    "inheritance": "AR"
  },
  {
    "gene": "SUCLG1",
    "phenotype": "Mitochondrial DNA depletion syndrome 9 (encephalomyopathic type with methylmalonic aciduria) [MIM: 245400]",
    "omimEntry": "611224",
    "inheritance": "AR"
  },
  {
    "gene": "SUFU",
    "phenotype": "{Medulloblastoma} [MIM: 155255]; {Meningioma, familial, susceptibility to} [MIM: 607174]; Basal cell nevus syndrome 2 [MIM: 620343]; Joubert syndrome 32 [MIM: 617757]",
    "omimEntry": "607035",
    "inheritance": "AD, AR, Smu"
  },
  {
    "gene": "SUMF1",
    "phenotype": "Multiple sulfatase deficiency [MIM: 272200]",
    "omimEntry": "607939",
    "inheritance": "AR"
  },
  {
    "gene": "SUOX",
    "phenotype": "Sulfite oxidase deficiency [MIM: 272300]",
    "omimEntry": "606887",
    "inheritance": "AR"
  },
  {
    "gene": "SURF1",
    "phenotype": "Charcot-Marie-Tooth disease, type 4K [MIM: 616684]; Mitochondrial complex IV deficiency, nuclear type 1 [MIM: 220110]",
    "omimEntry": "185620",
    "inheritance": "AR"
  },
  {
    "gene": "SVBP",
    "phenotype": "Neurodevelopmental disorder with ataxia, hypotonia, and microcephaly [MIM: 618569]",
    "omimEntry": "617853",
    "inheritance": "AR"
  },
  {
    "gene": "SYNE1",
    "phenotype": "Arthrogryposis multiplex congenita 3, myogenic type [MIM: 618484]; Emery-Dreifuss muscular dystrophy 4, autosomal dominant [MIM: 612998]; Emery-Dreifuss muscular dystrophy 4, autosomal dominant [MIM: 610743]",
    "omimEntry": "608441",
    "inheritance": "AD, AR"
  },
  {
    "gene": "SYNE2",
    "phenotype": "Emery-Dreifuss muscular dystrophy 5, autosomal dominant [MIM: 612999]",
    "omimEntry": "608442",
    "inheritance": "AD"
  },
  {
    "gene": "SYNJ1",
    "phenotype": "Developmental and epileptic encephalopathy 53 [MIM: 617389]; Parkinson disease 20, early-onset [MIM: 615530]",
    "omimEntry": "604297",
    "inheritance": "AR"
  },
  {
    "gene": "SYT14",
    "phenotype": "Spinocerebellar ataxia, autosomal recessive 11 [MIM: 614229]",
    "omimEntry": "610949",
    "inheritance": "AR"
  },
  {
    "gene": "SYT2",
    "phenotype": "Myasthenic syndrome, congenital, 7A, presynaptic, and distal motor neuropathy, autosomal dominant [MIM: 616040]; Myasthenic syndrome, congenital, 7B, presynaptic, autosomal recessive [MIM: 619461]",
    "omimEntry": "600104",
    "inheritance": "AD, AR"
  },
  {
    "gene": "TACO1",
    "phenotype": "Mitochondrial complex IV deficiency, nuclear type 8 [MIM: 619052]",
    "omimEntry": "612958",
    "inheritance": "AR"
  },
  {
    "gene": "TAF1",
    "phenotype": "Dystonia-Parkinsonism, X-linked [MIM: 314250]; Intellectual developmental disorder, X-linked syndromic 33 [MIM: 300966]",
    "omimEntry": "313650",
    "inheritance": "XLR"
  },
  {
    "gene": "TAF2",
    "phenotype": "Intellectual developmental disorder, autosomal recessive 40 [MIM: 615599]",
    "omimEntry": "604912",
    "inheritance": "AR"
  },
  {
    "gene": "TAFAZZIN",
    "phenotype": "Barth syndrome [MIM: 302060]",
    "omimEntry": "300394",
    "inheritance": "XLR"
  },
  {
    "gene": "TAMM41",
    "phenotype": "Combined oxidative phosphorylation deficiency 56 [MIM: 620139]",
    "omimEntry": "614948",
    "inheritance": "AR"
  },
  {
    "gene": "TANGO2",
    "phenotype": "Metabolic encephalomyopathic crises, recurrent, with rhabdomyolysis, cardiac arrhythmias, and neurodegeneration [MIM: 616878]",
    "omimEntry": "616830",
    "inheritance": "AR"
  },
  {
    "gene": "TARDBP",
    "phenotype": "Amyotrophic lateral sclerosis 10, with or without FTD [MIM: 612069]; Frontotemporal lobar degeneration, TARDBP-related [MIM: 612069]",
    "omimEntry": "605078",
    "inheritance": "AD"
  },
  {
    "gene": "TBC1D20",
    "phenotype": "Warburg micro syndrome 4 [MIM: 615663]",
    "omimEntry": "611663",
    "inheritance": "AR"
  },
  {
    "gene": "TBC1D23",
    "phenotype": "Pontocerebellar hypoplasia, type 11 [MIM: 617695]",
    "omimEntry": "617687",
    "inheritance": "AR"
  },
  {
    "gene": "TBC1D24",
    "phenotype": "Deafness, autosomal dominant 65 [MIM: 616044]; Deafness, autosomal recessive 86 [MIM: 614617]; Developmental and epileptic encephalopathy 16 [MIM: 615338]; DOORS syndrome [MIM: 220500]; Epilepsy, rolandic, with paroxysmal exercise-induce dystonia and writer's cramp [MIM: 608105]; Myoclonic epilepsy, infantile, familial [MIM: 605021]",
    "omimEntry": "613577",
    "inheritance": "AD, AR"
  },
  {
    "gene": "TBCD",
    "phenotype": "Encephalopathy, progressive, early-onset, with brain atrophy and thin corpus callosum [MIM: 617193]",
    "omimEntry": "604649",
    "inheritance": "AR"
  },
  {
    "gene": "TBCE",
    "phenotype": "Encephalopathy, progressive, with amyotrophy and optic atrophy [MIM: 617207]; Hypoparathyroidism-retardation-dysmorphism syndrome [MIM: 241410]; Kenny-Caffey syndrome, type 1 [MIM: 244460]",
    "omimEntry": "604934",
    "inheritance": "AR"
  },
  {
    "gene": "TBCK",
    "phenotype": "Hypotonia, infantile, with psychomotor retardation and characteristic facies 3 [MIM: 616900]",
    "omimEntry": "616899",
    "inheritance": "AR"
  },
  {
    "gene": "TBK1",
    "phenotype": "{Encephalopathy, acute, infection-induced (herpes-specific), susceptibility to, 8} [MIM: 617900]; Autoinflammation with arthritis and vasculitis [MIM: 620880]; Frontotemporal dementia and/or amyotrophic lateral sclerosis 4 [MIM: 616439]",
    "omimEntry": "604834",
    "inheritance": "AD, AR"
  },
  {
    "gene": "TBP",
    "phenotype": "{Parkinson disease susceptibility to} [MIM: 168600]; Spinocerebellar ataxia 17 [MIM: 607136]",
    "omimEntry": "600075",
    "inheritance": "AD, Multifactorial"
  },
  {
    "gene": "TCAP",
    "phenotype": "Cardiomyopathy, hypertrophic, 25 [MIM: 607487]; Muscular dystrophy, limb-girdle, autosomal recessive 7 [MIM: 601954]",
    "omimEntry": "604488",
    "inheritance": "AD. AR"
  },
  {
    "gene": "TCF4",
    "phenotype": "Corneal dystrophy, Fuchs endothelial, 3 [MIM: 613267]; Pitt-Hopkins syndrome [MIM: 610954]",
    "omimEntry": "602272",
    "inheritance": "AD"
  },
  {
    "gene": "TCN2",
    "phenotype": "Transcobalamin II deficiency [MIM: 275350]",
    "omimEntry": "613441",
    "inheritance": "AR"
  },
  {
    "gene": "TCTN1",
    "phenotype": "Joubert syndrome 13 [MIM: 614173]",
    "omimEntry": "609863",
    "inheritance": "AR"
  },
  {
    "gene": "TCTN2",
    "phenotype": "Meckel syndrome 8  [MIM: 613885]; Joubert syndrome 24 [MIM: 616654]",
    "omimEntry": "613846",
    "inheritance": "AR"
  },
  {
    "gene": "TCTN3",
    "phenotype": "Joubert syndrome 18 [MIM: 614815]; Orofaciodigital syndrome IV [MIM: 258860]",
    "omimEntry": "613847",
    "inheritance": "AR"
  },
  {
    "gene": "TDP1",
    "phenotype": "Spinocerebellar ataxia, autosomal recessive, with axonal neuropathy 1 [MIM: 607250]",
    "omimEntry": "607198",
    "inheritance": "AR"
  },
  {
    "gene": "TDP2",
    "phenotype": "Spinocerebellar ataxia, autosomal recessive 23 [MIM: 616949]",
    "omimEntry": "605764",
    "inheritance": "AR"
  },
  {
    "gene": "TECPR2",
    "phenotype": "Neuropathy, hereditary sensory and autonomic, type IX, with developmental delay [MIM: 615031]",
    "omimEntry": "615000",
    "inheritance": "AR"
  },
  {
    "gene": "TELO2",
    "phenotype": "You-Hoover-Fong syndrome [MIM: 616954]",
    "omimEntry": "611140",
    "inheritance": "AR"
  },
  {
    "gene": "TENM4",
    "phenotype": "Essential tremor, hereditary, 5 [MIM: 616736]",
    "omimEntry": "610084",
    "inheritance": "AD"
  },
  {
    "gene": "TFG",
    "phenotype": "Spastic paraplegia 57, autosomal recessive [MIM: 615658]; Hereditary motor and sensory neuropathy, Okinawa type [MIM: 604484]",
    "omimEntry": "602498",
    "inheritance": "AD, AR"
  },
  {
    "gene": "TGM6",
    "phenotype": "Spinocerebellar ataxia 35 [MIM: 613908]",
    "omimEntry": "613900",
    "inheritance": "AD"
  },
  {
    "gene": "TH",
    "phenotype": "Segawa syndrome, recessive [MIM: 605407]",
    "omimEntry": "191290",
    "inheritance": "AR"
  },
  {
    "gene": "THAP1",
    "phenotype": "Dystonia 6, torsion [MIM: 602629]",
    "omimEntry": "609520",
    "inheritance": "AD"
  },
  {
    "gene": "THAP11",
    "phenotype": "Spinocerebellar Ataxia 51 [MIM: 620947]",
    "omimEntry": "609119",
    "inheritance": "AD"
  },
  {
    "gene": "THG1L",
    "phenotype": "Spinocerebellar ataxia, autosomal recessive 28 [MIM: 618800]",
    "omimEntry": "618802",
    "inheritance": "AR"
  },
  {
    "gene": "THOC2",
    "phenotype": "Arthrogryposis multiplex congenita 7, X-linked [MIM: 301127]; Intellectual developmental disorder, X-linked syndromic, Kumar type [MIM: 300957]",
    "omimEntry": "300395",
    "inheritance": "XL"
  },
  {
    "gene": "TIA1",
    "phenotype": "Amyotrophic lateral sclerosis 26 with or without frontotemporal dementia [MIM: 619133]; Welander distal myopathy [MIM: 604454]",
    "omimEntry": "603518",
    "inheritance": "AD, AR"
  },
  {
    "gene": "TIMM8A",
    "phenotype": "Mohr-Tranebjaerg syndrome [MIM: 304700]",
    "omimEntry": "300356",
    "inheritance": "XLR"
  },
  {
    "gene": "TIMMDC1",
    "phenotype": "Mitochondrial complex I deficiency, nuclear type 31 [MIM: 618251]",
    "omimEntry": "615534",
    "inheritance": "AR"
  },
  {
    "gene": "TINF2",
    "phenotype": "Dyskeratosis congenita, autosomal dominant 3 [MIM: 613990]; Revesz syndrome [MIM: 268130]",
    "omimEntry": "604319",
    "inheritance": "AD"
  },
  {
    "gene": "TK2",
    "phenotype": "Progressive external ophthalmoplegia with mitochondrial DNA deletions, autosomal recessive 3 [MIM: 617069]; Mitochondrial DNA depletion syndrome 2 (myopathic type) [MIM: 609560]",
    "omimEntry": "188250",
    "inheritance": "AR"
  },
  {
    "gene": "TMEM107",
    "phenotype": "Joubert syndrome 29 [MIM: 617562]; Meckel syndrome 13 [MIM: 617562]; Orofaciodigital syndrome XVI [MIM: 617563]",
    "omimEntry": "616183",
    "inheritance": "AR"
  },
  {
    "gene": "TMEM126B",
    "phenotype": "Mitochondrial complex I deficiency, nuclear type 29 [MIM: 618250]",
    "omimEntry": "615533",
    "inheritance": "AR"
  },
  {
    "gene": "TMEM138",
    "phenotype": "Joubert syndrome 16 [MIM: 614465]",
    "omimEntry": "614459",
    "inheritance": "AR"
  },
  {
    "gene": "TMEM216",
    "phenotype": "Joubert syndrome 2 [MIM: 608091]; Meckel syndrome 2 [MIM: 603194]; Retinitis pigmentosa 98 [MIM: 620996]",
    "omimEntry": "613277",
    "inheritance": "AR"
  },
  {
    "gene": "TMEM231",
    "phenotype": "Joubert syndrome 20 [MIM: 614970]; Meckel syndrome 11 [MIM: 615397]",
    "omimEntry": "614949",
    "inheritance": "AR"
  },
  {
    "gene": "TMEM237",
    "phenotype": "Joubert syndrome 14 [MIM: 614424]",
    "omimEntry": "614423",
    "inheritance": "AR"
  },
  {
    "gene": "TMEM240",
    "phenotype": "Spinocerebellar ataxia 21 [MIM: 607454]",
    "omimEntry": "616101",
    "inheritance": "AD"
  },
  {
    "gene": "TMEM43",
    "phenotype": "Arrhythmogenic right ventricular dysplasia 5 [MIM: 604400]; Auditory neuropathy, autosomal dominant 3 [MIM: 619832]; Emery-Dreifuss muscular dystrophy 7, AD [MIM: 614302]",
    "omimEntry": "612048",
    "inheritance": "AD"
  },
  {
    "gene": "TMEM67",
    "phenotype": "RHYNS syndrome [MIM: 602152]; {Bardet-Biedl syndrome 14, modifier of} [MIM: 615991]; COACH syndrome 1 [MIM: 216360]; Joubert syndrome 6 [MIM: 610688]; Meckel syndrome 3 [MIM: 607361]; Nephronophthisis 11 [MIM: 613550]",
    "omimEntry": "609884",
    "inheritance": "AR"
  },
  {
    "gene": "TMEM70",
    "phenotype": "Mitochondrial complex V (ATP synthase) deficiency, nuclear type 2 [MIM: 614052]",
    "omimEntry": "612418",
    "inheritance": "AR"
  },
  {
    "gene": "TMX2",
    "phenotype": "Neurodevelopmental disorder with microcephaly, cortical malformations, and spasticity [MIM: 618730]",
    "omimEntry": "616715",
    "inheritance": "AR"
  },
  {
    "gene": "TNNC2",
    "phenotype": "Congenital myopathy 15 [MIM: 620161]",
    "omimEntry": "191039",
    "inheritance": "AD"
  },
  {
    "gene": "TNNI2",
    "phenotype": "Arthrogryposis, distal, type 2B1 [MIM: 601680]",
    "omimEntry": "191043",
    "inheritance": "AD"
  },
  {
    "gene": "TNNT1",
    "phenotype": "Nemaline myopathy 5A, autosomal recessive, severe infantile [MIM: 605355]; Nemaline myopathy 5B, autosomal recessive, childhood-onset [MIM: 620386]; Nemaline myopathy 5C, autosomal dominant [MIM: 620389]",
    "omimEntry": "191041",
    "inheritance": "AD"
  },
  {
    "gene": "TNNT3",
    "phenotype": "Arthrogryposis, distal, type 2B2 [MIM: 618435]",
    "omimEntry": "600692",
    "inheritance": "AD"
  },
  {
    "gene": "TNPO3",
    "phenotype": "Muscular dystrophy, limb-girdle, autosomal dominant 2 [MIM: 608423]",
    "omimEntry": "610032",
    "inheritance": "AD"
  },
  {
    "gene": "TNRC6A",
    "phenotype": "Epilepsy, familial adult myoclonic, 6 [MIM: 618074]",
    "omimEntry": "610739",
    "inheritance": "AD"
  },
  {
    "gene": "TOR1A",
    "phenotype": "{Dystonia-1, modifier of}; Arthrogryposis multiplex congenita 5 [MIM: 618947]; Dystonia-1, torsion [MIM: 128100]",
    "omimEntry": "605204",
    "inheritance": "AD, AR"
  },
  {
    "gene": "TOR1AIP1",
    "phenotype": "Muscular dystrophy, autosomal recessive, with rigid spine and distal joint contractures [MIM: 617072]",
    "omimEntry": "614512",
    "inheritance": "AR"
  },
  {
    "gene": "TP53RK",
    "phenotype": "Galloway-Mowat syndrome 4 [MIM: 617730]",
    "omimEntry": "608679",
    "inheritance": "AR"
  },
  {
    "gene": "TPI1",
    "phenotype": "Hemolytic anemia due to triosephosphate isomerase deficiency [MIM: 615512]",
    "omimEntry": "190450",
    "inheritance": "AR"
  },
  {
    "gene": "TPK1",
    "phenotype": "Thiamine metabolism dysfunction syndrome 5 (episodic encephalopathy type) [MIM: 614458]",
    "omimEntry": "606370",
    "inheritance": "AR"
  },
  {
    "gene": "TPM2",
    "phenotype": "Arthrogryposis, distal, type 1A [MIM: 108120]; Arthrogryposis, distal, type 2B4 [MIM: 108120]; Congenital myopathy 23 [MIM: 609285]",
    "omimEntry": "190990",
    "inheritance": "AD"
  },
  {
    "gene": "TPM3",
    "phenotype": "Congenital myopathy 4A, autosomal dominant [MIM: 255310]; Congenital myopathy 4B, autosomal recessive [MIM: 609284]",
    "omimEntry": "191030",
    "inheritance": "AD, AR"
  },
  {
    "gene": "TPP1",
    "phenotype": "Ceroid lipofuscinosis, neuronal, 2 [MIM: 204500]; Spinocerebellar ataxia, autosomal recessive 7 [MIM: 609270]",
    "omimEntry": "607998",
    "inheritance": "AR"
  },
  {
    "gene": "TRAPPC11",
    "phenotype": "Muscular dystrophy, limb-girdle, autosomal recessive 18 [MIM: 615356]",
    "omimEntry": "614138",
    "inheritance": "AR"
  },
  {
    "gene": "TRAPPC12",
    "phenotype": "Encephalopathy, progressive, early-onset, with brain atrophy and spasticity [MIM: 617669]",
    "omimEntry": "614139",
    "inheritance": "AR"
  },
  {
    "gene": "TRAPPC4",
    "phenotype": "Neurodevelopmental disorder with epilepsy, spasticity, and brain atrophy [MIM: 618741]",
    "omimEntry": "610971",
    "inheritance": "AR"
  },
  {
    "gene": "TRDN",
    "phenotype": "Cardiac arrhythmia syndrome, with or without skeletal muscle weakness [MIM: 615441]",
    "omimEntry": "603283",
    "inheritance": "AR"
  },
  {
    "gene": "TREM2",
    "phenotype": "{Alzheimer disease 17, susceptibility to} [MIM: 615080]; Polycystic lipomembranous osteodysplasia with sclerosing leukoencephalopathy 2 [MIM: 618193]",
    "omimEntry": "605086",
    "inheritance": "AR"
  },
  {
    "gene": "TREX1",
    "phenotype": "{Systemic lupus erythematosus, susceptibility to} [MIM: 152700]; Aicardi-Goutieres syndrome 1, dominant and recessive [MIM: 225750]; Chilblain lupus [MIM: 610448]; Vasculopathy, retinal, with cerebral leukoencephalopathy and systemic manifestations [MIM: 192315]",
    "omimEntry": "606609",
    "inheritance": "AD, AR"
  },
  {
    "gene": "TRIM32",
    "phenotype": "Bardet-Biedl syndrome 11 [MIM: 615988]; Muscular dystrophy, limb-girdle, autosomal recessive 8 [MIM: 254110]",
    "omimEntry": "602290",
    "inheritance": "AR"
  },
  {
    "gene": "TRIP4",
    "phenotype": "Muscular dystrophy, congenital, Davignon-Chauveau type [MIM: 617066]; Spinal muscular atrophy with congenital bone fractures 1 [MIM: 616866]",
    "omimEntry": "604501",
    "inheritance": "AR"
  },
  {
    "gene": "TRMT5",
    "phenotype": "Peripheral neuropathy with variable spasticity, exercise intolerance, and developmental delay [616539]",
    "omimEntry": "611023",
    "inheritance": "AR"
  },
  {
    "gene": "TRNT1",
    "phenotype": "Retinitis pigmentosa and erythrocytic microcytosis [MIM: 616959]; Sideroblastic anemia with B-cell immunodeficiency, periodic fevers, and developmental delay [MIM: 616084]",
    "omimEntry": "612907",
    "inheritance": "AR"
  },
  {
    "gene": "TRPC3",
    "phenotype": "Spinocerebellar ataxia 41  [MIM: 616410]",
    "omimEntry": "602345",
    "inheritance": "AD"
  },
  {
    "gene": "TRPM7",
    "phenotype": "{Amyotrophic lateral sclerosis-parkinsonism/dementia complex, susceptibility to} [MIM: 105500]",
    "omimEntry": "605692",
    "inheritance": "AD"
  },
  {
    "gene": "TRPV4",
    "phenotype": "Avascular necrosis of femoral head, primary, 2 [MIM: 617383]; [Sodium serum level QTL 1] [MIM: 613508]; Brachyolmia type 3 [MIM: 113500]; Digital arthropathy-brachydactyly, familial [MIM: 606835]; Hereditary motor and sensory neuropathy, type Iic [MIM: 606071]; Metatropic dysplasia [MIM: 156530]; Neuronopathy, distal hereditary motor, autosomal dominant 8 [MIM: 600175]; Parastremmatic dwarfism [MIM: 168400]; Scapuloperoneal spinal muscular atrophy [MIM: 181405]; SED, Maroteaux type [MIM: 184095]; Spondylometaphyseal dysplasia, Kozlowski type [MIM: 184252]",
    "omimEntry": "605427",
    "inheritance": "AD"
  },
  {
    "gene": "TSEN15",
    "phenotype": "Pontocerebellar hypoplasia, type 2F [MIM: 617026]",
    "omimEntry": "608756",
    "inheritance": "AR"
  },
  {
    "gene": "TSEN2",
    "phenotype": "Pontocerebellar hypoplasia type 2B [MIM: 612389]",
    "omimEntry": "608753",
    "inheritance": "AR"
  },
  {
    "gene": "TSEN54",
    "phenotype": "Pontocerebellar hypoplasia type 5  [MIM: 610204]; Pontocerebellar hypoplasia type 2A [MIM: 277470]; Pontocerebellar hypoplasia type 4 [MIM: 225753]",
    "omimEntry": "608755",
    "inheritance": "AR"
  },
  {
    "gene": "TSFM",
    "phenotype": "Combined oxidative phosphorylation deficiency 3 [MIM: 610505]",
    "omimEntry": "604723",
    "inheritance": "AR"
  },
  {
    "gene": "TTBK2",
    "phenotype": "Spinocerebellar ataxia 11 [MIM: 604432]",
    "omimEntry": "611695",
    "inheritance": "AD"
  },
  {
    "gene": "TTC19",
    "phenotype": "Mitochondrial complex III deficiency, nuclear type 2 [MIM: 615157]",
    "omimEntry": "613814",
    "inheritance": "AR"
  },
  {
    "gene": "TTC21B",
    "phenotype": "Nephronophthisis 12 [MIM: 613820]; Short-rib thoracic dysplasia 4 with or without polydactyly [MIM: 613819]",
    "omimEntry": "612014",
    "inheritance": "AD, AR"
  },
  {
    "gene": "TTN",
    "phenotype": "Cardiomyopathy, familial hypertrophic, 9 [MIM: 613765]; Cardiomyopathy, dilated, 1G [MIM: 604145]; Congenital myopathy 5 with cardiomyopathy [MIM: 611705]; Muscular dystrophy, limb-girdle, autosomal recessive 10 [MIM: 608807]; Myopathy myofibrillar, 9, with early respiratory failure [MIM: 603689]; Tibial muscular dystrophy, tardive [MIM: 600334]",
    "omimEntry": "188840",
    "inheritance": "AD, AR"
  },
  {
    "gene": "TTPA",
    "phenotype": "Ataxia with isolated vitamin E deficiency [MIM: 277460]",
    "omimEntry": "600415",
    "inheritance": "AR"
  },
  {
    "gene": "TTR",
    "phenotype": "[Dystransthyretinemic hyperthyroxinemia] [MIM: 145680]; Amyloidosis, hereditary systemic 1 [MIM: 105210]; Carpal tunnel syndrome, familial [MIM: 115430]",
    "omimEntry": "176300",
    "inheritance": "AD"
  },
  {
    "gene": "TUBA4A",
    "phenotype": "Congenital myopathy 26 [MIM: 621225]; Frontotemporal dementia and/or amyotrophic lateral sclerosis 9 [MIM: 616208]; Oocyte/zygote/embryo maturation arrest 23 [MIM: 621231]; Spastic ataxia 11, autosomal dominant [MIM: 621226]",
    "omimEntry": "191110",
    "inheritance": "AD, AR"
  },
  {
    "gene": "TUBB",
    "phenotype": "Cortical dysplasia, complex, with other brain malformations 6 [MIM:615771]; Symmetric circumferential skin creases, congenital, 1 [MIM: 156610]",
    "omimEntry": "191130",
    "inheritance": "AD"
  },
  {
    "gene": "TUBB3",
    "phenotype": "Cortical dysplasia, complex, with other brain malformations 1 [MIM: 614039]; Fibrosis of extraocular muscles, congenital, 3A [MIM: 600638]",
    "omimEntry": "602661",
    "inheritance": "AD"
  },
  {
    "gene": "TUBB4A",
    "phenotype": "Dystonia 4, torsion, autosomal dominant [MIM: 128101]; Leukodystrophy, hypomyelinating, 6 [MIM: 612438]",
    "omimEntry": "602662",
    "inheritance": "AD"
  },
  {
    "gene": "TUBG1",
    "phenotype": "Cortical dysplasia, complex, with other brain malformations 4 [MIM: 615412]",
    "omimEntry": "191135",
    "inheritance": "AD"
  },
  {
    "gene": "TWNK",
    "phenotype": "Mitochondrial DNA depletion syndrome 7 (hepatocerebral type) [MIM: 271245]; Perrault syndrome 5 [MIM: 616138]; Progressive external ophthalmoplegia with mitochondrial DNA deletions, autosomal dominant 3 [MIM: 609286]",
    "omimEntry": "606075",
    "inheritance": "AD, AR"
  },
  {
    "gene": "TXN2",
    "phenotype": "Combined oxidative phosphorylation deficiency 29 [MIM: 616811]",
    "omimEntry": "609063",
    "inheritance": "AR"
  },
  {
    "gene": "TYMP",
    "phenotype": "Mitochondrial DNA depletion syndrome 1 (MNGIE type) [MIM: 603041]",
    "omimEntry": "131222",
    "inheritance": "AR"
  },
  {
    "gene": "TYROBP",
    "phenotype": "Polycystic lipomembranous osteodysplasia with sclerosing leukoencephalopathy 1 [MIM: 221770]",
    "omimEntry": "604142",
    "inheritance": "AR"
  },
  {
    "gene": "UBA1",
    "phenotype": "Spinal muscular atrophy, X-linked 2, infantile [MIM: 301830]; VEXAS syndrome, somatic [MIM: 301054]",
    "omimEntry": "314370",
    "inheritance": "XLR"
  },
  {
    "gene": "UBA5",
    "phenotype": "Spinocerebellar ataxia, autosomal recessive 24[ MIM: 617133]; Developmental and epileptic encephalopathy 44 [MIM: 617132]",
    "omimEntry": "610552",
    "inheritance": "AR"
  },
  {
    "gene": "UBE3A",
    "phenotype": "Angelman syndrome [MIM: 105830]",
    "omimEntry": "601623",
    "inheritance": "AD"
  },
  {
    "gene": "UBQLN2",
    "phenotype": "Amyotrophic lateral sclerosis 15, with or without frontotemporal dementia [MIM: 300857]",
    "omimEntry": "300264",
    "inheritance": "XLD"
  },
  {
    "gene": "UBTF",
    "phenotype": "Neurodegeneration, childhood-onset, with brain atrophy [MIM: 617672]",
    "omimEntry": "600673",
    "inheritance": "AD"
  },
  {
    "gene": "UCHL1",
    "phenotype": "{Parkinson disease 5, susceptibility to} [MIM: 613643]; Spastic paraplegia 79A, autosomal dominant [MIM: 620221]; Spastic paraplegia 79B, autosomal recessive [MIM: 615491]",
    "omimEntry": "191342",
    "inheritance": "AD, AR"
  },
  {
    "gene": "UFC1",
    "phenotype": "Neurodevelopmental disorder with spasticity and poor growth [MIM: 618076]",
    "omimEntry": "610554",
    "inheritance": "AR"
  },
  {
    "gene": "UNC45B",
    "phenotype": "Cataract 43 [MIM: 616279]; Myofibrillar myopathy 11 [MIM: 619178]",
    "omimEntry": "611220",
    "inheritance": "AD, AR"
  },
  {
    "gene": "UNC80",
    "phenotype": "Hypotonia, infantile, with psychomotor retardation and characteristic facies 2 [MIM: 616801]",
    "omimEntry": "612636",
    "inheritance": "AR"
  },
  {
    "gene": "UPB1",
    "phenotype": "Beta-ureidopropionase deficiency [MIM: 613161]",
    "omimEntry": "606673",
    "inheritance": "AR"
  },
  {
    "gene": "UQCC2",
    "phenotype": "Mitochondrial complex III deficiency, nuclear type 7 [MIM: 615824]",
    "omimEntry": "614461",
    "inheritance": "AR"
  },
  {
    "gene": "UQCC3",
    "phenotype": "Mitochondrial complex III deficiency, nuclear type 9 [MIM: 616111]",
    "omimEntry": "616097",
    "inheritance": "AR"
  },
  {
    "gene": "UQCRB",
    "phenotype": "Mitochondrial complex III deficiency, nuclear type 3 [MIM: 615158]",
    "omimEntry": "191330",
    "inheritance": "AR"
  },
  {
    "gene": "UQCRC2",
    "phenotype": "Mitochondrial complex III deficiency, nuclear type 5 [MIM: 615160]",
    "omimEntry": "191329",
    "inheritance": "AR"
  },
  {
    "gene": "UQCRFS1",
    "phenotype": "Mitochondrial complex III deficiency, nuclear type 10 [MIM: 618775]",
    "omimEntry": "191327",
    "inheritance": "AR"
  },
  {
    "gene": "UQCRQ",
    "phenotype": "Mitochondrial complex III deficiency, nuclear type 4 [MIM: 615159]",
    "omimEntry": "612080",
    "inheritance": "AR"
  },
  {
    "gene": "UROC1",
    "phenotype": "Urocanase deficiency [MIM: 276880]",
    "omimEntry": "613012",
    "inheritance": "AR"
  },
  {
    "gene": "USP18",
    "phenotype": "Pseudo-TORCH syndrome 2 [MIM: 617397]",
    "omimEntry": "607057",
    "inheritance": "AR"
  },
  {
    "gene": "VAC14",
    "phenotype": "Striatonigral degeneration, childhood-onset [MIM: 617054]",
    "omimEntry": "604632",
    "inheritance": "AR"
  },
  {
    "gene": "VAMP1",
    "phenotype": "Myasthenic syndrome, congenital, 25 [MIM: 618323]; Spastic ataxia 1, autosomal dominant [MIM: 108600]",
    "omimEntry": "185880",
    "inheritance": "AD, AR"
  },
  {
    "gene": "VAPB",
    "phenotype": "Amyotrophic lateral sclerosis 8 [MIM: 608627]; Spinal muscular atrophy, late-onset, Finkel type [MIM: 182980]",
    "omimEntry": "605704",
    "inheritance": "AD"
  },
  {
    "gene": "VARS2",
    "phenotype": "Combined oxidative phosphorylation deficiency 20 [MIM: 615917]",
    "omimEntry": "612802",
    "inheritance": "AR"
  },
  {
    "gene": "VCP",
    "phenotype": "Charcot-Marie-Tooth disease, type 2Y [MIM: 616687]; Frontotemporal dementia and/or amyotrophic lateral sclerosis 6 [MIM: 613954]; Inclusion body myopathy with early-onset Paget disease and frontotemporal dementia 1 [MIM: 167320]",
    "omimEntry": "601023",
    "inheritance": "AD"
  },
  {
    "gene": "VLDLR",
    "phenotype": "Cerebellar hypoplasia, impaired intellectual development, and dysequilibrium syndrome 1 [MIM: 224050]",
    "omimEntry": "192977",
    "inheritance": "AR"
  },
  {
    "gene": "VMA21",
    "phenotype": "Myopathy, X-linked, with excessive autophagy [MIM: 310440]",
    "omimEntry": "300913",
    "inheritance": "XLR"
  },
  {
    "gene": "VPS11",
    "phenotype": "Dystonia 32 [MIM: 619637]; Leukodystrophy, hypomyelinating, 12 [MIM: 616683]",
    "omimEntry": "608549",
    "inheritance": "AR"
  },
  {
    "gene": "VPS13A",
    "phenotype": "Choreoacanthocytosis [MIM: 200150]",
    "omimEntry": "605978",
    "inheritance": "AR"
  },
  {
    "gene": "VPS13C",
    "phenotype": "Parkinson disease 23, autosomal recessive, early onset [MIM: 616840]",
    "omimEntry": "608879",
    "inheritance": "AR"
  },
  {
    "gene": "VPS13D",
    "phenotype": "Spinocerebellar ataxia, autosomal recessive 4 [MIM: 607317]",
    "omimEntry": "608877",
    "inheritance": "AR"
  },
  {
    "gene": "VPS16",
    "phenotype": "Dystonia 30 [MIM: 619291]",
    "omimEntry": "608550",
    "inheritance": "AD"
  },
  {
    "gene": "VPS35",
    "phenotype": "{Parkinson disease 17} [MIM: 614203]",
    "omimEntry": "601501",
    "inheritance": "AD"
  },
  {
    "gene": "VPS37A",
    "phenotype": "Spastic paraplegia 53, autosomal recessive [MIM: 614898]",
    "omimEntry": "609927",
    "inheritance": "AR"
  },
  {
    "gene": "VPS51",
    "phenotype": "Pontocerebellar hypoplasia, type 13 [MIM: 618606]",
    "omimEntry": "615738",
    "inheritance": "AR"
  },
  {
    "gene": "VPS53",
    "phenotype": "Pontocerebellar hypoplasia, type 2E [MIM: 615851]",
    "omimEntry": "615850",
    "inheritance": "AR"
  },
  {
    "gene": "VRK1",
    "phenotype": "Neuronopathy, distal hereditary motor, autosomal recessive 10 [MIM: 620542]; Pontocerebellar hypoplasia type 1A [MIM: 607596]",
    "omimEntry": "602168",
    "inheritance": "AR"
  },
  {
    "gene": "VWA1",
    "phenotype": "Neuronopathy, distal hereditary motor, autosomal recessive 7 [MIM: 619216]",
    "omimEntry": "611901",
    "inheritance": "AR"
  },
  {
    "gene": "VWA3B",
    "phenotype": "Spinocerebellar ataxia, autosomal recessive 22 [MIM: 616948]",
    "omimEntry": "614884",
    "inheritance": "AR"
  },
  {
    "gene": "WARS2",
    "phenotype": "Neurodevelopmental disorder, miochondrial, with abnormal movements and lactic acidosis, with or without seizures [MIM: 617710]; Parkinsonism-dystonia 3, childhood-onset [MIM: 619738]",
    "omimEntry": "604733",
    "inheritance": "AR"
  },
  {
    "gene": "WASHC5",
    "phenotype": "Ritscher-Schinzel syndrome 1 [MIM: 220210]; Spastic paraplegia 8, autosomal dominant [MIM: 603563]",
    "omimEntry": "610657",
    "inheritance": "AD, AR"
  },
  {
    "gene": "WDR26",
    "phenotype": "Skraban-Deardorff syndrome [MIM: 617616]",
    "omimEntry": "617424",
    "inheritance": "AD"
  },
  {
    "gene": "WDR45",
    "phenotype": "Neurodegeneration with brain iron accumulation 5 [MIM: 300894]",
    "omimEntry": "300526",
    "inheritance": "XLD"
  },
  {
    "gene": "WDR62",
    "phenotype": "Microcephaly 2, primary, autosomal recessive, with or without cortical malformations [MIM: 604317]",
    "omimEntry": "613583",
    "inheritance": "AR"
  },
  {
    "gene": "WDR73",
    "phenotype": "Galloway-Mowat syndrome 1 [MIM: 251300]",
    "omimEntry": "616144",
    "inheritance": "AR"
  },
  {
    "gene": "WDR81",
    "phenotype": "Cerebellar ataxia, impaired intellectual development, and dysquilibrium syndrome 2 [MIM: 610185]; Hydrocephalus, congenital, 3, with brain anomalies [MIM: 617967]",
    "omimEntry": "614218",
    "inheritance": "AR"
  },
  {
    "gene": "WFS1",
    "phenotype": "Cataract 41 [MIM: 116400]; {Diabetes mellitus, noninsulin-dependent, association with} [MIM: 125853]; Deafness, autosomal dominant 6/14/38 [MIM: 600965]; Wolfram syndrome 1 [MIM: 222300]; Wolfram-like syndrome, autosomal dominant [MIM: 614296]",
    "omimEntry": "606201",
    "inheritance": "AD, AR"
  },
  {
    "gene": "WNK1",
    "phenotype": "Neuropathy, hereditary sensory and autonomic, type II [MIM: 201300]; Pseudohypoaldosteronism, type IIC [MIM: 614492]",
    "omimEntry": "605232",
    "inheritance": "AD, AR"
  },
  {
    "gene": "WWOX",
    "phenotype": "Developmental and epileptic encephalopathy 28 [MIM: 616211]; Esophageal squamous cell carcinoma, somatic [MIM: 133233]; Spinocerebellar ataxia, autosomal recessive 12 [MIM: 614322]",
    "omimEntry": "605131",
    "inheritance": "AR"
  },
  {
    "gene": "XK",
    "phenotype": "McLeod syndrome [MIM: 300842]",
    "omimEntry": "314850",
    "inheritance": "XL"
  },
  {
    "gene": "XPA",
    "phenotype": "Xeroderma pigmentosum, group A [MIM: 278700]",
    "omimEntry": "611153",
    "inheritance": "AR"
  },
  {
    "gene": "XPNPEP3",
    "phenotype": "Nephronophthisis-like nephropathy 1 [MIM: 613159]",
    "omimEntry": "613553",
    "inheritance": "AR"
  },
  {
    "gene": "XPR1",
    "phenotype": "Basal ganglia calcification, idiopathic, 6 [MIM: 616413]",
    "omimEntry": "605237",
    "inheritance": "AD"
  },
  {
    "gene": "XRCC1",
    "phenotype": "Spinocerebellar ataxia, autosomal recessive 26 [MIM: 617633]",
    "omimEntry": "194360",
    "inheritance": "AR"
  },
  {
    "gene": "XRCC4",
    "phenotype": "Short stature, microcephaly, and endocrine dysfunction [MIM: 616541]",
    "omimEntry": "194363",
    "inheritance": "AR"
  },
  {
    "gene": "YARS2",
    "phenotype": "Myopathy, lactic acidosis, and sideroblastic anemia 2 [MIM: 613561]",
    "omimEntry": "610957",
    "inheritance": "AR"
  },
  {
    "gene": "YME1L1",
    "phenotype": "Optic atrophy 11 [MIM: 617302]",
    "omimEntry": "607472",
    "inheritance": "AR"
  },
  {
    "gene": "ZC4H2",
    "phenotype": "Wieacker-Wolff syndrome [MIM: 314580]; Wieacker-Wolff syndrome, female-restricted [MIM: 301041]",
    "omimEntry": "300897",
    "inheritance": "XLR, XLD"
  },
  {
    "gene": "ZFHX3",
    "phenotype": "Spinocerebellar ataxia 4 [MIM: 600223]",
    "omimEntry": "104155",
    "inheritance": "AD"
  },
  {
    "gene": "ZFYVE26",
    "phenotype": "Spastic paraplegia 15, autosomal recessive [MIM: 270700]",
    "omimEntry": "612012",
    "inheritance": "AR"
  },
  {
    "gene": "ZNF142",
    "phenotype": "Neurodevelopmental disorder with impaired speech and hyperkinetic movements [MIM: 618425]",
    "omimEntry": "604083",
    "inheritance": "AR"
  },
  {
    "gene": "ZNF335",
    "phenotype": "Microcephaly 10, primary, autosomal recessive [MIM: 615095]",
    "omimEntry": "610827",
    "inheritance": "AR"
  },
  {
    "gene": "ZNF423",
    "phenotype": "Joubert syndrome 19 [MIM: 614844]; Nephronophthisis 14 [MIM: 614844]",
    "omimEntry": "604557",
    "inheritance": "AD, AR"
  },
  {
    "gene": "ZNHIT3",
    "phenotype": "PEHO syndrome [MIM: 260565]",
    "omimEntry": "604500",
    "inheritance": "AR"
  }
];

export default comprehensiveMovementDisordersGeneTable;



// WEBPACK FOOTER //
// ./src/utils/comprehensiveMovementDisordersGeneTable.js